//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IApplicantClient {
    createApplicant(dto: OneIdUserDto): Observable<OneIdUserDto>;
    updateApplicant(dto: ApplicantDetailsDto): Observable<FileResponse | null>;
    update(request: ApplicantProfileDto): Observable<FileResponse | null>;
    getApplicant(pinfl: string | undefined): Observable<ApplicantDetailsDto>;
    profile(): Observable<ApplicantProfileDto>;
    refreshAndUpdateApplicantDetails(dto: ApplicantDetailsDto | undefined, mip: MIPIntegration | undefined): Observable<ApplicantDetailsDto>;
    getPdf(fileName: string): Observable<FileResponse | null>;
    getPhoto(filePath: string | undefined): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class ApplicantClient implements IApplicantClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    createApplicant(dto: OneIdUserDto): Observable<OneIdUserDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Applicant/CreateApplicant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateApplicant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateApplicant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OneIdUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OneIdUserDto>;
        }));
    }

    protected processCreateApplicant(response: HttpResponseBase): Observable<OneIdUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = OneIdUserDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateApplicant(dto: ApplicantDetailsDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PiimaJob/Applicant/UpdateApplicant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApplicant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApplicant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdateApplicant(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(request: ApplicantProfileDto): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PiimaJob/Applicant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicant(pinfl: string | undefined): Observable<ApplicantDetailsDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Applicant/GetApplicant?";
        if (pinfl === null)
            throw new Error("The parameter 'pinfl' cannot be null.");
        else if (pinfl !== undefined)
            url_ += "pinfl=" + encodeURIComponent("" + pinfl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicantDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicantDetailsDto>;
        }));
    }

    protected processGetApplicant(response: HttpResponseBase): Observable<ApplicantDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    profile(): Observable<ApplicantProfileDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Applicant/Profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicantProfileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicantProfileDto>;
        }));
    }

    protected processProfile(response: HttpResponseBase): Observable<ApplicantProfileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantProfileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshAndUpdateApplicantDetails(dto: ApplicantDetailsDto | undefined, mip: MIPIntegration | undefined): Observable<ApplicantDetailsDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Applicant/RefreshAndUpdateApplicantDetails?";
        if (mip === null)
            throw new Error("The parameter 'mip' cannot be null.");
        else if (mip !== undefined)
            url_ += "mip=" + encodeURIComponent("" + mip) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshAndUpdateApplicantDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshAndUpdateApplicantDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicantDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicantDetailsDto>;
        }));
    }

    protected processRefreshAndUpdateApplicantDetails(response: HttpResponseBase): Observable<ApplicantDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicantDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPdf(fileName: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PiimaJob/Applicant/GetPdf/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetPdf(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPhoto(filePath: string | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PiimaJob/Applicant/GetPhoto?";
        if (filePath === null)
            throw new Error("The parameter 'filePath' cannot be null.");
        else if (filePath !== undefined)
            url_ += "filePath=" + encodeURIComponent("" + filePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPhoto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPhoto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetPhoto(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IArchivesClient {
    getArchiveApplicationsAsNoHRMExportedById(id: number | undefined): Observable<JobApplicationDetailsDto>;
    getArchiveApplicationsAsNoHRMExported(metaData: TableMetaData, isHrmExported: boolean | undefined): Observable<QueryResultOfJobApplicationDto>;
    getArchiveApplicantsCountAsInstitutions(isExportedHrm: boolean | undefined): Observable<ArchiveInfoCountAsInstitutionDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ArchivesClient implements IArchivesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getArchiveApplicationsAsNoHRMExportedById(id: number | undefined): Observable<JobApplicationDetailsDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Archives/GetArchiveApplicationsAsNoHRMExportedById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArchiveApplicationsAsNoHRMExportedById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArchiveApplicationsAsNoHRMExportedById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobApplicationDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobApplicationDetailsDto>;
        }));
    }

    protected processGetArchiveApplicationsAsNoHRMExportedById(response: HttpResponseBase): Observable<JobApplicationDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobApplicationDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getArchiveApplicationsAsNoHRMExported(metaData: TableMetaData, isHrmExported: boolean | undefined): Observable<QueryResultOfJobApplicationDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Archives/GetArchiveApplicationsAsNoHRMExported?";
        if (isHrmExported === null)
            throw new Error("The parameter 'isHrmExported' cannot be null.");
        else if (isHrmExported !== undefined)
            url_ += "IsHrmExported=" + encodeURIComponent("" + isHrmExported) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metaData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArchiveApplicationsAsNoHRMExported(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArchiveApplicationsAsNoHRMExported(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryResultOfJobApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryResultOfJobApplicationDto>;
        }));
    }

    protected processGetArchiveApplicationsAsNoHRMExported(response: HttpResponseBase): Observable<QueryResultOfJobApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfJobApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getArchiveApplicantsCountAsInstitutions(isExportedHrm: boolean | undefined): Observable<ArchiveInfoCountAsInstitutionDto[]> {
        let url_ = this.baseUrl + "/api/PiimaJob/Archives/GetArchiveApplicantsCountAsInstitutions?";
        if (isExportedHrm === null)
            throw new Error("The parameter 'isExportedHrm' cannot be null.");
        else if (isExportedHrm !== undefined)
            url_ += "IsExportedHrm=" + encodeURIComponent("" + isExportedHrm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArchiveApplicantsCountAsInstitutions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArchiveApplicantsCountAsInstitutions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArchiveInfoCountAsInstitutionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArchiveInfoCountAsInstitutionDto[]>;
        }));
    }

    protected processGetArchiveApplicantsCountAsInstitutions(response: HttpResponseBase): Observable<ArchiveInfoCountAsInstitutionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ArchiveInfoCountAsInstitutionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IJobApplicationClient {
    uploadApplicantFile(): Observable<string>;
    getApplicationCountByStatus(): Observable<{ [key: string]: number; }>;
    getApplicationCountByStaff(isStep2: boolean | undefined): Observable<{ [key: string]: number; }>;
    getSelectedApplicationCountByStaff(): Observable<{ [key: string]: number; }>;
    getApplicationCountByStep(spCategoryOfPositionId: number | null | undefined): Observable<{ [key: string]: number; }>;
    getJobApplications(metaData: TableMetaData): Observable<QueryResultOfJobApplicationDto>;
    getJobApplicationsInExcel(status: number): Observable<FileResponse | null>;
    getApprovedApplications(metaData: TableMetaData): Observable<QueryResultOfJobApplicationApprovedItemDto>;
    getResultsApplications(metaData: TableMetaData): Observable<QueryResultOfJobApplicationApprovedItemDto>;
    getSelectedApplicationsByStage(request: SelectedApplicationsStageRequestDto): Observable<QueryResultOfJobApplicationApprovedItemDto>;
    getReservedApplications(metaData: TableMetaData): Observable<QueryResultOfJobApplicationDto>;
    createJobApplication(dto: JobApplicationDetailsDto): Observable<JobApplicationDetailsDto>;
    ensureDraftApplication(vacancyId: number | undefined): Observable<number>;
    submitApplication(applicationId: number | undefined): Observable<number>;
    update(dto: JobApplicationDetailsDto): Observable<JobApplicationDetailsDto>;
    myApplications(): Observable<JobApplicationMyDto[]>;
    myApplicationsPaged(metaData: TableMetaData): Observable<QueryResultOfJobApplicationMyDto>;
    getJobApplicationsByApplicantId(applicationId: number | undefined): Observable<JobApplicationDto[]>;
    getJobApplicationLogsById(jobApplicationId: number): Observable<JobApplicationLogDto[]>;
    applicationOpened(applicationId: number): Observable<number>;
    applicationApproved(applicationId: number): Observable<number>;
    applicationCorrecting(applicationId: number, details: string): Observable<number>;
    applicationCorrected(dto: JobApplicationCorrectedDto): Observable<number>;
    applicationRejecting(applicationId: number, reason: string): Observable<number>;
    applicationSentToReservePool(applicationId: number): Observable<number>;
    setSelectedApplicationStatus(applicationIds: number[], status: SelectedApplicationStatus | undefined, comment: string | null | undefined): Observable<number>;
    setFirstStageComment(applicationId: number, comment: string | undefined): Observable<number>;
    setFirstStageStatus(applicationIds: number[], status: FirstStageStatus | undefined, comment: string | null | undefined): Observable<number>;
    uploadFinalStatusFile(applicationId: number | undefined, file: FileParameter | null | undefined): Observable<string | null>;
    downloadFinalStatusFile(applicationId: number | undefined): Observable<FileResponse | null>;
    getJobApplicationDetailsById(id: number): Observable<JobApplicationDetailsDto>;
    downloadJobApplicationFile(id: string): Observable<FileResponse | null>;
    deactivateFile(id: string): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class JobApplicationClient implements IJobApplicationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    uploadApplicantFile(): Observable<string> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/UploadApplicantFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadApplicantFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadApplicantFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUploadApplicantFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationCountByStatus(): Observable<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/GetApplicationCountByStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationCountByStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationCountByStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: number; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: number; }>;
        }));
    }

    protected processGetApplicationCountByStatus(response: HttpResponseBase): Observable<{ [key: string]: number; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationCountByStaff(isStep2: boolean | undefined): Observable<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/GetApplicationCountByStaff?";
        if (isStep2 === null)
            throw new Error("The parameter 'isStep2' cannot be null.");
        else if (isStep2 !== undefined)
            url_ += "isStep2=" + encodeURIComponent("" + isStep2) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationCountByStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationCountByStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: number; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: number; }>;
        }));
    }

    protected processGetApplicationCountByStaff(response: HttpResponseBase): Observable<{ [key: string]: number; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSelectedApplicationCountByStaff(): Observable<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/GetSelectedApplicationCountByStaff";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSelectedApplicationCountByStaff(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSelectedApplicationCountByStaff(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: number; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: number; }>;
        }));
    }

    protected processGetSelectedApplicationCountByStaff(response: HttpResponseBase): Observable<{ [key: string]: number; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationCountByStep(spCategoryOfPositionId: number | null | undefined): Observable<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/GetApplicationCountByStep?";
        if (spCategoryOfPositionId !== undefined && spCategoryOfPositionId !== null)
            url_ += "spCategoryOfPositionId=" + encodeURIComponent("" + spCategoryOfPositionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationCountByStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationCountByStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: number; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: number; }>;
        }));
    }

    protected processGetApplicationCountByStep(response: HttpResponseBase): Observable<{ [key: string]: number; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getJobApplications(metaData: TableMetaData): Observable<QueryResultOfJobApplicationDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/GetJobApplications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metaData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryResultOfJobApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryResultOfJobApplicationDto>;
        }));
    }

    protected processGetJobApplications(response: HttpResponseBase): Observable<QueryResultOfJobApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfJobApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getJobApplicationsInExcel(status: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/GetJobApplicationsInExcel/{status}";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobApplicationsInExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobApplicationsInExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetJobApplicationsInExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApprovedApplications(metaData: TableMetaData): Observable<QueryResultOfJobApplicationApprovedItemDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/GetApprovedApplications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metaData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryResultOfJobApplicationApprovedItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryResultOfJobApplicationApprovedItemDto>;
        }));
    }

    protected processGetApprovedApplications(response: HttpResponseBase): Observable<QueryResultOfJobApplicationApprovedItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfJobApplicationApprovedItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getResultsApplications(metaData: TableMetaData): Observable<QueryResultOfJobApplicationApprovedItemDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/GetResultsApplications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metaData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResultsApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResultsApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryResultOfJobApplicationApprovedItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryResultOfJobApplicationApprovedItemDto>;
        }));
    }

    protected processGetResultsApplications(response: HttpResponseBase): Observable<QueryResultOfJobApplicationApprovedItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfJobApplicationApprovedItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSelectedApplicationsByStage(request: SelectedApplicationsStageRequestDto): Observable<QueryResultOfJobApplicationApprovedItemDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/GetSelectedApplicationsByStage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSelectedApplicationsByStage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSelectedApplicationsByStage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryResultOfJobApplicationApprovedItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryResultOfJobApplicationApprovedItemDto>;
        }));
    }

    protected processGetSelectedApplicationsByStage(response: HttpResponseBase): Observable<QueryResultOfJobApplicationApprovedItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfJobApplicationApprovedItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getReservedApplications(metaData: TableMetaData): Observable<QueryResultOfJobApplicationDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/GetReservedApplications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metaData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservedApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservedApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryResultOfJobApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryResultOfJobApplicationDto>;
        }));
    }

    protected processGetReservedApplications(response: HttpResponseBase): Observable<QueryResultOfJobApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfJobApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createJobApplication(dto: JobApplicationDetailsDto): Observable<JobApplicationDetailsDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/CreateJobApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateJobApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateJobApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobApplicationDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobApplicationDetailsDto>;
        }));
    }

    protected processCreateJobApplication(response: HttpResponseBase): Observable<JobApplicationDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = JobApplicationDetailsDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    ensureDraftApplication(vacancyId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/EnsureDraftApplication?";
        if (vacancyId === null)
            throw new Error("The parameter 'vacancyId' cannot be null.");
        else if (vacancyId !== undefined)
            url_ += "vacancyId=" + encodeURIComponent("" + vacancyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnsureDraftApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnsureDraftApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processEnsureDraftApplication(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    submitApplication(applicationId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/SubmitApplication?";
        if (applicationId === null)
            throw new Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSubmitApplication(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(dto: JobApplicationDetailsDto): Observable<JobApplicationDetailsDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobApplicationDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobApplicationDetailsDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<JobApplicationDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobApplicationDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    myApplications(): Observable<JobApplicationMyDto[]> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/MyApplications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMyApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMyApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobApplicationMyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobApplicationMyDto[]>;
        }));
    }

    protected processMyApplications(response: HttpResponseBase): Observable<JobApplicationMyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobApplicationMyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    myApplicationsPaged(metaData: TableMetaData): Observable<QueryResultOfJobApplicationMyDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/MyApplicationsPaged";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metaData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMyApplicationsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMyApplicationsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryResultOfJobApplicationMyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryResultOfJobApplicationMyDto>;
        }));
    }

    protected processMyApplicationsPaged(response: HttpResponseBase): Observable<QueryResultOfJobApplicationMyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfJobApplicationMyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getJobApplicationsByApplicantId(applicationId: number | undefined): Observable<JobApplicationDto[]> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/GetJobApplicationsByApplicantId?";
        if (applicationId === null)
            throw new Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobApplicationsByApplicantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobApplicationsByApplicantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobApplicationDto[]>;
        }));
    }

    protected processGetJobApplicationsByApplicantId(response: HttpResponseBase): Observable<JobApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobApplicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getJobApplicationLogsById(jobApplicationId: number): Observable<JobApplicationLogDto[]> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/GetJobApplicationLogsById/{jobApplicationId}";
        if (jobApplicationId === undefined || jobApplicationId === null)
            throw new Error("The parameter 'jobApplicationId' must be defined.");
        url_ = url_.replace("{jobApplicationId}", encodeURIComponent("" + jobApplicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobApplicationLogsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobApplicationLogsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobApplicationLogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobApplicationLogDto[]>;
        }));
    }

    protected processGetJobApplicationLogsById(response: HttpResponseBase): Observable<JobApplicationLogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobApplicationLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applicationOpened(applicationId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/ApplicationOpened/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationOpened(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationOpened(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processApplicationOpened(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applicationApproved(applicationId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/ApplicationApproved/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationApproved(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationApproved(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processApplicationApproved(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applicationCorrecting(applicationId: number, details: string): Observable<number> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/ApplicationCorrecting/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(details);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationCorrecting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationCorrecting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processApplicationCorrecting(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applicationCorrected(dto: JobApplicationCorrectedDto): Observable<number> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/ApplicationCorrected";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationCorrected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationCorrected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processApplicationCorrected(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applicationRejecting(applicationId: number, reason: string): Observable<number> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/ApplicationRejecting/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reason);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationRejecting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationRejecting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processApplicationRejecting(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    applicationSentToReservePool(applicationId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/ApplicationSentToReservePool/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApplicationSentToReservePool(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApplicationSentToReservePool(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processApplicationSentToReservePool(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setSelectedApplicationStatus(applicationIds: number[], status: SelectedApplicationStatus | undefined, comment: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/SetSelectedApplicationStatus?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(applicationIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetSelectedApplicationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetSelectedApplicationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetSelectedApplicationStatus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setFirstStageComment(applicationId: number, comment: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/SetFirstStageComment/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFirstStageComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFirstStageComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetFirstStageComment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setFirstStageStatus(applicationIds: number[], status: FirstStageStatus | undefined, comment: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/SetFirstStageStatus?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(applicationIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFirstStageStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFirstStageStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetFirstStageStatus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    uploadFinalStatusFile(applicationId: number | undefined, file: FileParameter | null | undefined): Observable<string | null> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/UploadFinalStatusFile?";
        if (applicationId === null)
            throw new Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFinalStatusFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFinalStatusFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processUploadFinalStatusFile(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFinalStatusFile(applicationId: number | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/DownloadFinalStatusFile?";
        if (applicationId === null)
            throw new Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFinalStatusFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFinalStatusFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadFinalStatusFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getJobApplicationDetailsById(id: number): Observable<JobApplicationDetailsDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/GetJobApplicationDetailsById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobApplicationDetailsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobApplicationDetailsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobApplicationDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobApplicationDetailsDto>;
        }));
    }

    protected processGetJobApplicationDetailsById(response: HttpResponseBase): Observable<JobApplicationDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobApplicationDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadJobApplicationFile(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/DownloadJobApplicationFile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadJobApplicationFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadJobApplicationFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadJobApplicationFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactivateFile(id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/DeactivateFile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeactivateFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IJobApplicationFilesClient {
    uploadJobApplicationFile(): Observable<boolean>;
    getJobApplicationFiles(jobApplicationId: number | undefined): Observable<JobApplicationFileDto[]>;
    downloadJobApplicationFile(id: string): Observable<FileResponse | null>;
    deleteJobApplicationFile(id: string): Observable<boolean>;
    updateFileStatus(fileId: string, dto: UpdateFileStatusDto): Observable<boolean>;
    getFilesByApplicationId(applicationId: number | undefined): Observable<JobApplicationFileDto[]>;
    adminDownloadJobApplicationFile(id: string): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class JobApplicationFilesClient implements IJobApplicationFilesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    uploadJobApplicationFile(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplicationFiles/UploadJobApplicationFile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadJobApplicationFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadJobApplicationFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUploadJobApplicationFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getJobApplicationFiles(jobApplicationId: number | undefined): Observable<JobApplicationFileDto[]> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplicationFiles/GetJobApplicationFiles?";
        if (jobApplicationId === null)
            throw new Error("The parameter 'jobApplicationId' cannot be null.");
        else if (jobApplicationId !== undefined)
            url_ += "jobApplicationId=" + encodeURIComponent("" + jobApplicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobApplicationFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobApplicationFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobApplicationFileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobApplicationFileDto[]>;
        }));
    }

    protected processGetJobApplicationFiles(response: HttpResponseBase): Observable<JobApplicationFileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobApplicationFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadJobApplicationFile(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplicationFiles/DownloadJobApplicationFile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadJobApplicationFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadJobApplicationFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processDownloadJobApplicationFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteJobApplicationFile(id: string): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplicationFiles/DeleteJobApplicationFile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteJobApplicationFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteJobApplicationFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteJobApplicationFile(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateFileStatus(fileId: string, dto: UpdateFileStatusDto): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplicationFiles/UpdateFileStatus/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFileStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFileStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateFileStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFilesByApplicationId(applicationId: number | undefined): Observable<JobApplicationFileDto[]> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplicationFiles/GetFilesByApplicationId?";
        if (applicationId === null)
            throw new Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilesByApplicationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilesByApplicationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobApplicationFileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobApplicationFileDto[]>;
        }));
    }

    protected processGetFilesByApplicationId(response: HttpResponseBase): Observable<JobApplicationFileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobApplicationFileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    adminDownloadJobApplicationFile(id: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplicationFiles/AdminDownloadJobApplicationFile/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdminDownloadJobApplicationFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdminDownloadJobApplicationFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processAdminDownloadJobApplicationFile(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IJobApplicationResultClient {
    getResult(id: number): Observable<JobApplicationResultDto>;
}

@Injectable({
    providedIn: 'root'
})
export class JobApplicationResultClient implements IJobApplicationResultClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getResult(id: number): Observable<JobApplicationResultDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/JobApplication/{id}/Result";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobApplicationResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobApplicationResultDto>;
        }));
    }

    protected processGetResult(response: HttpResponseBase): Observable<JobApplicationResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JobApplicationResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMigrationClient {
    runApplicantPhotoMigration(): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class MigrationClient implements IMigrationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    runApplicantPhotoMigration(): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PiimaJob/Migration/RunApplicantPhotoMigration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRunApplicantPhotoMigration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRunApplicantPhotoMigration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processRunApplicantPhotoMigration(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISelectedJobApplicationClient {
    getJobApplications(metaData: TableMetaData): Observable<QueryResultOfJobApplicationDto>;
    getSelectedJobApplicationInExcel(step: number): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class SelectedJobApplicationClient implements ISelectedJobApplicationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getJobApplications(metaData: TableMetaData): Observable<QueryResultOfJobApplicationDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/SelectedJobApplication/GetJobApplications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metaData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJobApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJobApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryResultOfJobApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryResultOfJobApplicationDto>;
        }));
    }

    protected processGetJobApplications(response: HttpResponseBase): Observable<QueryResultOfJobApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfJobApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSelectedJobApplicationInExcel(step: number): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PiimaJob/SelectedJobApplication/GetSelectedJobApplicationInExcel/{step}";
        if (step === undefined || step === null)
            throw new Error("The parameter 'step' must be defined.");
        url_ = url_.replace("{step}", encodeURIComponent("" + step));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSelectedJobApplicationInExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSelectedJobApplicationInExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processGetSelectedJobApplicationInExcel(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IStatisticsClient {
    getOverview(filter: DashboardFilterDto | undefined): Observable<DashboardOverviewDto>;
    getApplicationsByRegion(drillDownFilter: DrillDownFilterDto): Observable<QueryResultOfDrillDownApplicationItemDto>;
    getApplicationsByVacancy(drillDownFilter: DrillDownFilterDto): Observable<QueryResultOfDrillDownApplicationItemDto>;
}

@Injectable({
    providedIn: 'root'
})
export class StatisticsClient implements IStatisticsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getOverview(filter: DashboardFilterDto | undefined): Observable<DashboardOverviewDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Statistics/GetOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardOverviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardOverviewDto>;
        }));
    }

    protected processGetOverview(response: HttpResponseBase): Observable<DashboardOverviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOverviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationsByRegion(drillDownFilter: DrillDownFilterDto): Observable<QueryResultOfDrillDownApplicationItemDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Statistics/GetApplicationsByRegion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(drillDownFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationsByRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationsByRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryResultOfDrillDownApplicationItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryResultOfDrillDownApplicationItemDto>;
        }));
    }

    protected processGetApplicationsByRegion(response: HttpResponseBase): Observable<QueryResultOfDrillDownApplicationItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfDrillDownApplicationItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApplicationsByVacancy(drillDownFilter: DrillDownFilterDto): Observable<QueryResultOfDrillDownApplicationItemDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Statistics/GetApplicationsByVacancy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(drillDownFilter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationsByVacancy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationsByVacancy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryResultOfDrillDownApplicationItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryResultOfDrillDownApplicationItemDto>;
        }));
    }

    protected processGetApplicationsByVacancy(response: HttpResponseBase): Observable<QueryResultOfDrillDownApplicationItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfDrillDownApplicationItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITelegramWebhookClient {
    post(update: Update): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class TelegramWebhookClient implements ITelegramWebhookClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    post(update: Update): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/telegram/webhook";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(update);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse | null>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITestClient {
    getSelectedItems(): Observable<SelectItem[]>;
}

@Injectable({
    providedIn: 'root'
})
export class TestClient implements ITestClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getSelectedItems(): Observable<SelectItem[]> {
        let url_ = this.baseUrl + "/api/PiimaJob/Test/GetSelectedItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSelectedItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSelectedItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectItem[]>;
        }));
    }

    protected processGetSelectedItems(response: HttpResponseBase): Observable<SelectItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVacancyClient {
    foreachRegurlarVacancyIdFromHrm(sourceVacancy: SourceVacancy | undefined): Observable<string>;
    getVacancyListByInstitutionTin(tin: string | undefined, source: SourceVacancy | undefined): Observable<VacancyHrmDto[]>;
    getTotalNumberOfHrmVacancies(source: SourceVacancy | undefined): Observable<VacancyTotal[]>;
    getTotalNumberOfPiimaVacancies(): Observable<VacancyTotal[]>;
    getVacancyListByInstitutionId(spInstitutionId: number | undefined, metaData: TableMetaData): Observable<QueryResultOfVacancyDto>;
    getVacancyList(metaData: TableMetaData): Observable<QueryResultOfVacancyDto>;
    createVacancy(model: VacancyDetailsDto): Observable<VacancyDetailsDto>;
    updateVacancy(model: VacancyDetailsDto): Observable<VacancyDetailsDto>;
    onCancelVacancy(vacancyHrmId: number | undefined, vacancyId: number | undefined): Observable<Response>;
    getVacancyById(vacancyId: number | undefined): Observable<VacancyDetailsDto>;
    getDepartments(source: SourceVacancy | undefined): Observable<SelectItem2[]>;
    getPositions(source: SourceVacancy | undefined): Observable<SelectItem2[]>;
    refreshSp(): Observable<boolean>;
    earlyClosedVacancy(id: number | undefined): Observable<Response>;
    getAllVacancies(metaData: PaginatorMetaData): Observable<QueryResultOfVacancyDto>;
    bookingVacancyFromHrm(models: JobApplicationDto[]): Observable<JobApplicationDto[]>;
    sendWinnerApplicantToEKadr(applicantId: number, vacancyId: number): Observable<CResponseOfBoolean>;
    deactiveVacation(vacancyId: number): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class VacancyClient implements IVacancyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    foreachRegurlarVacancyIdFromHrm(sourceVacancy: SourceVacancy | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/ForeachRegurlarVacancyIdFromHrm?";
        if (sourceVacancy === null)
            throw new Error("The parameter 'sourceVacancy' cannot be null.");
        else if (sourceVacancy !== undefined)
            url_ += "sourceVacancy=" + encodeURIComponent("" + sourceVacancy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForeachRegurlarVacancyIdFromHrm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForeachRegurlarVacancyIdFromHrm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processForeachRegurlarVacancyIdFromHrm(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVacancyListByInstitutionTin(tin: string | undefined, source: SourceVacancy | undefined): Observable<VacancyHrmDto[]> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/GetVacancyListByInstitutionTin?";
        if (tin === null)
            throw new Error("The parameter 'tin' cannot be null.");
        else if (tin !== undefined)
            url_ += "tin=" + encodeURIComponent("" + tin) + "&";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVacancyListByInstitutionTin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVacancyListByInstitutionTin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VacancyHrmDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VacancyHrmDto[]>;
        }));
    }

    protected processGetVacancyListByInstitutionTin(response: HttpResponseBase): Observable<VacancyHrmDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VacancyHrmDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTotalNumberOfHrmVacancies(source: SourceVacancy | undefined): Observable<VacancyTotal[]> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/GetTotalNumberOfHrmVacancies?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalNumberOfHrmVacancies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalNumberOfHrmVacancies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VacancyTotal[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VacancyTotal[]>;
        }));
    }

    protected processGetTotalNumberOfHrmVacancies(response: HttpResponseBase): Observable<VacancyTotal[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VacancyTotal.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getTotalNumberOfPiimaVacancies(): Observable<VacancyTotal[]> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/GetTotalNumberOfPiimaVacancies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalNumberOfPiimaVacancies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalNumberOfPiimaVacancies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VacancyTotal[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VacancyTotal[]>;
        }));
    }

    protected processGetTotalNumberOfPiimaVacancies(response: HttpResponseBase): Observable<VacancyTotal[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VacancyTotal.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVacancyListByInstitutionId(spInstitutionId: number | undefined, metaData: TableMetaData): Observable<QueryResultOfVacancyDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/GetVacancyListByInstitutionId?";
        if (spInstitutionId === null)
            throw new Error("The parameter 'spInstitutionId' cannot be null.");
        else if (spInstitutionId !== undefined)
            url_ += "spInstitutionId=" + encodeURIComponent("" + spInstitutionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metaData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVacancyListByInstitutionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVacancyListByInstitutionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryResultOfVacancyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryResultOfVacancyDto>;
        }));
    }

    protected processGetVacancyListByInstitutionId(response: HttpResponseBase): Observable<QueryResultOfVacancyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfVacancyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVacancyList(metaData: TableMetaData): Observable<QueryResultOfVacancyDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/GetVacancyList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metaData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVacancyList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVacancyList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryResultOfVacancyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryResultOfVacancyDto>;
        }));
    }

    protected processGetVacancyList(response: HttpResponseBase): Observable<QueryResultOfVacancyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfVacancyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createVacancy(model: VacancyDetailsDto): Observable<VacancyDetailsDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/CreateVacancy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVacancy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVacancy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VacancyDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VacancyDetailsDto>;
        }));
    }

    protected processCreateVacancy(response: HttpResponseBase): Observable<VacancyDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = VacancyDetailsDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateVacancy(model: VacancyDetailsDto): Observable<VacancyDetailsDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/UpdateVacancy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVacancy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVacancy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VacancyDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VacancyDetailsDto>;
        }));
    }

    protected processUpdateVacancy(response: HttpResponseBase): Observable<VacancyDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VacancyDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    onCancelVacancy(vacancyHrmId: number | undefined, vacancyId: number | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/OnCancelVacancy?";
        if (vacancyHrmId === null)
            throw new Error("The parameter 'vacancyHrmId' cannot be null.");
        else if (vacancyHrmId !== undefined)
            url_ += "vacancyHrmId=" + encodeURIComponent("" + vacancyHrmId) + "&";
        if (vacancyId === null)
            throw new Error("The parameter 'vacancyId' cannot be null.");
        else if (vacancyId !== undefined)
            url_ += "vacancyId=" + encodeURIComponent("" + vacancyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnCancelVacancy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnCancelVacancy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Response>;
        }));
    }

    protected processOnCancelVacancy(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVacancyById(vacancyId: number | undefined): Observable<VacancyDetailsDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/GetVacancyById?";
        if (vacancyId === null)
            throw new Error("The parameter 'vacancyId' cannot be null.");
        else if (vacancyId !== undefined)
            url_ += "vacancyId=" + encodeURIComponent("" + vacancyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVacancyById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVacancyById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VacancyDetailsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VacancyDetailsDto>;
        }));
    }

    protected processGetVacancyById(response: HttpResponseBase): Observable<VacancyDetailsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VacancyDetailsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDepartments(source: SourceVacancy | undefined): Observable<SelectItem2[]> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/GetDepartments?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectItem2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectItem2[]>;
        }));
    }

    protected processGetDepartments(response: HttpResponseBase): Observable<SelectItem2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getPositions(source: SourceVacancy | undefined): Observable<SelectItem2[]> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/GetPositions?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectItem2[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectItem2[]>;
        }));
    }

    protected processGetPositions(response: HttpResponseBase): Observable<SelectItem2[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectItem2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshSp(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/RefreshSp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshSp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshSp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRefreshSp(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    earlyClosedVacancy(id: number | undefined): Observable<Response> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/EarlyClosedVacancy?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEarlyClosedVacancy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEarlyClosedVacancy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Response>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Response>;
        }));
    }

    protected processEarlyClosedVacancy(response: HttpResponseBase): Observable<Response> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Response.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllVacancies(metaData: PaginatorMetaData): Observable<QueryResultOfVacancyDto> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/GetAllVacancies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metaData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllVacancies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllVacancies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QueryResultOfVacancyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QueryResultOfVacancyDto>;
        }));
    }

    protected processGetAllVacancies(response: HttpResponseBase): Observable<QueryResultOfVacancyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QueryResultOfVacancyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    bookingVacancyFromHrm(models: JobApplicationDto[]): Observable<JobApplicationDto[]> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/BookingVacancyFromHrm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBookingVacancyFromHrm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingVacancyFromHrm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<JobApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<JobApplicationDto[]>;
        }));
    }

    protected processBookingVacancyFromHrm(response: HttpResponseBase): Observable<JobApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobApplicationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendWinnerApplicantToEKadr(applicantId: number, vacancyId: number): Observable<CResponseOfBoolean> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/SendWinnerApplicantToEKadr/vacancyId={vacancyId}&applicantId={applicantId}";
        if (applicantId === undefined || applicantId === null)
            throw new Error("The parameter 'applicantId' must be defined.");
        url_ = url_.replace("{applicantId}", encodeURIComponent("" + applicantId));
        if (vacancyId === undefined || vacancyId === null)
            throw new Error("The parameter 'vacancyId' must be defined.");
        url_ = url_.replace("{vacancyId}", encodeURIComponent("" + vacancyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendWinnerApplicantToEKadr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendWinnerApplicantToEKadr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CResponseOfBoolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CResponseOfBoolean>;
        }));
    }

    protected processSendWinnerApplicantToEKadr(response: HttpResponseBase): Observable<CResponseOfBoolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CResponseOfBoolean.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deactiveVacation(vacancyId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/PiimaJob/Vacancy/DeactiveVacation/vacancyId={vacancyId}";
        if (vacancyId === undefined || vacancyId === null)
            throw new Error("The parameter 'vacancyId' must be defined.");
        url_ = url_.replace("{vacancyId}", encodeURIComponent("" + vacancyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactiveVacation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactiveVacation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeactiveVacation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class OneIdUserDto implements IOneIdUserDto {
    valid!: boolean;
    role_list?: string | undefined;
    le_name?: string | undefined;
    gd?: string | undefined;
    per_adr?: string | undefined;
    tin!: number;
    pport_issue_date?: string | undefined;
    sur_name?: string | undefined;
    ctzn?: string | undefined;
    first_name?: string | undefined;
    le_tin?: string | undefined;
    user_id?: string | undefined;
    user_type?: string | undefined;
    birth_cntry?: string | undefined;
    birth_date?: Date | undefined;
    pport_expr_date?: string | undefined;
    ret_cd?: string | undefined;
    natn?: string | undefined;
    ws_list?: string | undefined;
    pport_no?: string | undefined;
    mid_name?: string | undefined;
    mob_phone_no?: string | undefined;
    pin?: string | undefined;
    pport_issue_place?: string | undefined;
    full_name?: string | undefined;
    email?: string | undefined;
    sess_id?: string | undefined;
    applicantId!: number;

    constructor(data?: IOneIdUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valid = _data["valid"];
            this.role_list = _data["role_list"];
            this.le_name = _data["le_name"];
            this.gd = _data["gd"];
            this.per_adr = _data["per_adr"];
            this.tin = _data["tin"];
            this.pport_issue_date = _data["pport_issue_date"];
            this.sur_name = _data["sur_name"];
            this.ctzn = _data["ctzn"];
            this.first_name = _data["first_name"];
            this.le_tin = _data["le_tin"];
            this.user_id = _data["user_id"];
            this.user_type = _data["user_type"];
            this.birth_cntry = _data["birth_cntry"];
            this.birth_date = _data["birth_date"] ? new Date(_data["birth_date"].toString()) : <any>undefined;
            this.pport_expr_date = _data["pport_expr_date"];
            this.ret_cd = _data["ret_cd"];
            this.natn = _data["natn"];
            this.ws_list = _data["ws_list"];
            this.pport_no = _data["pport_no"];
            this.mid_name = _data["mid_name"];
            this.mob_phone_no = _data["mob_phone_no"];
            this.pin = _data["pin"];
            this.pport_issue_place = _data["pport_issue_place"];
            this.full_name = _data["full_name"];
            this.email = _data["email"];
            this.sess_id = _data["sess_id"];
            this.applicantId = _data["applicantId"];
        }
    }

    static fromJS(data: any): OneIdUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new OneIdUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valid"] = this.valid;
        data["role_list"] = this.role_list;
        data["le_name"] = this.le_name;
        data["gd"] = this.gd;
        data["per_adr"] = this.per_adr;
        data["tin"] = this.tin;
        data["pport_issue_date"] = this.pport_issue_date;
        data["sur_name"] = this.sur_name;
        data["ctzn"] = this.ctzn;
        data["first_name"] = this.first_name;
        data["le_tin"] = this.le_tin;
        data["user_id"] = this.user_id;
        data["user_type"] = this.user_type;
        data["birth_cntry"] = this.birth_cntry;
        data["birth_date"] = this.birth_date ? this.birth_date.toISOString() : <any>undefined;
        data["pport_expr_date"] = this.pport_expr_date;
        data["ret_cd"] = this.ret_cd;
        data["natn"] = this.natn;
        data["ws_list"] = this.ws_list;
        data["pport_no"] = this.pport_no;
        data["mid_name"] = this.mid_name;
        data["mob_phone_no"] = this.mob_phone_no;
        data["pin"] = this.pin;
        data["pport_issue_place"] = this.pport_issue_place;
        data["full_name"] = this.full_name;
        data["email"] = this.email;
        data["sess_id"] = this.sess_id;
        data["applicantId"] = this.applicantId;
        return data;
    }
}

export interface IOneIdUserDto {
    valid: boolean;
    role_list?: string | undefined;
    le_name?: string | undefined;
    gd?: string | undefined;
    per_adr?: string | undefined;
    tin: number;
    pport_issue_date?: string | undefined;
    sur_name?: string | undefined;
    ctzn?: string | undefined;
    first_name?: string | undefined;
    le_tin?: string | undefined;
    user_id?: string | undefined;
    user_type?: string | undefined;
    birth_cntry?: string | undefined;
    birth_date?: Date | undefined;
    pport_expr_date?: string | undefined;
    ret_cd?: string | undefined;
    natn?: string | undefined;
    ws_list?: string | undefined;
    pport_no?: string | undefined;
    mid_name?: string | undefined;
    mob_phone_no?: string | undefined;
    pin?: string | undefined;
    pport_issue_place?: string | undefined;
    full_name?: string | undefined;
    email?: string | undefined;
    sess_id?: string | undefined;
    applicantId: number;
}

export abstract class EntityBase implements IEntityBase {
    id!: number;
    active!: boolean;
    createdBy?: string | undefined;
    createdDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;
    comment?: string | undefined;

    constructor(data?: IEntityBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
            this.createdBy = _data["createdBy"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): EntityBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        data["createdBy"] = this.createdBy;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IEntityBase {
    id: number;
    active: boolean;
    createdBy?: string | undefined;
    createdDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;
    comment?: string | undefined;
}

export class GcpBase extends EntityBase implements IGcpBase {
    fullName?: FullName | undefined;
    passport!: PassportData;
    address!: Address;
    contact!: ContactData;
    inn?: string | undefined;
    isFromGcp!: boolean;

    constructor(data?: IGcpBase) {
        super(data);
        if (!data) {
            this.passport = new PassportData();
            this.address = new Address();
            this.contact = new ContactData();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fullName = _data["fullName"] ? FullName.fromJS(_data["fullName"]) : <any>undefined;
            this.passport = _data["passport"] ? PassportData.fromJS(_data["passport"]) : new PassportData();
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : new Address();
            this.contact = _data["contact"] ? ContactData.fromJS(_data["contact"]) : new ContactData();
            this.inn = _data["inn"];
            this.isFromGcp = _data["isFromGcp"];
        }
    }

    static override fromJS(data: any): GcpBase {
        data = typeof data === 'object' ? data : {};
        let result = new GcpBase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName ? this.fullName.toJSON() : <any>undefined;
        data["passport"] = this.passport ? this.passport.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["inn"] = this.inn;
        data["isFromGcp"] = this.isFromGcp;
        super.toJSON(data);
        return data;
    }
}

export interface IGcpBase extends IEntityBase {
    fullName?: FullName | undefined;
    passport: PassportData;
    address: Address;
    contact: ContactData;
    inn?: string | undefined;
    isFromGcp: boolean;
}

export class ApplicantDetailsDto extends GcpBase implements IApplicantDetailsDto {
    universities!: DiplomUniverDataDto[];
    applicantWorkplaceHistories!: ApplicantWorkplaceHistoryDto[];
    applicantCurrentWorkplaces!: ApplicantCurrentWorkplaceDto[];
    applicantFiles!: ApplicantFileDto[];
    pedagogicalCertificates!: ApplicantPedagogicalCertificateDto[];
    base64PassportPhoto?: string | undefined;
    profilePhotoUrl?: string | undefined;
    profilePhotoThumbnailUrl?: string | undefined;

    constructor(data?: IApplicantDetailsDto) {
        super(data);
        if (!data) {
            this.universities = [];
            this.applicantWorkplaceHistories = [];
            this.applicantCurrentWorkplaces = [];
            this.applicantFiles = [];
            this.pedagogicalCertificates = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["universities"])) {
                this.universities = [] as any;
                for (let item of _data["universities"])
                    this.universities!.push(DiplomUniverDataDto.fromJS(item));
            }
            if (Array.isArray(_data["applicantWorkplaceHistories"])) {
                this.applicantWorkplaceHistories = [] as any;
                for (let item of _data["applicantWorkplaceHistories"])
                    this.applicantWorkplaceHistories!.push(ApplicantWorkplaceHistoryDto.fromJS(item));
            }
            if (Array.isArray(_data["applicantCurrentWorkplaces"])) {
                this.applicantCurrentWorkplaces = [] as any;
                for (let item of _data["applicantCurrentWorkplaces"])
                    this.applicantCurrentWorkplaces!.push(ApplicantCurrentWorkplaceDto.fromJS(item));
            }
            if (Array.isArray(_data["applicantFiles"])) {
                this.applicantFiles = [] as any;
                for (let item of _data["applicantFiles"])
                    this.applicantFiles!.push(ApplicantFileDto.fromJS(item));
            }
            if (Array.isArray(_data["pedagogicalCertificates"])) {
                this.pedagogicalCertificates = [] as any;
                for (let item of _data["pedagogicalCertificates"])
                    this.pedagogicalCertificates!.push(ApplicantPedagogicalCertificateDto.fromJS(item));
            }
            this.base64PassportPhoto = _data["base64PassportPhoto"];
            this.profilePhotoUrl = _data["profilePhotoUrl"];
            this.profilePhotoThumbnailUrl = _data["profilePhotoThumbnailUrl"];
        }
    }

    static override fromJS(data: any): ApplicantDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.universities)) {
            data["universities"] = [];
            for (let item of this.universities)
                data["universities"].push(item.toJSON());
        }
        if (Array.isArray(this.applicantWorkplaceHistories)) {
            data["applicantWorkplaceHistories"] = [];
            for (let item of this.applicantWorkplaceHistories)
                data["applicantWorkplaceHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.applicantCurrentWorkplaces)) {
            data["applicantCurrentWorkplaces"] = [];
            for (let item of this.applicantCurrentWorkplaces)
                data["applicantCurrentWorkplaces"].push(item.toJSON());
        }
        if (Array.isArray(this.applicantFiles)) {
            data["applicantFiles"] = [];
            for (let item of this.applicantFiles)
                data["applicantFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.pedagogicalCertificates)) {
            data["pedagogicalCertificates"] = [];
            for (let item of this.pedagogicalCertificates)
                data["pedagogicalCertificates"].push(item.toJSON());
        }
        data["base64PassportPhoto"] = this.base64PassportPhoto;
        data["profilePhotoUrl"] = this.profilePhotoUrl;
        data["profilePhotoThumbnailUrl"] = this.profilePhotoThumbnailUrl;
        super.toJSON(data);
        return data;
    }
}

export interface IApplicantDetailsDto extends IGcpBase {
    universities: DiplomUniverDataDto[];
    applicantWorkplaceHistories: ApplicantWorkplaceHistoryDto[];
    applicantCurrentWorkplaces: ApplicantCurrentWorkplaceDto[];
    applicantFiles: ApplicantFileDto[];
    pedagogicalCertificates: ApplicantPedagogicalCertificateDto[];
    base64PassportPhoto?: string | undefined;
    profilePhotoUrl?: string | undefined;
    profilePhotoThumbnailUrl?: string | undefined;
}

export class DiplomUniverDataDto implements IDiplomUniverDataDto {
    id!: number;
    institutionId?: number | undefined;
    specialityName?: string | undefined;
    eduTypeName?: string | undefined;
    eduFormName?: string | undefined;
    eduDurationName?: string | undefined;
    degreeName?: string | undefined;
    eduFinishingDate?: Date | undefined;
    degreeId?: number | undefined;
    isFromGcp?: boolean | undefined;
    minId?: string | undefined;
    pinfl?: string | undefined;
    eduTypeId?: number | undefined;
    institutionTypeId?: number | undefined;
    institutionTypeName?: string | undefined;
    institutionName?: string | undefined;
    institutionOldNameId?: number | undefined;
    institutionOldName?: string | undefined;
    eduFormId?: number | undefined;
    specialityId?: number | undefined;
    specialityOldId?: number | undefined;
    specialityCode?: string | undefined;
    eduDurationId?: number | undefined;
    eduStartingDate?: Date | undefined;
    diplomaGivenDate?: Date | undefined;
    diplomaSerialId?: number | undefined;
    diplomaSerial?: string | undefined;
    diplomaNumber?: string | undefined;
    diplomaTypeId?: number | undefined;
    diplomaTypeName?: string | undefined;
    statusId?: number | undefined;
    statusName?: string | undefined;

    constructor(data?: IDiplomUniverDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.institutionId = _data["institutionId"];
            this.specialityName = _data["specialityName"];
            this.eduTypeName = _data["eduTypeName"];
            this.eduFormName = _data["eduFormName"];
            this.eduDurationName = _data["eduDurationName"];
            this.degreeName = _data["degreeName"];
            this.eduFinishingDate = _data["eduFinishingDate"] ? new Date(_data["eduFinishingDate"].toString()) : <any>undefined;
            this.degreeId = _data["degreeId"];
            this.isFromGcp = _data["isFromGcp"];
            this.minId = _data["minId"];
            this.pinfl = _data["pinfl"];
            this.eduTypeId = _data["eduTypeId"];
            this.institutionTypeId = _data["institutionTypeId"];
            this.institutionTypeName = _data["institutionTypeName"];
            this.institutionName = _data["institutionName"];
            this.institutionOldNameId = _data["institutionOldNameId"];
            this.institutionOldName = _data["institutionOldName"];
            this.eduFormId = _data["eduFormId"];
            this.specialityId = _data["specialityId"];
            this.specialityOldId = _data["specialityOldId"];
            this.specialityCode = _data["specialityCode"];
            this.eduDurationId = _data["eduDurationId"];
            this.eduStartingDate = _data["eduStartingDate"] ? new Date(_data["eduStartingDate"].toString()) : <any>undefined;
            this.diplomaGivenDate = _data["diplomaGivenDate"] ? new Date(_data["diplomaGivenDate"].toString()) : <any>undefined;
            this.diplomaSerialId = _data["diplomaSerialId"];
            this.diplomaSerial = _data["diplomaSerial"];
            this.diplomaNumber = _data["diplomaNumber"];
            this.diplomaTypeId = _data["diplomaTypeId"];
            this.diplomaTypeName = _data["diplomaTypeName"];
            this.statusId = _data["statusId"];
            this.statusName = _data["statusName"];
        }
    }

    static fromJS(data: any): DiplomUniverDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiplomUniverDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["institutionId"] = this.institutionId;
        data["specialityName"] = this.specialityName;
        data["eduTypeName"] = this.eduTypeName;
        data["eduFormName"] = this.eduFormName;
        data["eduDurationName"] = this.eduDurationName;
        data["degreeName"] = this.degreeName;
        data["eduFinishingDate"] = this.eduFinishingDate ? this.eduFinishingDate.toISOString() : <any>undefined;
        data["degreeId"] = this.degreeId;
        data["isFromGcp"] = this.isFromGcp;
        data["minId"] = this.minId;
        data["pinfl"] = this.pinfl;
        data["eduTypeId"] = this.eduTypeId;
        data["institutionTypeId"] = this.institutionTypeId;
        data["institutionTypeName"] = this.institutionTypeName;
        data["institutionName"] = this.institutionName;
        data["institutionOldNameId"] = this.institutionOldNameId;
        data["institutionOldName"] = this.institutionOldName;
        data["eduFormId"] = this.eduFormId;
        data["specialityId"] = this.specialityId;
        data["specialityOldId"] = this.specialityOldId;
        data["specialityCode"] = this.specialityCode;
        data["eduDurationId"] = this.eduDurationId;
        data["eduStartingDate"] = this.eduStartingDate ? this.eduStartingDate.toISOString() : <any>undefined;
        data["diplomaGivenDate"] = this.diplomaGivenDate ? this.diplomaGivenDate.toISOString() : <any>undefined;
        data["diplomaSerialId"] = this.diplomaSerialId;
        data["diplomaSerial"] = this.diplomaSerial;
        data["diplomaNumber"] = this.diplomaNumber;
        data["diplomaTypeId"] = this.diplomaTypeId;
        data["diplomaTypeName"] = this.diplomaTypeName;
        data["statusId"] = this.statusId;
        data["statusName"] = this.statusName;
        return data;
    }
}

export interface IDiplomUniverDataDto {
    id: number;
    institutionId?: number | undefined;
    specialityName?: string | undefined;
    eduTypeName?: string | undefined;
    eduFormName?: string | undefined;
    eduDurationName?: string | undefined;
    degreeName?: string | undefined;
    eduFinishingDate?: Date | undefined;
    degreeId?: number | undefined;
    isFromGcp?: boolean | undefined;
    minId?: string | undefined;
    pinfl?: string | undefined;
    eduTypeId?: number | undefined;
    institutionTypeId?: number | undefined;
    institutionTypeName?: string | undefined;
    institutionName?: string | undefined;
    institutionOldNameId?: number | undefined;
    institutionOldName?: string | undefined;
    eduFormId?: number | undefined;
    specialityId?: number | undefined;
    specialityOldId?: number | undefined;
    specialityCode?: string | undefined;
    eduDurationId?: number | undefined;
    eduStartingDate?: Date | undefined;
    diplomaGivenDate?: Date | undefined;
    diplomaSerialId?: number | undefined;
    diplomaSerial?: string | undefined;
    diplomaNumber?: string | undefined;
    diplomaTypeId?: number | undefined;
    diplomaTypeName?: string | undefined;
    statusId?: number | undefined;
    statusName?: string | undefined;
}

export class ApplicantWorkplaceHistoryDto implements IApplicantWorkplaceHistoryDto {
    id!: number;
    applicantId!: number;
    applicant?: ApplicantDto | undefined;
    endDate?: Date | undefined;
    companyInn!: string;
    companyName!: string;
    kodp?: string | undefined;
    kodpType?: string | undefined;
    positionName!: string;
    soatoCode!: string;
    startDate?: Date | undefined;
    structureName?: string | undefined;
    transactionId!: number;
    workplaceAddress?: string | undefined;

    constructor(data?: IApplicantWorkplaceHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicantId = _data["applicantId"];
            this.applicant = _data["applicant"] ? ApplicantDto.fromJS(_data["applicant"]) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.companyInn = _data["companyInn"];
            this.companyName = _data["companyName"];
            this.kodp = _data["kodp"];
            this.kodpType = _data["kodpType"];
            this.positionName = _data["positionName"];
            this.soatoCode = _data["soatoCode"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.structureName = _data["structureName"];
            this.transactionId = _data["transactionId"];
            this.workplaceAddress = _data["workplaceAddress"];
        }
    }

    static fromJS(data: any): ApplicantWorkplaceHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantWorkplaceHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicantId"] = this.applicantId;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["companyInn"] = this.companyInn;
        data["companyName"] = this.companyName;
        data["kodp"] = this.kodp;
        data["kodpType"] = this.kodpType;
        data["positionName"] = this.positionName;
        data["soatoCode"] = this.soatoCode;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["structureName"] = this.structureName;
        data["transactionId"] = this.transactionId;
        data["workplaceAddress"] = this.workplaceAddress;
        return data;
    }
}

export interface IApplicantWorkplaceHistoryDto {
    id: number;
    applicantId: number;
    applicant?: ApplicantDto | undefined;
    endDate?: Date | undefined;
    companyInn: string;
    companyName: string;
    kodp?: string | undefined;
    kodpType?: string | undefined;
    positionName: string;
    soatoCode: string;
    startDate?: Date | undefined;
    structureName?: string | undefined;
    transactionId: number;
    workplaceAddress?: string | undefined;
}

export class ApplicantDto implements IApplicantDto {
    id!: number;
    chatId!: number;
    fullName!: FullName;
    passport!: PassportData;
    contact!: ContactData;
    address!: Address;
    universities?: DiplomUniverDataDto[] | undefined;
    applicantWorkplaceHistories!: ApplicantWorkplaceHistoryDto[];
    applicantCurrentWorkplaces!: ApplicantCurrentWorkplaceDto[];
    pedagogicalCertificates!: ApplicantPedagogicalCertificateDto[];
    jobApplications!: JobApplicationDto[];
    applicantFiles!: ApplicantFileDto[];
    spTeachesLanguageIds!: number[];
    base64PassportPhoto?: string | undefined;
    profilePhotoUrl?: string | undefined;
    profilePhotoThumbnailUrl?: string | undefined;

    constructor(data?: IApplicantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fullName = new FullName();
            this.passport = new PassportData();
            this.contact = new ContactData();
            this.address = new Address();
            this.applicantWorkplaceHistories = [];
            this.applicantCurrentWorkplaces = [];
            this.pedagogicalCertificates = [];
            this.jobApplications = [];
            this.applicantFiles = [];
            this.spTeachesLanguageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chatId = _data["chatId"];
            this.fullName = _data["fullName"] ? FullName.fromJS(_data["fullName"]) : new FullName();
            this.passport = _data["passport"] ? PassportData.fromJS(_data["passport"]) : new PassportData();
            this.contact = _data["contact"] ? ContactData.fromJS(_data["contact"]) : new ContactData();
            this.address = _data["address"] ? Address.fromJS(_data["address"]) : new Address();
            if (Array.isArray(_data["universities"])) {
                this.universities = [] as any;
                for (let item of _data["universities"])
                    this.universities!.push(DiplomUniverDataDto.fromJS(item));
            }
            if (Array.isArray(_data["applicantWorkplaceHistories"])) {
                this.applicantWorkplaceHistories = [] as any;
                for (let item of _data["applicantWorkplaceHistories"])
                    this.applicantWorkplaceHistories!.push(ApplicantWorkplaceHistoryDto.fromJS(item));
            }
            if (Array.isArray(_data["applicantCurrentWorkplaces"])) {
                this.applicantCurrentWorkplaces = [] as any;
                for (let item of _data["applicantCurrentWorkplaces"])
                    this.applicantCurrentWorkplaces!.push(ApplicantCurrentWorkplaceDto.fromJS(item));
            }
            if (Array.isArray(_data["pedagogicalCertificates"])) {
                this.pedagogicalCertificates = [] as any;
                for (let item of _data["pedagogicalCertificates"])
                    this.pedagogicalCertificates!.push(ApplicantPedagogicalCertificateDto.fromJS(item));
            }
            if (Array.isArray(_data["jobApplications"])) {
                this.jobApplications = [] as any;
                for (let item of _data["jobApplications"])
                    this.jobApplications!.push(JobApplicationDto.fromJS(item));
            }
            if (Array.isArray(_data["applicantFiles"])) {
                this.applicantFiles = [] as any;
                for (let item of _data["applicantFiles"])
                    this.applicantFiles!.push(ApplicantFileDto.fromJS(item));
            }
            if (Array.isArray(_data["spTeachesLanguageIds"])) {
                this.spTeachesLanguageIds = [] as any;
                for (let item of _data["spTeachesLanguageIds"])
                    this.spTeachesLanguageIds!.push(item);
            }
            this.base64PassportPhoto = _data["base64PassportPhoto"];
            this.profilePhotoUrl = _data["profilePhotoUrl"];
            this.profilePhotoThumbnailUrl = _data["profilePhotoThumbnailUrl"];
        }
    }

    static fromJS(data: any): ApplicantDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chatId"] = this.chatId;
        data["fullName"] = this.fullName ? this.fullName.toJSON() : <any>undefined;
        data["passport"] = this.passport ? this.passport.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        if (Array.isArray(this.universities)) {
            data["universities"] = [];
            for (let item of this.universities)
                data["universities"].push(item.toJSON());
        }
        if (Array.isArray(this.applicantWorkplaceHistories)) {
            data["applicantWorkplaceHistories"] = [];
            for (let item of this.applicantWorkplaceHistories)
                data["applicantWorkplaceHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.applicantCurrentWorkplaces)) {
            data["applicantCurrentWorkplaces"] = [];
            for (let item of this.applicantCurrentWorkplaces)
                data["applicantCurrentWorkplaces"].push(item.toJSON());
        }
        if (Array.isArray(this.pedagogicalCertificates)) {
            data["pedagogicalCertificates"] = [];
            for (let item of this.pedagogicalCertificates)
                data["pedagogicalCertificates"].push(item.toJSON());
        }
        if (Array.isArray(this.jobApplications)) {
            data["jobApplications"] = [];
            for (let item of this.jobApplications)
                data["jobApplications"].push(item.toJSON());
        }
        if (Array.isArray(this.applicantFiles)) {
            data["applicantFiles"] = [];
            for (let item of this.applicantFiles)
                data["applicantFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.spTeachesLanguageIds)) {
            data["spTeachesLanguageIds"] = [];
            for (let item of this.spTeachesLanguageIds)
                data["spTeachesLanguageIds"].push(item);
        }
        data["base64PassportPhoto"] = this.base64PassportPhoto;
        data["profilePhotoUrl"] = this.profilePhotoUrl;
        data["profilePhotoThumbnailUrl"] = this.profilePhotoThumbnailUrl;
        return data;
    }
}

export interface IApplicantDto {
    id: number;
    chatId: number;
    fullName: FullName;
    passport: PassportData;
    contact: ContactData;
    address: Address;
    universities?: DiplomUniverDataDto[] | undefined;
    applicantWorkplaceHistories: ApplicantWorkplaceHistoryDto[];
    applicantCurrentWorkplaces: ApplicantCurrentWorkplaceDto[];
    pedagogicalCertificates: ApplicantPedagogicalCertificateDto[];
    jobApplications: JobApplicationDto[];
    applicantFiles: ApplicantFileDto[];
    spTeachesLanguageIds: number[];
    base64PassportPhoto?: string | undefined;
    profilePhotoUrl?: string | undefined;
    profilePhotoThumbnailUrl?: string | undefined;
}

export class FullName implements IFullName {
    surname!: string;
    name!: string;
    patronymic?: string | undefined;
    fio!: string;

    constructor(data?: IFullName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surname = _data["surname"];
            this.name = _data["name"];
            this.patronymic = _data["patronymic"];
            this.fio = _data["fio"];
        }
    }

    static fromJS(data: any): FullName {
        data = typeof data === 'object' ? data : {};
        let result = new FullName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surname"] = this.surname;
        data["name"] = this.name;
        data["patronymic"] = this.patronymic;
        data["fio"] = this.fio;
        return data;
    }
}

export interface IFullName {
    surname: string;
    name: string;
    patronymic?: string | undefined;
    fio: string;
}

export class PassportData implements IPassportData {
    pinfl?: string | undefined;
    passportSeria?: string | undefined;
    passportNumber?: string | undefined;
    passportGiven?: string | undefined;
    passportDateBegin?: Date | undefined;
    passportDateEnd?: Date | undefined;
    birthDate?: Date | undefined;
    spNationId?: number | undefined;
    spCitizenshipId?: number | undefined;
    citizenship?: string | undefined;
    spGenderId?: number | undefined;
    inps?: string | undefined;

    constructor(data?: IPassportData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pinfl = _data["pinfl"];
            this.passportSeria = _data["passportSeria"];
            this.passportNumber = _data["passportNumber"];
            this.passportGiven = _data["passportGiven"];
            this.passportDateBegin = _data["passportDateBegin"] ? new Date(_data["passportDateBegin"].toString()) : <any>undefined;
            this.passportDateEnd = _data["passportDateEnd"] ? new Date(_data["passportDateEnd"].toString()) : <any>undefined;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.spNationId = _data["spNationId"];
            this.spCitizenshipId = _data["spCitizenshipId"];
            this.citizenship = _data["citizenship"];
            this.spGenderId = _data["spGenderId"];
            this.inps = _data["inps"];
        }
    }

    static fromJS(data: any): PassportData {
        data = typeof data === 'object' ? data : {};
        let result = new PassportData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pinfl"] = this.pinfl;
        data["passportSeria"] = this.passportSeria;
        data["passportNumber"] = this.passportNumber;
        data["passportGiven"] = this.passportGiven;
        data["passportDateBegin"] = this.passportDateBegin ? this.passportDateBegin.toISOString() : <any>undefined;
        data["passportDateEnd"] = this.passportDateEnd ? this.passportDateEnd.toISOString() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["spNationId"] = this.spNationId;
        data["spCitizenshipId"] = this.spCitizenshipId;
        data["citizenship"] = this.citizenship;
        data["spGenderId"] = this.spGenderId;
        data["inps"] = this.inps;
        return data;
    }
}

export interface IPassportData {
    pinfl?: string | undefined;
    passportSeria?: string | undefined;
    passportNumber?: string | undefined;
    passportGiven?: string | undefined;
    passportDateBegin?: Date | undefined;
    passportDateEnd?: Date | undefined;
    birthDate?: Date | undefined;
    spNationId?: number | undefined;
    spCitizenshipId?: number | undefined;
    citizenship?: string | undefined;
    spGenderId?: number | undefined;
    inps?: string | undefined;
}

export class ContactData implements IContactData {
    phoneMain?: string | undefined;
    phoneAdditional?: string | undefined;
    eMail?: string | undefined;
    eMailAdditional?: string | undefined;

    constructor(data?: IContactData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneMain = _data["phoneMain"];
            this.phoneAdditional = _data["phoneAdditional"];
            this.eMail = _data["eMail"];
            this.eMailAdditional = _data["eMailAdditional"];
        }
    }

    static fromJS(data: any): ContactData {
        data = typeof data === 'object' ? data : {};
        let result = new ContactData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneMain"] = this.phoneMain;
        data["phoneAdditional"] = this.phoneAdditional;
        data["eMail"] = this.eMail;
        data["eMailAdditional"] = this.eMailAdditional;
        return data;
    }
}

export interface IContactData {
    phoneMain?: string | undefined;
    phoneAdditional?: string | undefined;
    eMail?: string | undefined;
    eMailAdditional?: string | undefined;
}

export class Address implements IAddress {
    spCountryId?: number | undefined;
    spRegionId?: number | undefined;
    spDistrictId?: number | undefined;
    streetHome?: string | undefined;
    addressBirth?: string | undefined;

    constructor(data?: IAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spCountryId = _data["spCountryId"];
            this.spRegionId = _data["spRegionId"];
            this.spDistrictId = _data["spDistrictId"];
            this.streetHome = _data["streetHome"];
            this.addressBirth = _data["addressBirth"];
        }
    }

    static fromJS(data: any): Address {
        data = typeof data === 'object' ? data : {};
        let result = new Address();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spCountryId"] = this.spCountryId;
        data["spRegionId"] = this.spRegionId;
        data["spDistrictId"] = this.spDistrictId;
        data["streetHome"] = this.streetHome;
        data["addressBirth"] = this.addressBirth;
        return data;
    }
}

export interface IAddress {
    spCountryId?: number | undefined;
    spRegionId?: number | undefined;
    spDistrictId?: number | undefined;
    streetHome?: string | undefined;
    addressBirth?: string | undefined;
}

export class ApplicantCurrentWorkplaceDto implements IApplicantCurrentWorkplaceDto {
    id!: number;
    applicantId!: number;
    applicant?: ApplicantDto | undefined;
    beginDate?: Date | undefined;
    departmentId!: number;
    departmentName!: string;
    documentBeginNumber!: string;
    kodp?: string | undefined;
    organizationName!: string;
    organizationId!: string;
    organizationInn!: string;
    positionName!: string;
    positionId!: number;
    rate!: string;

    constructor(data?: IApplicantCurrentWorkplaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicantId = _data["applicantId"];
            this.applicant = _data["applicant"] ? ApplicantDto.fromJS(_data["applicant"]) : <any>undefined;
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.documentBeginNumber = _data["documentBeginNumber"];
            this.kodp = _data["kodp"];
            this.organizationName = _data["organizationName"];
            this.organizationId = _data["organizationId"];
            this.organizationInn = _data["organizationInn"];
            this.positionName = _data["positionName"];
            this.positionId = _data["positionId"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): ApplicantCurrentWorkplaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantCurrentWorkplaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicantId"] = this.applicantId;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["documentBeginNumber"] = this.documentBeginNumber;
        data["kodp"] = this.kodp;
        data["organizationName"] = this.organizationName;
        data["organizationId"] = this.organizationId;
        data["organizationInn"] = this.organizationInn;
        data["positionName"] = this.positionName;
        data["positionId"] = this.positionId;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IApplicantCurrentWorkplaceDto {
    id: number;
    applicantId: number;
    applicant?: ApplicantDto | undefined;
    beginDate?: Date | undefined;
    departmentId: number;
    departmentName: string;
    documentBeginNumber: string;
    kodp?: string | undefined;
    organizationName: string;
    organizationId: string;
    organizationInn: string;
    positionName: string;
    positionId: number;
    rate: string;
}

export class ApplicantPedagogicalCertificateDto implements IApplicantPedagogicalCertificateDto {
    applicantId!: number;
    applicant?: ApplicantDto | undefined;
    subjectId!: number;
    subject!: string;
    category!: string;
    categoryId!: number;
    seriesId!: number;
    certificateFullname!: string;
    certificateSeriesId!: number;
    certificateNumber!: string;
    orderNumber!: string;
    orderDate!: Date;
    isForever!: boolean;
    startDate!: Date;
    endDate!: Date;

    constructor(data?: IApplicantPedagogicalCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"];
            this.applicant = _data["applicant"] ? ApplicantDto.fromJS(_data["applicant"]) : <any>undefined;
            this.subjectId = _data["subjectId"];
            this.subject = _data["subject"];
            this.category = _data["category"];
            this.categoryId = _data["categoryId"];
            this.seriesId = _data["seriesId"];
            this.certificateFullname = _data["certificateFullname"];
            this.certificateSeriesId = _data["certificateSeriesId"];
            this.certificateNumber = _data["certificateNumber"];
            this.orderNumber = _data["orderNumber"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.isForever = _data["isForever"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicantPedagogicalCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantPedagogicalCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["subjectId"] = this.subjectId;
        data["subject"] = this.subject;
        data["category"] = this.category;
        data["categoryId"] = this.categoryId;
        data["seriesId"] = this.seriesId;
        data["certificateFullname"] = this.certificateFullname;
        data["certificateSeriesId"] = this.certificateSeriesId;
        data["certificateNumber"] = this.certificateNumber;
        data["orderNumber"] = this.orderNumber;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["isForever"] = this.isForever;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IApplicantPedagogicalCertificateDto {
    applicantId: number;
    applicant?: ApplicantDto | undefined;
    subjectId: number;
    subject: string;
    category: string;
    categoryId: number;
    seriesId: number;
    certificateFullname: string;
    certificateSeriesId: number;
    certificateNumber: string;
    orderNumber: string;
    orderDate: Date;
    isForever: boolean;
    startDate: Date;
    endDate: Date;
}

export class JobApplicationDto implements IJobApplicationDto {
    id!: number;
    status!: JobApplicationStatus;
    staffType!: StaffType;
    applicant?: ApplicantDto | undefined;
    vacancyId?: number | undefined;
    vacancy?: VacancyDto | undefined;
    logs!: JobApplicationLogDto[];
    objectiveFileGuid?: string | undefined;
    qualificationCategoryFileGuid?: string | undefined;
    retrainingDocFileGuid?: string | undefined;
    passportFileGuid?: string | undefined;
    educationDegreeFileGuid?: string | undefined;
    certificateFileGuid?: string | undefined;
    rejectionReason?: string | undefined;
    firstStageStatus!: FirstStageStatus;
    firstStageComment?: string | undefined;
    finalStatus!: SelectedApplicationStatus;
    finalStatusComment?: string | undefined;
    isExportedToHrm!: boolean;
    commentExportedToHrm?: string | undefined;
    isInArchive!: boolean;
    commentIsInArchive?: string | undefined;
    createdBy?: string | undefined;
    creator?: string | undefined;
    createdDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModificator?: string | undefined;
    comment?: string | undefined;

    constructor(data?: IJobApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.logs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.staffType = _data["staffType"];
            this.applicant = _data["applicant"] ? ApplicantDto.fromJS(_data["applicant"]) : <any>undefined;
            this.vacancyId = _data["vacancyId"];
            this.vacancy = _data["vacancy"] ? VacancyDto.fromJS(_data["vacancy"]) : <any>undefined;
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(JobApplicationLogDto.fromJS(item));
            }
            this.objectiveFileGuid = _data["objectiveFileGuid"];
            this.qualificationCategoryFileGuid = _data["qualificationCategoryFileGuid"];
            this.retrainingDocFileGuid = _data["retrainingDocFileGuid"];
            this.passportFileGuid = _data["passportFileGuid"];
            this.educationDegreeFileGuid = _data["educationDegreeFileGuid"];
            this.certificateFileGuid = _data["certificateFileGuid"];
            this.rejectionReason = _data["rejectionReason"];
            this.firstStageStatus = _data["firstStageStatus"];
            this.firstStageComment = _data["firstStageComment"];
            this.finalStatus = _data["finalStatus"];
            this.finalStatusComment = _data["finalStatusComment"];
            this.isExportedToHrm = _data["isExportedToHrm"];
            this.commentExportedToHrm = _data["commentExportedToHrm"];
            this.isInArchive = _data["isInArchive"];
            this.commentIsInArchive = _data["commentIsInArchive"];
            this.createdBy = _data["createdBy"];
            this.creator = _data["creator"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.lastModificator = _data["lastModificator"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): JobApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["staffType"] = this.staffType;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["vacancyId"] = this.vacancyId;
        data["vacancy"] = this.vacancy ? this.vacancy.toJSON() : <any>undefined;
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        data["objectiveFileGuid"] = this.objectiveFileGuid;
        data["qualificationCategoryFileGuid"] = this.qualificationCategoryFileGuid;
        data["retrainingDocFileGuid"] = this.retrainingDocFileGuid;
        data["passportFileGuid"] = this.passportFileGuid;
        data["educationDegreeFileGuid"] = this.educationDegreeFileGuid;
        data["certificateFileGuid"] = this.certificateFileGuid;
        data["rejectionReason"] = this.rejectionReason;
        data["firstStageStatus"] = this.firstStageStatus;
        data["firstStageComment"] = this.firstStageComment;
        data["finalStatus"] = this.finalStatus;
        data["finalStatusComment"] = this.finalStatusComment;
        data["isExportedToHrm"] = this.isExportedToHrm;
        data["commentExportedToHrm"] = this.commentExportedToHrm;
        data["isInArchive"] = this.isInArchive;
        data["commentIsInArchive"] = this.commentIsInArchive;
        data["createdBy"] = this.createdBy;
        data["creator"] = this.creator;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["lastModificator"] = this.lastModificator;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IJobApplicationDto {
    id: number;
    status: JobApplicationStatus;
    staffType: StaffType;
    applicant?: ApplicantDto | undefined;
    vacancyId?: number | undefined;
    vacancy?: VacancyDto | undefined;
    logs: JobApplicationLogDto[];
    objectiveFileGuid?: string | undefined;
    qualificationCategoryFileGuid?: string | undefined;
    retrainingDocFileGuid?: string | undefined;
    passportFileGuid?: string | undefined;
    educationDegreeFileGuid?: string | undefined;
    certificateFileGuid?: string | undefined;
    rejectionReason?: string | undefined;
    firstStageStatus: FirstStageStatus;
    firstStageComment?: string | undefined;
    finalStatus: SelectedApplicationStatus;
    finalStatusComment?: string | undefined;
    isExportedToHrm: boolean;
    commentExportedToHrm?: string | undefined;
    isInArchive: boolean;
    commentIsInArchive?: string | undefined;
    createdBy?: string | undefined;
    creator?: string | undefined;
    createdDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: Date | undefined;
    lastModificator?: string | undefined;
    comment?: string | undefined;
}

export enum JobApplicationStatus {
    Draft = 0,
    New = 10,
    Opened = 20,
    Correcting = 30,
    Corrected = 40,
    Rejected = 50,
    Approve = 60,
    Reserved = 70,
}

export enum StaffType {
    Executive = 10,
    Pedagogical = 20,
    Technical = 30,
}

export class VacancyDto implements IVacancyDto {
    staffType!: StaffType;
    id!: number;
    startEndDates?: string | undefined;
    numberOfApplications!: number;
    applicationsCount!: number;
    title!: string;
    spSubjectId!: number;
    spSubjectName?: string | undefined;
    workExperience?: string | undefined;
    spInstitutionId!: number;
    spInstitutionName?: string | undefined;
    spInstitutionTypeId!: number;
    regionCode!: number;
    spDepartmentId!: number;
    spDepartmentName?: string | undefined;
    spPositionId!: number;
    spPositionName?: string | undefined;
    spCategoryOfPositionId?: number | undefined;
    spCategoryOfPositionName?: string | undefined;
    spTypeOfPositionId?: number | undefined;
    spTypeOfPositionName?: string | undefined;
    educationLevelId?: number | undefined;
    educationLevelName?: string | undefined;
    spPedagogicalCategoryId?: number | undefined;
    salary!: number;
    workingDays?: string | undefined;
    workingHours?: string | undefined;
    typeOfEmploymentRelations!: EmploymentRelation;
    qualificationRequirements?: string | undefined;
    positionDuties?: string | undefined;
    workingConditions?: string | undefined;
    computerLiteracy?: string | undefined;
    numberOfViews!: number;
    rate?: number | undefined;
    endDate?: Date | undefined;
    startDate?: Date | undefined;
    status!: VacancyStatus;
    vacancyFiles!: VacancyFileDto[];
    sourceVacancy!: SourceVacancy;
    createdBy?: string | undefined;
    creator?: string | undefined;
    createdDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    lastModificator?: string | undefined;
    lastModifiedDate?: Date | undefined;
    comment?: string | undefined;

    constructor(data?: IVacancyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vacancyFiles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staffType = _data["staffType"];
            this.id = _data["id"];
            this.startEndDates = _data["startEndDates"];
            this.numberOfApplications = _data["numberOfApplications"];
            this.applicationsCount = _data["applicationsCount"];
            this.title = _data["title"];
            this.spSubjectId = _data["spSubjectId"];
            this.spSubjectName = _data["spSubjectName"];
            this.workExperience = _data["workExperience"];
            this.spInstitutionId = _data["spInstitutionId"];
            this.spInstitutionName = _data["spInstitutionName"];
            this.spInstitutionTypeId = _data["spInstitutionTypeId"];
            this.regionCode = _data["regionCode"];
            this.spDepartmentId = _data["spDepartmentId"];
            this.spDepartmentName = _data["spDepartmentName"];
            this.spPositionId = _data["spPositionId"];
            this.spPositionName = _data["spPositionName"];
            this.spCategoryOfPositionId = _data["spCategoryOfPositionId"];
            this.spCategoryOfPositionName = _data["spCategoryOfPositionName"];
            this.spTypeOfPositionId = _data["spTypeOfPositionId"];
            this.spTypeOfPositionName = _data["spTypeOfPositionName"];
            this.educationLevelId = _data["educationLevelId"];
            this.educationLevelName = _data["educationLevelName"];
            this.spPedagogicalCategoryId = _data["spPedagogicalCategoryId"];
            this.salary = _data["salary"];
            this.workingDays = _data["workingDays"];
            this.workingHours = _data["workingHours"];
            this.typeOfEmploymentRelations = _data["typeOfEmploymentRelations"];
            this.qualificationRequirements = _data["qualificationRequirements"];
            this.positionDuties = _data["positionDuties"];
            this.workingConditions = _data["workingConditions"];
            this.computerLiteracy = _data["computerLiteracy"];
            this.numberOfViews = _data["numberOfViews"];
            this.rate = _data["rate"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            if (Array.isArray(_data["vacancyFiles"])) {
                this.vacancyFiles = [] as any;
                for (let item of _data["vacancyFiles"])
                    this.vacancyFiles!.push(VacancyFileDto.fromJS(item));
            }
            this.sourceVacancy = _data["sourceVacancy"];
            this.createdBy = _data["createdBy"];
            this.creator = _data["creator"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModificator = _data["lastModificator"];
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): VacancyDto {
        data = typeof data === 'object' ? data : {};
        let result = new VacancyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staffType"] = this.staffType;
        data["id"] = this.id;
        data["startEndDates"] = this.startEndDates;
        data["numberOfApplications"] = this.numberOfApplications;
        data["applicationsCount"] = this.applicationsCount;
        data["title"] = this.title;
        data["spSubjectId"] = this.spSubjectId;
        data["spSubjectName"] = this.spSubjectName;
        data["workExperience"] = this.workExperience;
        data["spInstitutionId"] = this.spInstitutionId;
        data["spInstitutionName"] = this.spInstitutionName;
        data["spInstitutionTypeId"] = this.spInstitutionTypeId;
        data["regionCode"] = this.regionCode;
        data["spDepartmentId"] = this.spDepartmentId;
        data["spDepartmentName"] = this.spDepartmentName;
        data["spPositionId"] = this.spPositionId;
        data["spPositionName"] = this.spPositionName;
        data["spCategoryOfPositionId"] = this.spCategoryOfPositionId;
        data["spCategoryOfPositionName"] = this.spCategoryOfPositionName;
        data["spTypeOfPositionId"] = this.spTypeOfPositionId;
        data["spTypeOfPositionName"] = this.spTypeOfPositionName;
        data["educationLevelId"] = this.educationLevelId;
        data["educationLevelName"] = this.educationLevelName;
        data["spPedagogicalCategoryId"] = this.spPedagogicalCategoryId;
        data["salary"] = this.salary;
        data["workingDays"] = this.workingDays;
        data["workingHours"] = this.workingHours;
        data["typeOfEmploymentRelations"] = this.typeOfEmploymentRelations;
        data["qualificationRequirements"] = this.qualificationRequirements;
        data["positionDuties"] = this.positionDuties;
        data["workingConditions"] = this.workingConditions;
        data["computerLiteracy"] = this.computerLiteracy;
        data["numberOfViews"] = this.numberOfViews;
        data["rate"] = this.rate;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["status"] = this.status;
        if (Array.isArray(this.vacancyFiles)) {
            data["vacancyFiles"] = [];
            for (let item of this.vacancyFiles)
                data["vacancyFiles"].push(item.toJSON());
        }
        data["sourceVacancy"] = this.sourceVacancy;
        data["createdBy"] = this.createdBy;
        data["creator"] = this.creator;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModificator"] = this.lastModificator;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IVacancyDto {
    staffType: StaffType;
    id: number;
    startEndDates?: string | undefined;
    numberOfApplications: number;
    applicationsCount: number;
    title: string;
    spSubjectId: number;
    spSubjectName?: string | undefined;
    workExperience?: string | undefined;
    spInstitutionId: number;
    spInstitutionName?: string | undefined;
    spInstitutionTypeId: number;
    regionCode: number;
    spDepartmentId: number;
    spDepartmentName?: string | undefined;
    spPositionId: number;
    spPositionName?: string | undefined;
    spCategoryOfPositionId?: number | undefined;
    spCategoryOfPositionName?: string | undefined;
    spTypeOfPositionId?: number | undefined;
    spTypeOfPositionName?: string | undefined;
    educationLevelId?: number | undefined;
    educationLevelName?: string | undefined;
    spPedagogicalCategoryId?: number | undefined;
    salary: number;
    workingDays?: string | undefined;
    workingHours?: string | undefined;
    typeOfEmploymentRelations: EmploymentRelation;
    qualificationRequirements?: string | undefined;
    positionDuties?: string | undefined;
    workingConditions?: string | undefined;
    computerLiteracy?: string | undefined;
    numberOfViews: number;
    rate?: number | undefined;
    endDate?: Date | undefined;
    startDate?: Date | undefined;
    status: VacancyStatus;
    vacancyFiles: VacancyFileDto[];
    sourceVacancy: SourceVacancy;
    createdBy?: string | undefined;
    creator?: string | undefined;
    createdDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    lastModificator?: string | undefined;
    lastModifiedDate?: Date | undefined;
    comment?: string | undefined;
}

export enum EmploymentRelation {
    Basic = 1,
    Orindoshlik = 2,
    Clockwise = 3,
    Remote = 4,
    Seasonal = 5,
}

export enum VacancyStatus {
    Opened = 1,
    Publish = 2,
    EarlyClosed = 3,
    Closed = 4,
}

export class VacancyFileDto implements IVacancyFileDto {
    id!: number;
    spApplicantFileTypeId!: number;
    vacancyId!: number;

    constructor(data?: IVacancyFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.spApplicantFileTypeId = _data["spApplicantFileTypeId"];
            this.vacancyId = _data["vacancyId"];
        }
    }

    static fromJS(data: any): VacancyFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new VacancyFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["spApplicantFileTypeId"] = this.spApplicantFileTypeId;
        data["vacancyId"] = this.vacancyId;
        return data;
    }
}

export interface IVacancyFileDto {
    id: number;
    spApplicantFileTypeId: number;
    vacancyId: number;
}

export enum SourceVacancy {
    Ekadr = 1,
    Hrm = 2,
    All = 100,
}

export class JobApplicationLogDto implements IJobApplicationLogDto {
    createdDate!: string;
    userFullName?: string | undefined;
    status!: JobApplicationStatus;
    details?: string | undefined;

    constructor(data?: IJobApplicationLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdDate = _data["createdDate"];
            this.userFullName = _data["userFullName"];
            this.status = _data["status"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): JobApplicationLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobApplicationLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdDate"] = this.createdDate;
        data["userFullName"] = this.userFullName;
        data["status"] = this.status;
        data["details"] = this.details;
        return data;
    }
}

export interface IJobApplicationLogDto {
    createdDate: string;
    userFullName?: string | undefined;
    status: JobApplicationStatus;
    details?: string | undefined;
}

export enum FirstStageStatus {
    NotAssessed = 10,
    Failed = 20,
    Succeeded = 30,
}

export enum SelectedApplicationStatus {
    NotAssessed = 10,
    Failed = 20,
    Succeeded = 30,
}

export class ApplicantFileDto implements IApplicantFileDto {
    id!: string;
    fileOriginalName?: string | undefined;
    fileName!: string;
    contentType!: string;
    fileUploadDate!: Date;
    fileUploadedBy?: string | undefined;
    applicantId!: number;
    applicant?: ApplicantDto | undefined;
    spApplicantFileTypeId!: number;
    active!: boolean;

    constructor(data?: IApplicantFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileOriginalName = _data["fileOriginalName"];
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.fileUploadDate = _data["fileUploadDate"] ? new Date(_data["fileUploadDate"].toString()) : <any>undefined;
            this.fileUploadedBy = _data["fileUploadedBy"];
            this.applicantId = _data["applicantId"];
            this.applicant = _data["applicant"] ? ApplicantDto.fromJS(_data["applicant"]) : <any>undefined;
            this.spApplicantFileTypeId = _data["spApplicantFileTypeId"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): ApplicantFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileOriginalName"] = this.fileOriginalName;
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["fileUploadDate"] = this.fileUploadDate ? this.fileUploadDate.toISOString() : <any>undefined;
        data["fileUploadedBy"] = this.fileUploadedBy;
        data["applicantId"] = this.applicantId;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["spApplicantFileTypeId"] = this.spApplicantFileTypeId;
        data["active"] = this.active;
        return data;
    }
}

export interface IApplicantFileDto {
    id: string;
    fileOriginalName?: string | undefined;
    fileName: string;
    contentType: string;
    fileUploadDate: Date;
    fileUploadedBy?: string | undefined;
    applicantId: number;
    applicant?: ApplicantDto | undefined;
    spApplicantFileTypeId: number;
    active: boolean;
}

export class ApplicantProfileDto implements IApplicantProfileDto {
    id!: number;
    fullName!: ProfileFullNameDto;
    passport!: ProfilePassportDto;
    address!: ProfileAddressDto;
    contact!: ProfileContactDto;
    base64PassportPhoto?: string | undefined;
    universities!: ProfileUniversityDto[];
    applicantWorkplaceHistories!: ProfileWorkplaceHistoryDto[];
    applicantCurrentWorkplaces!: ProfileCurrentWorkplaceDto[];
    pedagogicalCertificates!: ProfilePedagogicalCertificateDto[];
    applicantFiles!: ProfileApplicantFileDto[];

    constructor(data?: IApplicantProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fullName = new ProfileFullNameDto();
            this.passport = new ProfilePassportDto();
            this.address = new ProfileAddressDto();
            this.contact = new ProfileContactDto();
            this.universities = [];
            this.applicantWorkplaceHistories = [];
            this.applicantCurrentWorkplaces = [];
            this.pedagogicalCertificates = [];
            this.applicantFiles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"] ? ProfileFullNameDto.fromJS(_data["fullName"]) : new ProfileFullNameDto();
            this.passport = _data["passport"] ? ProfilePassportDto.fromJS(_data["passport"]) : new ProfilePassportDto();
            this.address = _data["address"] ? ProfileAddressDto.fromJS(_data["address"]) : new ProfileAddressDto();
            this.contact = _data["contact"] ? ProfileContactDto.fromJS(_data["contact"]) : new ProfileContactDto();
            this.base64PassportPhoto = _data["base64PassportPhoto"];
            if (Array.isArray(_data["universities"])) {
                this.universities = [] as any;
                for (let item of _data["universities"])
                    this.universities!.push(ProfileUniversityDto.fromJS(item));
            }
            if (Array.isArray(_data["applicantWorkplaceHistories"])) {
                this.applicantWorkplaceHistories = [] as any;
                for (let item of _data["applicantWorkplaceHistories"])
                    this.applicantWorkplaceHistories!.push(ProfileWorkplaceHistoryDto.fromJS(item));
            }
            if (Array.isArray(_data["applicantCurrentWorkplaces"])) {
                this.applicantCurrentWorkplaces = [] as any;
                for (let item of _data["applicantCurrentWorkplaces"])
                    this.applicantCurrentWorkplaces!.push(ProfileCurrentWorkplaceDto.fromJS(item));
            }
            if (Array.isArray(_data["pedagogicalCertificates"])) {
                this.pedagogicalCertificates = [] as any;
                for (let item of _data["pedagogicalCertificates"])
                    this.pedagogicalCertificates!.push(ProfilePedagogicalCertificateDto.fromJS(item));
            }
            if (Array.isArray(_data["applicantFiles"])) {
                this.applicantFiles = [] as any;
                for (let item of _data["applicantFiles"])
                    this.applicantFiles!.push(ProfileApplicantFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicantProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName ? this.fullName.toJSON() : <any>undefined;
        data["passport"] = this.passport ? this.passport.toJSON() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["base64PassportPhoto"] = this.base64PassportPhoto;
        if (Array.isArray(this.universities)) {
            data["universities"] = [];
            for (let item of this.universities)
                data["universities"].push(item.toJSON());
        }
        if (Array.isArray(this.applicantWorkplaceHistories)) {
            data["applicantWorkplaceHistories"] = [];
            for (let item of this.applicantWorkplaceHistories)
                data["applicantWorkplaceHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.applicantCurrentWorkplaces)) {
            data["applicantCurrentWorkplaces"] = [];
            for (let item of this.applicantCurrentWorkplaces)
                data["applicantCurrentWorkplaces"].push(item.toJSON());
        }
        if (Array.isArray(this.pedagogicalCertificates)) {
            data["pedagogicalCertificates"] = [];
            for (let item of this.pedagogicalCertificates)
                data["pedagogicalCertificates"].push(item.toJSON());
        }
        if (Array.isArray(this.applicantFiles)) {
            data["applicantFiles"] = [];
            for (let item of this.applicantFiles)
                data["applicantFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApplicantProfileDto {
    id: number;
    fullName: ProfileFullNameDto;
    passport: ProfilePassportDto;
    address: ProfileAddressDto;
    contact: ProfileContactDto;
    base64PassportPhoto?: string | undefined;
    universities: ProfileUniversityDto[];
    applicantWorkplaceHistories: ProfileWorkplaceHistoryDto[];
    applicantCurrentWorkplaces: ProfileCurrentWorkplaceDto[];
    pedagogicalCertificates: ProfilePedagogicalCertificateDto[];
    applicantFiles: ProfileApplicantFileDto[];
}

export class ProfileFullNameDto implements IProfileFullNameDto {
    surname?: string | undefined;
    name?: string | undefined;
    patronymic?: string | undefined;
    fio!: string;

    constructor(data?: IProfileFullNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surname = _data["surname"];
            this.name = _data["name"];
            this.patronymic = _data["patronymic"];
            this.fio = _data["fio"];
        }
    }

    static fromJS(data: any): ProfileFullNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileFullNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surname"] = this.surname;
        data["name"] = this.name;
        data["patronymic"] = this.patronymic;
        data["fio"] = this.fio;
        return data;
    }
}

export interface IProfileFullNameDto {
    surname?: string | undefined;
    name?: string | undefined;
    patronymic?: string | undefined;
    fio: string;
}

export class ProfilePassportDto implements IProfilePassportDto {
    birthDate?: Date | undefined;
    citizenship?: string | undefined;
    spGenderId?: number | undefined;
    pinfl?: string | undefined;
    passportSeria?: string | undefined;
    passportNumber?: string | undefined;

    constructor(data?: IProfilePassportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.citizenship = _data["citizenship"];
            this.spGenderId = _data["spGenderId"];
            this.pinfl = _data["pinfl"];
            this.passportSeria = _data["passportSeria"];
            this.passportNumber = _data["passportNumber"];
        }
    }

    static fromJS(data: any): ProfilePassportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfilePassportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["citizenship"] = this.citizenship;
        data["spGenderId"] = this.spGenderId;
        data["pinfl"] = this.pinfl;
        data["passportSeria"] = this.passportSeria;
        data["passportNumber"] = this.passportNumber;
        return data;
    }
}

export interface IProfilePassportDto {
    birthDate?: Date | undefined;
    citizenship?: string | undefined;
    spGenderId?: number | undefined;
    pinfl?: string | undefined;
    passportSeria?: string | undefined;
    passportNumber?: string | undefined;
}

export class ProfileAddressDto implements IProfileAddressDto {
    streetHome?: string | undefined;

    constructor(data?: IProfileAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetHome = _data["streetHome"];
        }
    }

    static fromJS(data: any): ProfileAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetHome"] = this.streetHome;
        return data;
    }
}

export interface IProfileAddressDto {
    streetHome?: string | undefined;
}

export class ProfileContactDto implements IProfileContactDto {
    phoneMain?: string | undefined;
    eMail?: string | undefined;

    constructor(data?: IProfileContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneMain = _data["phoneMain"];
            this.eMail = _data["eMail"];
        }
    }

    static fromJS(data: any): ProfileContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneMain"] = this.phoneMain;
        data["eMail"] = this.eMail;
        return data;
    }
}

export interface IProfileContactDto {
    phoneMain?: string | undefined;
    eMail?: string | undefined;
}

export class ProfileUniversityDto implements IProfileUniversityDto {
    degreeId?: number | undefined;
    institutionId?: number | undefined;
    specialityName?: string | undefined;
    eduFinishingDate?: Date | undefined;

    constructor(data?: IProfileUniversityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.degreeId = _data["degreeId"];
            this.institutionId = _data["institutionId"];
            this.specialityName = _data["specialityName"];
            this.eduFinishingDate = _data["eduFinishingDate"] ? new Date(_data["eduFinishingDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProfileUniversityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileUniversityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["degreeId"] = this.degreeId;
        data["institutionId"] = this.institutionId;
        data["specialityName"] = this.specialityName;
        data["eduFinishingDate"] = this.eduFinishingDate ? this.eduFinishingDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProfileUniversityDto {
    degreeId?: number | undefined;
    institutionId?: number | undefined;
    specialityName?: string | undefined;
    eduFinishingDate?: Date | undefined;
}

export class ProfileWorkplaceHistoryDto implements IProfileWorkplaceHistoryDto {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    companyName!: string;
    workplaceAddress?: string | undefined;
    positionName!: string;

    constructor(data?: IProfileWorkplaceHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.companyName = _data["companyName"];
            this.workplaceAddress = _data["workplaceAddress"];
            this.positionName = _data["positionName"];
        }
    }

    static fromJS(data: any): ProfileWorkplaceHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileWorkplaceHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["companyName"] = this.companyName;
        data["workplaceAddress"] = this.workplaceAddress;
        data["positionName"] = this.positionName;
        return data;
    }
}

export interface IProfileWorkplaceHistoryDto {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    companyName: string;
    workplaceAddress?: string | undefined;
    positionName: string;
}

export class ProfileCurrentWorkplaceDto implements IProfileCurrentWorkplaceDto {
    beginDate?: Date | undefined;
    organizationName!: string;
    departmentName!: string;
    positionName?: string | undefined;

    constructor(data?: IProfileCurrentWorkplaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.organizationName = _data["organizationName"];
            this.departmentName = _data["departmentName"];
            this.positionName = _data["positionName"];
        }
    }

    static fromJS(data: any): ProfileCurrentWorkplaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileCurrentWorkplaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["organizationName"] = this.organizationName;
        data["departmentName"] = this.departmentName;
        data["positionName"] = this.positionName;
        return data;
    }
}

export interface IProfileCurrentWorkplaceDto {
    beginDate?: Date | undefined;
    organizationName: string;
    departmentName: string;
    positionName?: string | undefined;
}

export class ProfilePedagogicalCertificateDto implements IProfilePedagogicalCertificateDto {
    category!: string;
    certificateFullname!: string;
    certificateNumber!: string;
    startDate!: Date;
    endDate!: Date;

    constructor(data?: IProfilePedagogicalCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
            this.certificateFullname = _data["certificateFullname"];
            this.certificateNumber = _data["certificateNumber"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProfilePedagogicalCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfilePedagogicalCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        data["certificateFullname"] = this.certificateFullname;
        data["certificateNumber"] = this.certificateNumber;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProfilePedagogicalCertificateDto {
    category: string;
    certificateFullname: string;
    certificateNumber: string;
    startDate: Date;
    endDate: Date;
}

export class ProfileApplicantFileDto implements IProfileApplicantFileDto {
    id!: string;
    fileOriginalName?: string | undefined;
    fileName!: string;
    spApplicantFileTypeId!: number;

    constructor(data?: IProfileApplicantFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileOriginalName = _data["fileOriginalName"];
            this.fileName = _data["fileName"];
            this.spApplicantFileTypeId = _data["spApplicantFileTypeId"];
        }
    }

    static fromJS(data: any): ProfileApplicantFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileApplicantFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileOriginalName"] = this.fileOriginalName;
        data["fileName"] = this.fileName;
        data["spApplicantFileTypeId"] = this.spApplicantFileTypeId;
        return data;
    }
}

export interface IProfileApplicantFileDto {
    id: string;
    fileOriginalName?: string | undefined;
    fileName: string;
    spApplicantFileTypeId: number;
}

export enum MIPIntegration {
    DiplomaData = 10,
    EmploymentHistory = 20,
    EmploymentCurrent = 30,
    PedCategory = 40,
    PhotoFromGCP = 50,
}

export class JobApplicationDetailsDto implements IJobApplicationDetailsDto {
    id?: number | undefined;
    applicant?: ApplicantDetailsDto | undefined;
    applicantId?: number | undefined;
    vacancy?: VacancyDetailsDto | undefined;
    vacancyId?: number | undefined;
    status!: JobApplicationStatus;
    staffType!: StaffType;
    objectiveFileGuid?: string | undefined;
    qualificationCategoryFileGuid?: string | undefined;
    retrainingDocFileGuid?: string | undefined;
    passportFileGuid?: string | undefined;
    educationDegreeFileGuid?: string | undefined;
    certificateFileGuid?: string | undefined;
    createdDate?: Date | undefined;
    firstStageComment?: string | undefined;
    firstStageStatus!: FirstStageStatus;
    finalStatus!: SelectedApplicationStatus;
    finalStatusComment?: string | undefined;
    finalStatusFileGuid?: string | undefined;
    isExportedToHRM!: boolean;
    commentExportedToHRM?: string | undefined;
    logs?: JobApplicationLogDto[] | undefined;

    constructor(data?: IJobApplicationDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicant = _data["applicant"] ? ApplicantDetailsDto.fromJS(_data["applicant"]) : <any>undefined;
            this.applicantId = _data["applicantId"];
            this.vacancy = _data["vacancy"] ? VacancyDetailsDto.fromJS(_data["vacancy"]) : <any>undefined;
            this.vacancyId = _data["vacancyId"];
            this.status = _data["status"];
            this.staffType = _data["staffType"];
            this.objectiveFileGuid = _data["objectiveFileGuid"];
            this.qualificationCategoryFileGuid = _data["qualificationCategoryFileGuid"];
            this.retrainingDocFileGuid = _data["retrainingDocFileGuid"];
            this.passportFileGuid = _data["passportFileGuid"];
            this.educationDegreeFileGuid = _data["educationDegreeFileGuid"];
            this.certificateFileGuid = _data["certificateFileGuid"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.firstStageComment = _data["firstStageComment"];
            this.firstStageStatus = _data["firstStageStatus"];
            this.finalStatus = _data["finalStatus"];
            this.finalStatusComment = _data["finalStatusComment"];
            this.finalStatusFileGuid = _data["finalStatusFileGuid"];
            this.isExportedToHRM = _data["isExportedToHRM"];
            this.commentExportedToHRM = _data["commentExportedToHRM"];
            if (Array.isArray(_data["logs"])) {
                this.logs = [] as any;
                for (let item of _data["logs"])
                    this.logs!.push(JobApplicationLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): JobApplicationDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobApplicationDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : <any>undefined;
        data["applicantId"] = this.applicantId;
        data["vacancy"] = this.vacancy ? this.vacancy.toJSON() : <any>undefined;
        data["vacancyId"] = this.vacancyId;
        data["status"] = this.status;
        data["staffType"] = this.staffType;
        data["objectiveFileGuid"] = this.objectiveFileGuid;
        data["qualificationCategoryFileGuid"] = this.qualificationCategoryFileGuid;
        data["retrainingDocFileGuid"] = this.retrainingDocFileGuid;
        data["passportFileGuid"] = this.passportFileGuid;
        data["educationDegreeFileGuid"] = this.educationDegreeFileGuid;
        data["certificateFileGuid"] = this.certificateFileGuid;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["firstStageComment"] = this.firstStageComment;
        data["firstStageStatus"] = this.firstStageStatus;
        data["finalStatus"] = this.finalStatus;
        data["finalStatusComment"] = this.finalStatusComment;
        data["finalStatusFileGuid"] = this.finalStatusFileGuid;
        data["isExportedToHRM"] = this.isExportedToHRM;
        data["commentExportedToHRM"] = this.commentExportedToHRM;
        if (Array.isArray(this.logs)) {
            data["logs"] = [];
            for (let item of this.logs)
                data["logs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJobApplicationDetailsDto {
    id?: number | undefined;
    applicant?: ApplicantDetailsDto | undefined;
    applicantId?: number | undefined;
    vacancy?: VacancyDetailsDto | undefined;
    vacancyId?: number | undefined;
    status: JobApplicationStatus;
    staffType: StaffType;
    objectiveFileGuid?: string | undefined;
    qualificationCategoryFileGuid?: string | undefined;
    retrainingDocFileGuid?: string | undefined;
    passportFileGuid?: string | undefined;
    educationDegreeFileGuid?: string | undefined;
    certificateFileGuid?: string | undefined;
    createdDate?: Date | undefined;
    firstStageComment?: string | undefined;
    firstStageStatus: FirstStageStatus;
    finalStatus: SelectedApplicationStatus;
    finalStatusComment?: string | undefined;
    finalStatusFileGuid?: string | undefined;
    isExportedToHRM: boolean;
    commentExportedToHRM?: string | undefined;
    logs?: JobApplicationLogDto[] | undefined;
}

export class VacancyDetailsDto implements IVacancyDetailsDto {
    id!: number;
    title?: string | undefined;
    staffType!: StaffType;
    spSubjectId!: number;
    workExperience?: string | undefined;
    spInstitutionId!: number;
    spInstitutionName?: string | undefined;
    spDepartmentId!: number;
    spDepartmentName?: string | undefined;
    spPositionId!: number;
    spPositionName?: string | undefined;
    spInstitutionTypeId!: number;
    spCategoryOfPositionId?: number | undefined;
    spPedagogicalCategoryId?: number | undefined;
    salary!: number;
    spTypeOfPositionId?: number | undefined;
    vacancyId!: number;
    educationLevelId?: number | undefined;
    workingDays?: string | undefined;
    workingHours?: string | undefined;
    typeOfEmploymentRelations!: EmploymentRelation;
    qualificationRequirements?: string | undefined;
    computerLiteracy?: string | undefined;
    positionDuties?: string | undefined;
    workingConditions?: string | undefined;
    numberOfViews!: number;
    rate?: number | undefined;
    endDate?: Date | undefined;
    startDate?: Date | undefined;
    status!: VacancyStatus;
    version!: number;
    vacancyFiles!: VacancyFileDto[];
    regionCode!: number;
    jobApplications!: JobApplicationDetailsDto[];
    sourceVacancy!: SourceVacancy;
    spTeachesLanguageIds!: number[];

    constructor(data?: IVacancyDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vacancyFiles = [];
            this.jobApplications = [];
            this.spTeachesLanguageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.staffType = _data["staffType"];
            this.spSubjectId = _data["spSubjectId"];
            this.workExperience = _data["workExperience"];
            this.spInstitutionId = _data["spInstitutionId"];
            this.spInstitutionName = _data["spInstitutionName"];
            this.spDepartmentId = _data["spDepartmentId"];
            this.spDepartmentName = _data["spDepartmentName"];
            this.spPositionId = _data["spPositionId"];
            this.spPositionName = _data["spPositionName"];
            this.spInstitutionTypeId = _data["spInstitutionTypeId"];
            this.spCategoryOfPositionId = _data["spCategoryOfPositionId"];
            this.spPedagogicalCategoryId = _data["spPedagogicalCategoryId"];
            this.salary = _data["salary"];
            this.spTypeOfPositionId = _data["spTypeOfPositionId"];
            this.vacancyId = _data["vacancyId"];
            this.educationLevelId = _data["educationLevelId"];
            this.workingDays = _data["workingDays"];
            this.workingHours = _data["workingHours"];
            this.typeOfEmploymentRelations = _data["typeOfEmploymentRelations"];
            this.qualificationRequirements = _data["qualificationRequirements"];
            this.computerLiteracy = _data["computerLiteracy"];
            this.positionDuties = _data["positionDuties"];
            this.workingConditions = _data["workingConditions"];
            this.numberOfViews = _data["numberOfViews"];
            this.rate = _data["rate"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.version = _data["version"];
            if (Array.isArray(_data["vacancyFiles"])) {
                this.vacancyFiles = [] as any;
                for (let item of _data["vacancyFiles"])
                    this.vacancyFiles!.push(VacancyFileDto.fromJS(item));
            }
            this.regionCode = _data["regionCode"];
            if (Array.isArray(_data["jobApplications"])) {
                this.jobApplications = [] as any;
                for (let item of _data["jobApplications"])
                    this.jobApplications!.push(JobApplicationDetailsDto.fromJS(item));
            }
            this.sourceVacancy = _data["sourceVacancy"];
            if (Array.isArray(_data["spTeachesLanguageIds"])) {
                this.spTeachesLanguageIds = [] as any;
                for (let item of _data["spTeachesLanguageIds"])
                    this.spTeachesLanguageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): VacancyDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new VacancyDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["staffType"] = this.staffType;
        data["spSubjectId"] = this.spSubjectId;
        data["workExperience"] = this.workExperience;
        data["spInstitutionId"] = this.spInstitutionId;
        data["spInstitutionName"] = this.spInstitutionName;
        data["spDepartmentId"] = this.spDepartmentId;
        data["spDepartmentName"] = this.spDepartmentName;
        data["spPositionId"] = this.spPositionId;
        data["spPositionName"] = this.spPositionName;
        data["spInstitutionTypeId"] = this.spInstitutionTypeId;
        data["spCategoryOfPositionId"] = this.spCategoryOfPositionId;
        data["spPedagogicalCategoryId"] = this.spPedagogicalCategoryId;
        data["salary"] = this.salary;
        data["spTypeOfPositionId"] = this.spTypeOfPositionId;
        data["vacancyId"] = this.vacancyId;
        data["educationLevelId"] = this.educationLevelId;
        data["workingDays"] = this.workingDays;
        data["workingHours"] = this.workingHours;
        data["typeOfEmploymentRelations"] = this.typeOfEmploymentRelations;
        data["qualificationRequirements"] = this.qualificationRequirements;
        data["computerLiteracy"] = this.computerLiteracy;
        data["positionDuties"] = this.positionDuties;
        data["workingConditions"] = this.workingConditions;
        data["numberOfViews"] = this.numberOfViews;
        data["rate"] = this.rate;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>undefined;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>undefined;
        data["status"] = this.status;
        data["version"] = this.version;
        if (Array.isArray(this.vacancyFiles)) {
            data["vacancyFiles"] = [];
            for (let item of this.vacancyFiles)
                data["vacancyFiles"].push(item.toJSON());
        }
        data["regionCode"] = this.regionCode;
        if (Array.isArray(this.jobApplications)) {
            data["jobApplications"] = [];
            for (let item of this.jobApplications)
                data["jobApplications"].push(item.toJSON());
        }
        data["sourceVacancy"] = this.sourceVacancy;
        if (Array.isArray(this.spTeachesLanguageIds)) {
            data["spTeachesLanguageIds"] = [];
            for (let item of this.spTeachesLanguageIds)
                data["spTeachesLanguageIds"].push(item);
        }
        return data;
    }
}

export interface IVacancyDetailsDto {
    id: number;
    title?: string | undefined;
    staffType: StaffType;
    spSubjectId: number;
    workExperience?: string | undefined;
    spInstitutionId: number;
    spInstitutionName?: string | undefined;
    spDepartmentId: number;
    spDepartmentName?: string | undefined;
    spPositionId: number;
    spPositionName?: string | undefined;
    spInstitutionTypeId: number;
    spCategoryOfPositionId?: number | undefined;
    spPedagogicalCategoryId?: number | undefined;
    salary: number;
    spTypeOfPositionId?: number | undefined;
    vacancyId: number;
    educationLevelId?: number | undefined;
    workingDays?: string | undefined;
    workingHours?: string | undefined;
    typeOfEmploymentRelations: EmploymentRelation;
    qualificationRequirements?: string | undefined;
    computerLiteracy?: string | undefined;
    positionDuties?: string | undefined;
    workingConditions?: string | undefined;
    numberOfViews: number;
    rate?: number | undefined;
    endDate?: Date | undefined;
    startDate?: Date | undefined;
    status: VacancyStatus;
    version: number;
    vacancyFiles: VacancyFileDto[];
    regionCode: number;
    jobApplications: JobApplicationDetailsDto[];
    sourceVacancy: SourceVacancy;
    spTeachesLanguageIds: number[];
}

export class QueryResultOfJobApplicationDto implements IQueryResultOfJobApplicationDto {
    items!: JobApplicationDto[];
    totalItems!: number;

    constructor(data?: IQueryResultOfJobApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JobApplicationDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): QueryResultOfJobApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfJobApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IQueryResultOfJobApplicationDto {
    items: JobApplicationDto[];
    totalItems: number;
}

export class TableMetaData implements ITableMetaData {
    filters?: string | undefined;
    first!: number;
    rows!: number;
    sortField?: string | undefined;
    sortOrder!: number;
    filterHandle?: string | undefined;
    tagHandle?: string | undefined;
    globalFilter?: string | undefined;

    constructor(data?: ITableMetaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filters = _data["filters"];
            this.first = _data["first"];
            this.rows = _data["rows"];
            this.sortField = _data["sortField"];
            this.sortOrder = _data["sortOrder"];
            this.filterHandle = _data["filterHandle"];
            this.tagHandle = _data["tagHandle"];
            this.globalFilter = _data["globalFilter"];
        }
    }

    static fromJS(data: any): TableMetaData {
        data = typeof data === 'object' ? data : {};
        let result = new TableMetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filters"] = this.filters;
        data["first"] = this.first;
        data["rows"] = this.rows;
        data["sortField"] = this.sortField;
        data["sortOrder"] = this.sortOrder;
        data["filterHandle"] = this.filterHandle;
        data["tagHandle"] = this.tagHandle;
        data["globalFilter"] = this.globalFilter;
        return data;
    }
}

export interface ITableMetaData {
    filters?: string | undefined;
    first: number;
    rows: number;
    sortField?: string | undefined;
    sortOrder: number;
    filterHandle?: string | undefined;
    tagHandle?: string | undefined;
    globalFilter?: string | undefined;
}

export class ArchiveInfoCountAsInstitutionDto implements IArchiveInfoCountAsInstitutionDto {
    spInstitutionId!: number;
    applicantCount!: number;

    constructor(data?: IArchiveInfoCountAsInstitutionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spInstitutionId = _data["spInstitutionId"];
            this.applicantCount = _data["applicantCount"];
        }
    }

    static fromJS(data: any): ArchiveInfoCountAsInstitutionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveInfoCountAsInstitutionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spInstitutionId"] = this.spInstitutionId;
        data["applicantCount"] = this.applicantCount;
        return data;
    }
}

export interface IArchiveInfoCountAsInstitutionDto {
    spInstitutionId: number;
    applicantCount: number;
}

export class QueryResultOfJobApplicationApprovedItemDto implements IQueryResultOfJobApplicationApprovedItemDto {
    items!: JobApplicationApprovedItemDto[];
    totalItems!: number;

    constructor(data?: IQueryResultOfJobApplicationApprovedItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JobApplicationApprovedItemDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): QueryResultOfJobApplicationApprovedItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfJobApplicationApprovedItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IQueryResultOfJobApplicationApprovedItemDto {
    items: JobApplicationApprovedItemDto[];
    totalItems: number;
}

export class JobApplicationApprovedItemDto implements IJobApplicationApprovedItemDto {
    id!: number;
    vacancyId!: number;
    status!: JobApplicationStatus;
    staffType!: StaffType;
    firstStageStatus!: FirstStageStatus;
    firstStageComment?: string | undefined;
    finalStatus!: SelectedApplicationStatus;
    finalStatusComment?: string | undefined;
    applicantFio?: string | undefined;
    base64PassportPhoto?: string | undefined;
    profilePhotoThumbnailUrl?: string | undefined;
    pinfl?: string | undefined;
    spGenderId?: number | undefined;
    vacancyTitle?: string | undefined;
    spInstitutionId?: number | undefined;
    spCategoryOfPositionId?: number | undefined;
    createdBy?: string | undefined;
    creator?: string | undefined;
    createdDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    lastModificator?: string | undefined;
    isExportedToHrm!: boolean;
    commentExportedToHrm?: string | undefined;
    sourceVacancy?: number | undefined;

    constructor(data?: IJobApplicationApprovedItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vacancyId = _data["vacancyId"];
            this.status = _data["status"];
            this.staffType = _data["staffType"];
            this.firstStageStatus = _data["firstStageStatus"];
            this.firstStageComment = _data["firstStageComment"];
            this.finalStatus = _data["finalStatus"];
            this.finalStatusComment = _data["finalStatusComment"];
            this.applicantFio = _data["applicantFio"];
            this.base64PassportPhoto = _data["base64PassportPhoto"];
            this.profilePhotoThumbnailUrl = _data["profilePhotoThumbnailUrl"];
            this.pinfl = _data["pinfl"];
            this.spGenderId = _data["spGenderId"];
            this.vacancyTitle = _data["vacancyTitle"];
            this.spInstitutionId = _data["spInstitutionId"];
            this.spCategoryOfPositionId = _data["spCategoryOfPositionId"];
            this.createdBy = _data["createdBy"];
            this.creator = _data["creator"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModificator = _data["lastModificator"];
            this.isExportedToHrm = _data["isExportedToHrm"];
            this.commentExportedToHrm = _data["commentExportedToHrm"];
            this.sourceVacancy = _data["sourceVacancy"];
        }
    }

    static fromJS(data: any): JobApplicationApprovedItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobApplicationApprovedItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vacancyId"] = this.vacancyId;
        data["status"] = this.status;
        data["staffType"] = this.staffType;
        data["firstStageStatus"] = this.firstStageStatus;
        data["firstStageComment"] = this.firstStageComment;
        data["finalStatus"] = this.finalStatus;
        data["finalStatusComment"] = this.finalStatusComment;
        data["applicantFio"] = this.applicantFio;
        data["base64PassportPhoto"] = this.base64PassportPhoto;
        data["profilePhotoThumbnailUrl"] = this.profilePhotoThumbnailUrl;
        data["pinfl"] = this.pinfl;
        data["spGenderId"] = this.spGenderId;
        data["vacancyTitle"] = this.vacancyTitle;
        data["spInstitutionId"] = this.spInstitutionId;
        data["spCategoryOfPositionId"] = this.spCategoryOfPositionId;
        data["createdBy"] = this.createdBy;
        data["creator"] = this.creator;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModificator"] = this.lastModificator;
        data["isExportedToHrm"] = this.isExportedToHrm;
        data["commentExportedToHrm"] = this.commentExportedToHrm;
        data["sourceVacancy"] = this.sourceVacancy;
        return data;
    }
}

export interface IJobApplicationApprovedItemDto {
    id: number;
    vacancyId: number;
    status: JobApplicationStatus;
    staffType: StaffType;
    firstStageStatus: FirstStageStatus;
    firstStageComment?: string | undefined;
    finalStatus: SelectedApplicationStatus;
    finalStatusComment?: string | undefined;
    applicantFio?: string | undefined;
    base64PassportPhoto?: string | undefined;
    profilePhotoThumbnailUrl?: string | undefined;
    pinfl?: string | undefined;
    spGenderId?: number | undefined;
    vacancyTitle?: string | undefined;
    spInstitutionId?: number | undefined;
    spCategoryOfPositionId?: number | undefined;
    createdBy?: string | undefined;
    creator?: string | undefined;
    createdDate?: Date | undefined;
    lastModifiedBy?: string | undefined;
    lastModificator?: string | undefined;
    isExportedToHrm: boolean;
    commentExportedToHrm?: string | undefined;
    sourceVacancy?: number | undefined;
}

export class SelectedApplicationsStageRequestDto implements ISelectedApplicationsStageRequestDto {
    spCategoryOfPositionId?: number | undefined;
    stage!: SelectedApplicationsStage;
    tableMeta!: TableMetaData;

    constructor(data?: ISelectedApplicationsStageRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tableMeta = new TableMetaData();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spCategoryOfPositionId = _data["spCategoryOfPositionId"];
            this.stage = _data["stage"];
            this.tableMeta = _data["tableMeta"] ? TableMetaData.fromJS(_data["tableMeta"]) : new TableMetaData();
        }
    }

    static fromJS(data: any): SelectedApplicationsStageRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectedApplicationsStageRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spCategoryOfPositionId"] = this.spCategoryOfPositionId;
        data["stage"] = this.stage;
        data["tableMeta"] = this.tableMeta ? this.tableMeta.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISelectedApplicationsStageRequestDto {
    spCategoryOfPositionId?: number | undefined;
    stage: SelectedApplicationsStage;
    tableMeta: TableMetaData;
}

export enum SelectedApplicationsStage {
    Step2 = 1,
    Step3 = 2,
    Results = 3,
}

export class JobApplicationMyDto implements IJobApplicationMyDto {
    id!: number;
    status!: JobApplicationStatus;
    createdDate?: Date | undefined;
    vacancyId!: number;
    vacancyTitle?: string | undefined;
    spInstitutionId!: number;
    statusComment?: string | undefined;

    constructor(data?: IJobApplicationMyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.vacancyId = _data["vacancyId"];
            this.vacancyTitle = _data["vacancyTitle"];
            this.spInstitutionId = _data["spInstitutionId"];
            this.statusComment = _data["statusComment"];
        }
    }

    static fromJS(data: any): JobApplicationMyDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobApplicationMyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["vacancyId"] = this.vacancyId;
        data["vacancyTitle"] = this.vacancyTitle;
        data["spInstitutionId"] = this.spInstitutionId;
        data["statusComment"] = this.statusComment;
        return data;
    }
}

export interface IJobApplicationMyDto {
    id: number;
    status: JobApplicationStatus;
    createdDate?: Date | undefined;
    vacancyId: number;
    vacancyTitle?: string | undefined;
    spInstitutionId: number;
    statusComment?: string | undefined;
}

export class QueryResultOfJobApplicationMyDto implements IQueryResultOfJobApplicationMyDto {
    items!: JobApplicationMyDto[];
    totalItems!: number;

    constructor(data?: IQueryResultOfJobApplicationMyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(JobApplicationMyDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): QueryResultOfJobApplicationMyDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfJobApplicationMyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IQueryResultOfJobApplicationMyDto {
    items: JobApplicationMyDto[];
    totalItems: number;
}

export class JobApplicationCorrectedDto implements IJobApplicationCorrectedDto {
    applicationId!: number;
    details?: string | undefined;

    constructor(data?: IJobApplicationCorrectedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): JobApplicationCorrectedDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobApplicationCorrectedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["details"] = this.details;
        return data;
    }
}

export interface IJobApplicationCorrectedDto {
    applicationId: number;
    details?: string | undefined;
}

export class JobApplicationFileDto implements IJobApplicationFileDto {
    id!: string;
    jobApplicationId!: number;
    spApplicantFileTypeId!: number;
    status!: JobApplicationFileStatus;
    statusComment?: string | undefined;
    fileOriginalName?: string | undefined;

    constructor(data?: IJobApplicationFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobApplicationId = _data["jobApplicationId"];
            this.spApplicantFileTypeId = _data["spApplicantFileTypeId"];
            this.status = _data["status"];
            this.statusComment = _data["statusComment"];
            this.fileOriginalName = _data["fileOriginalName"];
        }
    }

    static fromJS(data: any): JobApplicationFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobApplicationFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobApplicationId"] = this.jobApplicationId;
        data["spApplicantFileTypeId"] = this.spApplicantFileTypeId;
        data["status"] = this.status;
        data["statusComment"] = this.statusComment;
        data["fileOriginalName"] = this.fileOriginalName;
        return data;
    }
}

export interface IJobApplicationFileDto {
    id: string;
    jobApplicationId: number;
    spApplicantFileTypeId: number;
    status: JobApplicationFileStatus;
    statusComment?: string | undefined;
    fileOriginalName?: string | undefined;
}

export enum JobApplicationFileStatus {
    Pending = 0,
    Verified = 10,
    Edit = 20,
    Rejected = 30,
}

export class UpdateFileStatusDto implements IUpdateFileStatusDto {
    fileId!: string;
    status!: JobApplicationFileStatus;
    statusComment?: string | undefined;

    constructor(data?: IUpdateFileStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.status = _data["status"];
            this.statusComment = _data["statusComment"];
        }
    }

    static fromJS(data: any): UpdateFileStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFileStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["status"] = this.status;
        data["statusComment"] = this.statusComment;
        return data;
    }
}

export interface IUpdateFileStatusDto {
    fileId: string;
    status: JobApplicationFileStatus;
    statusComment?: string | undefined;
}

export class JobApplicationResultDto implements IJobApplicationResultDto {
    applicationId!: number;
    status!: JobApplicationStatus;
    statusComment?: string | undefined;
    firstStageStatus!: FirstStageStatus;
    finalStatus!: SelectedApplicationStatus;
    firstStageComment?: string | undefined;
    finalStatusComment?: string | undefined;
    finalStatusFileGuid?: string | undefined;
    createdDate?: Date | undefined;

    constructor(data?: IJobApplicationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"];
            this.status = _data["status"];
            this.statusComment = _data["statusComment"];
            this.firstStageStatus = _data["firstStageStatus"];
            this.finalStatus = _data["finalStatus"];
            this.firstStageComment = _data["firstStageComment"];
            this.finalStatusComment = _data["finalStatusComment"];
            this.finalStatusFileGuid = _data["finalStatusFileGuid"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): JobApplicationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new JobApplicationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId;
        data["status"] = this.status;
        data["statusComment"] = this.statusComment;
        data["firstStageStatus"] = this.firstStageStatus;
        data["finalStatus"] = this.finalStatus;
        data["firstStageComment"] = this.firstStageComment;
        data["finalStatusComment"] = this.finalStatusComment;
        data["finalStatusFileGuid"] = this.finalStatusFileGuid;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IJobApplicationResultDto {
    applicationId: number;
    status: JobApplicationStatus;
    statusComment?: string | undefined;
    firstStageStatus: FirstStageStatus;
    finalStatus: SelectedApplicationStatus;
    firstStageComment?: string | undefined;
    finalStatusComment?: string | undefined;
    finalStatusFileGuid?: string | undefined;
    createdDate?: Date | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class DashboardOverviewDto implements IDashboardOverviewDto {
    kpiCards!: KpiCardDto[];
    charts!: ChartDataDto;
    meta!: DashboardMetaDto;

    constructor(data?: IDashboardOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.kpiCards = [];
            this.charts = new ChartDataDto();
            this.meta = new DashboardMetaDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kpiCards"])) {
                this.kpiCards = [] as any;
                for (let item of _data["kpiCards"])
                    this.kpiCards!.push(KpiCardDto.fromJS(item));
            }
            this.charts = _data["charts"] ? ChartDataDto.fromJS(_data["charts"]) : new ChartDataDto();
            this.meta = _data["meta"] ? DashboardMetaDto.fromJS(_data["meta"]) : new DashboardMetaDto();
        }
    }

    static fromJS(data: any): DashboardOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kpiCards)) {
            data["kpiCards"] = [];
            for (let item of this.kpiCards)
                data["kpiCards"].push(item.toJSON());
        }
        data["charts"] = this.charts ? this.charts.toJSON() : <any>undefined;
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardOverviewDto {
    kpiCards: KpiCardDto[];
    charts: ChartDataDto;
    meta: DashboardMetaDto;
}

export class KpiCardDto implements IKpiCardDto {
    key!: string;
    count!: number;
    trend?: TrendDto | undefined;

    constructor(data?: IKpiCardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.count = _data["count"];
            this.trend = _data["trend"] ? TrendDto.fromJS(_data["trend"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KpiCardDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpiCardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["count"] = this.count;
        data["trend"] = this.trend ? this.trend.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKpiCardDto {
    key: string;
    count: number;
    trend?: TrendDto | undefined;
}

export class TrendDto implements ITrendDto {
    direction!: string;
    percentage!: number;
    previousCount!: number;

    constructor(data?: ITrendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.direction = _data["direction"];
            this.percentage = _data["percentage"];
            this.previousCount = _data["previousCount"];
        }
    }

    static fromJS(data: any): TrendDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["direction"] = this.direction;
        data["percentage"] = this.percentage;
        data["previousCount"] = this.previousCount;
        return data;
    }
}

export interface ITrendDto {
    direction: string;
    percentage: number;
    previousCount: number;
}

export class ChartDataDto implements IChartDataDto {
    bySchoolType!: ChartSliceDto[];
    byRegion!: ChartBarDto[];
    byPositionCategory!: ChartBarDto[];
    byStatus!: ChartSliceDto[];
    byStage!: ChartBarDto[];
    approvedByCategory!: ChartBarDto[];
    byVacancy!: ChartBarDto[];

    constructor(data?: IChartDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.bySchoolType = [];
            this.byRegion = [];
            this.byPositionCategory = [];
            this.byStatus = [];
            this.byStage = [];
            this.approvedByCategory = [];
            this.byVacancy = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bySchoolType"])) {
                this.bySchoolType = [] as any;
                for (let item of _data["bySchoolType"])
                    this.bySchoolType!.push(ChartSliceDto.fromJS(item));
            }
            if (Array.isArray(_data["byRegion"])) {
                this.byRegion = [] as any;
                for (let item of _data["byRegion"])
                    this.byRegion!.push(ChartBarDto.fromJS(item));
            }
            if (Array.isArray(_data["byPositionCategory"])) {
                this.byPositionCategory = [] as any;
                for (let item of _data["byPositionCategory"])
                    this.byPositionCategory!.push(ChartBarDto.fromJS(item));
            }
            if (Array.isArray(_data["byStatus"])) {
                this.byStatus = [] as any;
                for (let item of _data["byStatus"])
                    this.byStatus!.push(ChartSliceDto.fromJS(item));
            }
            if (Array.isArray(_data["byStage"])) {
                this.byStage = [] as any;
                for (let item of _data["byStage"])
                    this.byStage!.push(ChartBarDto.fromJS(item));
            }
            if (Array.isArray(_data["approvedByCategory"])) {
                this.approvedByCategory = [] as any;
                for (let item of _data["approvedByCategory"])
                    this.approvedByCategory!.push(ChartBarDto.fromJS(item));
            }
            if (Array.isArray(_data["byVacancy"])) {
                this.byVacancy = [] as any;
                for (let item of _data["byVacancy"])
                    this.byVacancy!.push(ChartBarDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChartDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bySchoolType)) {
            data["bySchoolType"] = [];
            for (let item of this.bySchoolType)
                data["bySchoolType"].push(item.toJSON());
        }
        if (Array.isArray(this.byRegion)) {
            data["byRegion"] = [];
            for (let item of this.byRegion)
                data["byRegion"].push(item.toJSON());
        }
        if (Array.isArray(this.byPositionCategory)) {
            data["byPositionCategory"] = [];
            for (let item of this.byPositionCategory)
                data["byPositionCategory"].push(item.toJSON());
        }
        if (Array.isArray(this.byStatus)) {
            data["byStatus"] = [];
            for (let item of this.byStatus)
                data["byStatus"].push(item.toJSON());
        }
        if (Array.isArray(this.byStage)) {
            data["byStage"] = [];
            for (let item of this.byStage)
                data["byStage"].push(item.toJSON());
        }
        if (Array.isArray(this.approvedByCategory)) {
            data["approvedByCategory"] = [];
            for (let item of this.approvedByCategory)
                data["approvedByCategory"].push(item.toJSON());
        }
        if (Array.isArray(this.byVacancy)) {
            data["byVacancy"] = [];
            for (let item of this.byVacancy)
                data["byVacancy"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChartDataDto {
    bySchoolType: ChartSliceDto[];
    byRegion: ChartBarDto[];
    byPositionCategory: ChartBarDto[];
    byStatus: ChartSliceDto[];
    byStage: ChartBarDto[];
    approvedByCategory: ChartBarDto[];
    byVacancy: ChartBarDto[];
}

export class ChartSliceDto implements IChartSliceDto {
    key!: string;
    count!: number;
    percentage!: number;

    constructor(data?: IChartSliceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.count = _data["count"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): ChartSliceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartSliceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["count"] = this.count;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IChartSliceDto {
    key: string;
    count: number;
    percentage: number;
}

export class ChartBarDto implements IChartBarDto {
    key!: string;
    value?: string | undefined;
    count!: number;

    constructor(data?: IChartBarDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ChartBarDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChartBarDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["count"] = this.count;
        return data;
    }
}

export interface IChartBarDto {
    key: string;
    value?: string | undefined;
    count: number;
}

export class DashboardMetaDto implements IDashboardMetaDto {
    generatedAt!: Date;
    appliedFilters?: DashboardFilterDto | undefined;
    periodFrom!: Date;
    periodTo!: Date;

    constructor(data?: IDashboardMetaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.generatedAt = _data["generatedAt"] ? new Date(_data["generatedAt"].toString()) : <any>undefined;
            this.appliedFilters = _data["appliedFilters"] ? DashboardFilterDto.fromJS(_data["appliedFilters"]) : <any>undefined;
            this.periodFrom = _data["periodFrom"] ? new Date(_data["periodFrom"].toString()) : <any>undefined;
            this.periodTo = _data["periodTo"] ? new Date(_data["periodTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardMetaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardMetaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["generatedAt"] = this.generatedAt ? this.generatedAt.toISOString() : <any>undefined;
        data["appliedFilters"] = this.appliedFilters ? this.appliedFilters.toJSON() : <any>undefined;
        data["periodFrom"] = this.periodFrom ? this.periodFrom.toISOString() : <any>undefined;
        data["periodTo"] = this.periodTo ? this.periodTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDashboardMetaDto {
    generatedAt: Date;
    appliedFilters?: DashboardFilterDto | undefined;
    periodFrom: Date;
    periodTo: Date;
}

export class DashboardFilterDto implements IDashboardFilterDto {
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    regionCode?: number | undefined;
    districtId?: number | undefined;
    spInstitutionTypeId?: number | undefined;
    spInstitutionId?: number | undefined;
    vacancyId?: number | undefined;
    status?: number | undefined;
    orgId?: number | undefined;

    constructor(data?: IDashboardFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.regionCode = _data["regionCode"];
            this.districtId = _data["districtId"];
            this.spInstitutionTypeId = _data["spInstitutionTypeId"];
            this.spInstitutionId = _data["spInstitutionId"];
            this.vacancyId = _data["vacancyId"];
            this.status = _data["status"];
            this.orgId = _data["orgId"];
        }
    }

    static fromJS(data: any): DashboardFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["regionCode"] = this.regionCode;
        data["districtId"] = this.districtId;
        data["spInstitutionTypeId"] = this.spInstitutionTypeId;
        data["spInstitutionId"] = this.spInstitutionId;
        data["vacancyId"] = this.vacancyId;
        data["status"] = this.status;
        data["orgId"] = this.orgId;
        return data;
    }
}

export interface IDashboardFilterDto {
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    regionCode?: number | undefined;
    districtId?: number | undefined;
    spInstitutionTypeId?: number | undefined;
    spInstitutionId?: number | undefined;
    vacancyId?: number | undefined;
    status?: number | undefined;
    orgId?: number | undefined;
}

export class QueryResultOfDrillDownApplicationItemDto implements IQueryResultOfDrillDownApplicationItemDto {
    items!: DrillDownApplicationItemDto[];
    totalItems!: number;

    constructor(data?: IQueryResultOfDrillDownApplicationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DrillDownApplicationItemDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): QueryResultOfDrillDownApplicationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfDrillDownApplicationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IQueryResultOfDrillDownApplicationItemDto {
    items: DrillDownApplicationItemDto[];
    totalItems: number;
}

export class DrillDownApplicationItemDto implements IDrillDownApplicationItemDto {
    id!: number;
    status!: number;
    vacancyId!: number;
    vacancyTitle?: string | undefined;
    createdDate?: Date | undefined;

    constructor(data?: IDrillDownApplicationItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.vacancyId = _data["vacancyId"];
            this.vacancyTitle = _data["vacancyTitle"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DrillDownApplicationItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrillDownApplicationItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["vacancyId"] = this.vacancyId;
        data["vacancyTitle"] = this.vacancyTitle;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDrillDownApplicationItemDto {
    id: number;
    status: number;
    vacancyId: number;
    vacancyTitle?: string | undefined;
    createdDate?: Date | undefined;
}

export class DrillDownFilterDto implements IDrillDownFilterDto {
    filter?: DashboardFilterDto | undefined;
    regionCode?: number | undefined;
    vacancyId?: number | undefined;
    first!: number;
    rows!: number;

    constructor(data?: IDrillDownFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"] ? DashboardFilterDto.fromJS(_data["filter"]) : <any>undefined;
            this.regionCode = _data["regionCode"];
            this.vacancyId = _data["vacancyId"];
            this.first = _data["first"];
            this.rows = _data["rows"];
        }
    }

    static fromJS(data: any): DrillDownFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrillDownFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["regionCode"] = this.regionCode;
        data["vacancyId"] = this.vacancyId;
        data["first"] = this.first;
        data["rows"] = this.rows;
        return data;
    }
}

export interface IDrillDownFilterDto {
    filter?: DashboardFilterDto | undefined;
    regionCode?: number | undefined;
    vacancyId?: number | undefined;
    first: number;
    rows: number;
}

/** This object represents an incoming update.At most one of the optional parameters can be present in any given update. */
export class Update implements IUpdate {
    /** The update's unique identifier. Update identifiers start from a certain positive number and increase sequentially. This identifier becomes especially handy if you're using webhooks, since it allows you to ignore repeated updates or to restore the correct update sequence, should they get out of order. If there are no new updates for at least a week, then identifier of the next update will be chosen randomly instead of sequentially. */
    id!: number;
    /** Optional. New incoming message of any kind - text, photo, sticker, etc. */
    message?: Message | undefined;
    /** Optional. New version of a message that is known to the bot and was edited. This update may at times be triggered by changes to message fields that are either unavailable or not actively used by your bot. */
    editedMessage?: Message | undefined;
    /** Optional. New incoming channel post of any kind - text, photo, sticker, etc. */
    channelPost?: Message | undefined;
    /** Optional. New version of a channel post that is known to the bot and was edited. This update may at times be triggered by changes to message fields that are either unavailable or not actively used by your bot. */
    editedChannelPost?: Message | undefined;
    /** Optional. The bot was connected to or disconnected from a business account, or a user edited an existing connection with the bot */
    businessConnection?: BusinessConnection | undefined;
    /** Optional. New message from a connected business account */
    businessMessage?: Message | undefined;
    /** Optional. New version of a message from a connected business account */
    editedBusinessMessage?: Message | undefined;
    /** Optional. Messages were deleted from a connected business account */
    deletedBusinessMessages?: BusinessMessagesDeleted | undefined;
    /** Optional. A reaction to a message was changed by a user. The bot must be an administrator in the chat and must explicitly specify "MessageReaction" in the list of AllowedUpdates to receive these updates. The update isn't received for reactions set by bots. */
    messageReaction?: MessageReactionUpdated | undefined;
    /** Optional. Reactions to a message with anonymous reactions were changed. The bot must be an administrator in the chat and must explicitly specify "MessageReactionCount" in the list of AllowedUpdates to receive these updates. The updates are grouped and can be sent with delay up to a few minutes. */
    messageReactionCount?: MessageReactionCountUpdated | undefined;
    /** Optional. New incoming inline query */
    inlineQuery?: InlineQuery | undefined;
    /** Optional. The result of an inline query that was chosen by a user and sent to their chat partner. Please see our documentation on the feedback collecting for details on how to enable these updates for your bot. */
    chosenInlineResult?: ChosenInlineResult | undefined;
    /** Optional. New incoming callback query */
    callbackQuery?: CallbackQuery | undefined;
    /** Optional. New incoming shipping query. Only for invoices with flexible price */
    shippingQuery?: ShippingQuery | undefined;
    /** Optional. New incoming pre-checkout query. Contains full information about checkout */
    preCheckoutQuery?: PreCheckoutQuery | undefined;
    /** Optional. A user purchased paid media with a non-empty payload sent by the bot in a non-channel chat */
    purchasedPaidMedia?: PaidMediaPurchased | undefined;
    /** Optional. New poll state. Bots receive only updates about manually stopped polls and polls, which are sent by the bot */
    poll?: Poll | undefined;
    /** Optional. A user changed their answer in a non-anonymous poll. Bots receive new votes only in polls that were sent by the bot itself. */
    pollAnswer?: PollAnswer | undefined;
    /** Optional. The bot's chat member status was updated in a chat. For private chats, this update is received only when the bot is blocked or unblocked by the user. */
    myChatMember?: ChatMemberUpdated | undefined;
    /** Optional. A chat member's status was updated in a chat. The bot must be an administrator in the chat and must explicitly specify "ChatMember" in the list of AllowedUpdates to receive these updates. */
    chatMember?: ChatMemberUpdated | undefined;
    /** Optional. A request to join the chat has been sent. The bot must have the CanInviteUsers administrator right in the chat to receive these updates. */
    chatJoinRequest?: ChatJoinRequest | undefined;
    /** Optional. A chat boost was added or changed. The bot must be an administrator in the chat to receive these updates. */
    chatBoost?: ChatBoostUpdated | undefined;
    /** Optional. A boost was removed from a chat. The bot must be an administrator in the chat to receive these updates. */
    removedChatBoost?: ChatBoostRemoved | undefined;
    /** Gets the type of the Update */
    type!: UpdateType;

    constructor(data?: IUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"] ? Message.fromJS(_data["message"]) : <any>undefined;
            this.editedMessage = _data["editedMessage"] ? Message.fromJS(_data["editedMessage"]) : <any>undefined;
            this.channelPost = _data["channelPost"] ? Message.fromJS(_data["channelPost"]) : <any>undefined;
            this.editedChannelPost = _data["editedChannelPost"] ? Message.fromJS(_data["editedChannelPost"]) : <any>undefined;
            this.businessConnection = _data["businessConnection"] ? BusinessConnection.fromJS(_data["businessConnection"]) : <any>undefined;
            this.businessMessage = _data["businessMessage"] ? Message.fromJS(_data["businessMessage"]) : <any>undefined;
            this.editedBusinessMessage = _data["editedBusinessMessage"] ? Message.fromJS(_data["editedBusinessMessage"]) : <any>undefined;
            this.deletedBusinessMessages = _data["deletedBusinessMessages"] ? BusinessMessagesDeleted.fromJS(_data["deletedBusinessMessages"]) : <any>undefined;
            this.messageReaction = _data["messageReaction"] ? MessageReactionUpdated.fromJS(_data["messageReaction"]) : <any>undefined;
            this.messageReactionCount = _data["messageReactionCount"] ? MessageReactionCountUpdated.fromJS(_data["messageReactionCount"]) : <any>undefined;
            this.inlineQuery = _data["inlineQuery"] ? InlineQuery.fromJS(_data["inlineQuery"]) : <any>undefined;
            this.chosenInlineResult = _data["chosenInlineResult"] ? ChosenInlineResult.fromJS(_data["chosenInlineResult"]) : <any>undefined;
            this.callbackQuery = _data["callbackQuery"] ? CallbackQuery.fromJS(_data["callbackQuery"]) : <any>undefined;
            this.shippingQuery = _data["shippingQuery"] ? ShippingQuery.fromJS(_data["shippingQuery"]) : <any>undefined;
            this.preCheckoutQuery = _data["preCheckoutQuery"] ? PreCheckoutQuery.fromJS(_data["preCheckoutQuery"]) : <any>undefined;
            this.purchasedPaidMedia = _data["purchasedPaidMedia"] ? PaidMediaPurchased.fromJS(_data["purchasedPaidMedia"]) : <any>undefined;
            this.poll = _data["poll"] ? Poll.fromJS(_data["poll"]) : <any>undefined;
            this.pollAnswer = _data["pollAnswer"] ? PollAnswer.fromJS(_data["pollAnswer"]) : <any>undefined;
            this.myChatMember = _data["myChatMember"] ? ChatMemberUpdated.fromJS(_data["myChatMember"]) : <any>undefined;
            this.chatMember = _data["chatMember"] ? ChatMemberUpdated.fromJS(_data["chatMember"]) : <any>undefined;
            this.chatJoinRequest = _data["chatJoinRequest"] ? ChatJoinRequest.fromJS(_data["chatJoinRequest"]) : <any>undefined;
            this.chatBoost = _data["chatBoost"] ? ChatBoostUpdated.fromJS(_data["chatBoost"]) : <any>undefined;
            this.removedChatBoost = _data["removedChatBoost"] ? ChatBoostRemoved.fromJS(_data["removedChatBoost"]) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Update {
        data = typeof data === 'object' ? data : {};
        let result = new Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        data["editedMessage"] = this.editedMessage ? this.editedMessage.toJSON() : <any>undefined;
        data["channelPost"] = this.channelPost ? this.channelPost.toJSON() : <any>undefined;
        data["editedChannelPost"] = this.editedChannelPost ? this.editedChannelPost.toJSON() : <any>undefined;
        data["businessConnection"] = this.businessConnection ? this.businessConnection.toJSON() : <any>undefined;
        data["businessMessage"] = this.businessMessage ? this.businessMessage.toJSON() : <any>undefined;
        data["editedBusinessMessage"] = this.editedBusinessMessage ? this.editedBusinessMessage.toJSON() : <any>undefined;
        data["deletedBusinessMessages"] = this.deletedBusinessMessages ? this.deletedBusinessMessages.toJSON() : <any>undefined;
        data["messageReaction"] = this.messageReaction ? this.messageReaction.toJSON() : <any>undefined;
        data["messageReactionCount"] = this.messageReactionCount ? this.messageReactionCount.toJSON() : <any>undefined;
        data["inlineQuery"] = this.inlineQuery ? this.inlineQuery.toJSON() : <any>undefined;
        data["chosenInlineResult"] = this.chosenInlineResult ? this.chosenInlineResult.toJSON() : <any>undefined;
        data["callbackQuery"] = this.callbackQuery ? this.callbackQuery.toJSON() : <any>undefined;
        data["shippingQuery"] = this.shippingQuery ? this.shippingQuery.toJSON() : <any>undefined;
        data["preCheckoutQuery"] = this.preCheckoutQuery ? this.preCheckoutQuery.toJSON() : <any>undefined;
        data["purchasedPaidMedia"] = this.purchasedPaidMedia ? this.purchasedPaidMedia.toJSON() : <any>undefined;
        data["poll"] = this.poll ? this.poll.toJSON() : <any>undefined;
        data["pollAnswer"] = this.pollAnswer ? this.pollAnswer.toJSON() : <any>undefined;
        data["myChatMember"] = this.myChatMember ? this.myChatMember.toJSON() : <any>undefined;
        data["chatMember"] = this.chatMember ? this.chatMember.toJSON() : <any>undefined;
        data["chatJoinRequest"] = this.chatJoinRequest ? this.chatJoinRequest.toJSON() : <any>undefined;
        data["chatBoost"] = this.chatBoost ? this.chatBoost.toJSON() : <any>undefined;
        data["removedChatBoost"] = this.removedChatBoost ? this.removedChatBoost.toJSON() : <any>undefined;
        data["type"] = this.type;
        return data;
    }
}

/** This object represents an incoming update.At most one of the optional parameters can be present in any given update. */
export interface IUpdate {
    /** The update's unique identifier. Update identifiers start from a certain positive number and increase sequentially. This identifier becomes especially handy if you're using webhooks, since it allows you to ignore repeated updates or to restore the correct update sequence, should they get out of order. If there are no new updates for at least a week, then identifier of the next update will be chosen randomly instead of sequentially. */
    id: number;
    /** Optional. New incoming message of any kind - text, photo, sticker, etc. */
    message?: Message | undefined;
    /** Optional. New version of a message that is known to the bot and was edited. This update may at times be triggered by changes to message fields that are either unavailable or not actively used by your bot. */
    editedMessage?: Message | undefined;
    /** Optional. New incoming channel post of any kind - text, photo, sticker, etc. */
    channelPost?: Message | undefined;
    /** Optional. New version of a channel post that is known to the bot and was edited. This update may at times be triggered by changes to message fields that are either unavailable or not actively used by your bot. */
    editedChannelPost?: Message | undefined;
    /** Optional. The bot was connected to or disconnected from a business account, or a user edited an existing connection with the bot */
    businessConnection?: BusinessConnection | undefined;
    /** Optional. New message from a connected business account */
    businessMessage?: Message | undefined;
    /** Optional. New version of a message from a connected business account */
    editedBusinessMessage?: Message | undefined;
    /** Optional. Messages were deleted from a connected business account */
    deletedBusinessMessages?: BusinessMessagesDeleted | undefined;
    /** Optional. A reaction to a message was changed by a user. The bot must be an administrator in the chat and must explicitly specify "MessageReaction" in the list of AllowedUpdates to receive these updates. The update isn't received for reactions set by bots. */
    messageReaction?: MessageReactionUpdated | undefined;
    /** Optional. Reactions to a message with anonymous reactions were changed. The bot must be an administrator in the chat and must explicitly specify "MessageReactionCount" in the list of AllowedUpdates to receive these updates. The updates are grouped and can be sent with delay up to a few minutes. */
    messageReactionCount?: MessageReactionCountUpdated | undefined;
    /** Optional. New incoming inline query */
    inlineQuery?: InlineQuery | undefined;
    /** Optional. The result of an inline query that was chosen by a user and sent to their chat partner. Please see our documentation on the feedback collecting for details on how to enable these updates for your bot. */
    chosenInlineResult?: ChosenInlineResult | undefined;
    /** Optional. New incoming callback query */
    callbackQuery?: CallbackQuery | undefined;
    /** Optional. New incoming shipping query. Only for invoices with flexible price */
    shippingQuery?: ShippingQuery | undefined;
    /** Optional. New incoming pre-checkout query. Contains full information about checkout */
    preCheckoutQuery?: PreCheckoutQuery | undefined;
    /** Optional. A user purchased paid media with a non-empty payload sent by the bot in a non-channel chat */
    purchasedPaidMedia?: PaidMediaPurchased | undefined;
    /** Optional. New poll state. Bots receive only updates about manually stopped polls and polls, which are sent by the bot */
    poll?: Poll | undefined;
    /** Optional. A user changed their answer in a non-anonymous poll. Bots receive new votes only in polls that were sent by the bot itself. */
    pollAnswer?: PollAnswer | undefined;
    /** Optional. The bot's chat member status was updated in a chat. For private chats, this update is received only when the bot is blocked or unblocked by the user. */
    myChatMember?: ChatMemberUpdated | undefined;
    /** Optional. A chat member's status was updated in a chat. The bot must be an administrator in the chat and must explicitly specify "ChatMember" in the list of AllowedUpdates to receive these updates. */
    chatMember?: ChatMemberUpdated | undefined;
    /** Optional. A request to join the chat has been sent. The bot must have the CanInviteUsers administrator right in the chat to receive these updates. */
    chatJoinRequest?: ChatJoinRequest | undefined;
    /** Optional. A chat boost was added or changed. The bot must be an administrator in the chat to receive these updates. */
    chatBoost?: ChatBoostUpdated | undefined;
    /** Optional. A boost was removed from a chat. The bot must be an administrator in the chat to receive these updates. */
    removedChatBoost?: ChatBoostRemoved | undefined;
    /** Gets the type of the Update */
    type: UpdateType;
}

/** This object represents a message. */
export class Message implements IMessage {
    /** Same as Id */
    messageId!: number;
    /** Optional. For forwarded messages, sender of the original message */
    forwardFrom?: User | undefined;
    /** Optional. For messages forwarded from channels or from anonymous administrators, information about the original sender chat */
    forwardFromChat?: Chat | undefined;
    /** Optional. For messages forwarded from channels, identifier of the original message in the channel */
    forwardFromMessageId?: number | undefined;
    /** Optional. For messages forwarded from channels, signature of the post author if present */
    forwardSignature?: string | undefined;
    /** Optional. Sender's name for messages forwarded from users who disallow adding a link to their account in forwarded messages */
    forwardSenderName?: string | undefined;
    /** Optional. For forwarded messages, date the original message was sent */
    forwardDate?: Date | undefined;
    /** Gets the entity values. */
    entityValues?: string[] | undefined;
    /** Gets the caption entity values. */
    captionEntityValues?: string[] | undefined;
    /** Unique message identifier inside this chat. In specific instances (e.g., message containing a video sent to a big chat), the server might automatically schedule a message instead of sending it immediately. In such cases, this field will be 0 and the relevant message will be unusable until it is actually sent */
    id!: number;
    /** Optional. Unique identifier of a message thread to which the message belongs; for supergroups only */
    messageThreadId?: number | undefined;
    /** Optional. Sender of the message; may be empty for messages sent to channels. For backward compatibility, if the message was sent on behalf of a chat, the field contains a fake sender user in non-channel chats */
    from?: User | undefined;
    /** Optional. Sender of the message when sent on behalf of a chat. For example, the supergroup itself for messages sent by its anonymous administrators or a linked channel for messages automatically forwarded to the channel's discussion group. For backward compatibility, if the message was sent on behalf of a chat, the field From contains a fake sender user in non-channel chats. */
    senderChat?: Chat | undefined;
    /** Optional. If the sender of the message boosted the chat, the number of boosts added by the user */
    senderBoostCount?: number | undefined;
    /** Optional. The bot that actually sent the message on behalf of the business account. Available only for outgoing messages sent on behalf of the connected business account. */
    senderBusinessBot?: User | undefined;
    /** Date the message was sent. It is always a valid date. */
    date!: Date;
    /** Optional. Unique identifier of the business connection from which the message was received. If non-empty, the message belongs to a chat of the corresponding business account that is independent from any potential bot chat which might share the same identifier. */
    businessConnectionId?: string | undefined;
    /** Chat the message belongs to */
    chat!: Chat;
    /** Optional. Information about the original message for forwarded messages */
    forwardOrigin?: MessageOrigin | undefined;
    /** Optional. true, if the message is sent to a forum topic */
    isTopicMessage!: boolean;
    /** Optional. true, if the message is a channel post that was automatically forwarded to the connected discussion group */
    isAutomaticForward!: boolean;
    /** Optional. For replies in the same chat and message thread, the original message. Note that the Message object in this field will not contain further ReplyToMessage fields even if it itself is a reply. */
    replyToMessage?: Message | undefined;
    /** Optional. Information about the message that is being replied to, which may come from another chat or forum topic */
    externalReply?: ExternalReplyInfo | undefined;
    /** Optional. For replies that quote part of the original message, the quoted part of the message */
    quote?: TextQuote | undefined;
    /** Optional. For replies to a story, the original story */
    replyToStory?: Story | undefined;
    /** Optional. Bot through which the message was sent */
    viaBot?: User | undefined;
    /** Optional. Date the message was last edited */
    editDate?: Date | undefined;
    /** Optional. true, if the message can't be forwarded */
    hasProtectedContent!: boolean;
    /** Optional. true, if the message was sent by an implicit action, for example, as an away or a greeting business message, or as a scheduled message */
    isFromOffline!: boolean;
    /** Optional. The unique identifier of a media message group this message belongs to */
    mediaGroupId?: string | undefined;
    /** Optional. Signature of the post author for messages in channels, or the custom title of an anonymous group administrator */
    authorSignature?: string | undefined;
    /** Optional. For text messages, the actual text of the message */
    text?: string | undefined;
    /** Optional. For text messages, special entities like usernames, URLs, bot commands, etc. that appear in the text */
    entities?: MessageEntity[] | undefined;
    /** Optional. Options used for link preview generation for the message, if it is a text message and link preview options were changed */
    linkPreviewOptions?: LinkPreviewOptions | undefined;
    /** Optional. Unique identifier of the message effect added to the message */
    effectId?: string | undefined;
    /** Optional. Message is an animation, information about the animation. For backward compatibility, when this field is set, the Document field will also be set */
    animation?: Animation | undefined;
    /** Optional. Message is an audio file, information about the file */
    audio?: Audio | undefined;
    /** Optional. Message is a general file, information about the file */
    document?: Document | undefined;
    /** Optional. Message contains paid media; information about the paid media */
    paidMedia?: PaidMediaInfo | undefined;
    /** Optional. Message is a photo, available sizes of the photo */
    photo?: PhotoSize[] | undefined;
    /** Optional. Message is a sticker, information about the sticker */
    sticker?: Sticker | undefined;
    /** Optional. Message is a forwarded story */
    story?: Story | undefined;
    /** Optional. Message is a video, information about the video */
    video?: Video | undefined;
    /** Optional. Message is a video note, information about the video message */
    videoNote?: VideoNote | undefined;
    /** Optional. Message is a voice message, information about the file */
    voice?: Voice | undefined;
    /** Optional. Caption for the animation, audio, document, paid media, photo, video or voice */
    caption?: string | undefined;
    /** Optional. For messages with a caption, special entities like usernames, URLs, bot commands, etc. that appear in the caption */
    captionEntities?: MessageEntity[] | undefined;
    /** Optional. true, if the caption must be shown above the message media */
    showCaptionAboveMedia!: boolean;
    /** Optional. true, if the message media is covered by a spoiler animation */
    hasMediaSpoiler!: boolean;
    /** Optional. Message is a shared contact, information about the contact */
    contact?: Contact | undefined;
    /** Optional. Message is a dice with random value */
    dice?: Dice | undefined;
    /** Optional. Message is a game, information about the game. More about games » */
    game?: Game | undefined;
    /** Optional. Message is a native poll, information about the poll */
    poll?: Poll | undefined;
    /** Optional. Message is a venue, information about the venue. For backward compatibility, when this field is set, the Location field will also be set */
    venue?: Venue | undefined;
    /** Optional. Message is a shared location, information about the location */
    location?: Location | undefined;
    /** Optional. New members that were added to the group or supergroup and information about them (the bot itself may be one of these members) */
    newChatMembers?: User[] | undefined;
    /** Optional. A member was removed from the group, information about them (this member may be the bot itself) */
    leftChatMember?: User | undefined;
    /** Optional. A chat title was changed to this value */
    newChatTitle?: string | undefined;
    /** Optional. A chat photo was change to this value */
    newChatPhoto?: PhotoSize[] | undefined;
    /** Optional. Service message: the chat photo was deleted */
    deleteChatPhoto?: boolean | undefined;
    /** Optional. Service message: the group has been created */
    groupChatCreated?: boolean | undefined;
    /** Optional. Service message: the supergroup has been created. This field can't be received in a message coming through updates, because bot can't be a member of a supergroup when it is created. It can only be found in ReplyToMessage if someone replies to a very first message in a directly created supergroup. */
    supergroupChatCreated?: boolean | undefined;
    /** Optional. Service message: the channel has been created. This field can't be received in a message coming through updates, because bot can't be a member of a channel when it is created. It can only be found in ReplyToMessage if someone replies to a very first message in a channel. */
    channelChatCreated?: boolean | undefined;
    /** Optional. Service message: auto-delete timer settings changed in the chat */
    messageAutoDeleteTimerChanged?: MessageAutoDeleteTimerChanged | undefined;
    /** Optional. The group has been migrated to a supergroup with the specified identifier. */
    migrateToChatId?: number | undefined;
    /** Optional. The supergroup has been migrated from a group with the specified identifier. */
    migrateFromChatId?: number | undefined;
    /** Optional. Specified message was pinned. Note that the Message object in this field will not contain further ReplyToMessage fields even if it itself is a reply. */
    pinnedMessage?: Message | undefined;
    /** Optional. Message is an invoice for a payment, information about the invoice. More about payments » */
    invoice?: Invoice | undefined;
    /** Optional. Message is a service message about a successful payment, information about the payment. More about payments » */
    successfulPayment?: SuccessfulPayment | undefined;
    /** Optional. Message is a service message about a refunded payment, information about the payment. More about payments » */
    refundedPayment?: RefundedPayment | undefined;
    /** Optional. Service message: users were shared with the bot */
    usersShared?: UsersShared | undefined;
    /** Optional. Service message: a chat was shared with the bot */
    chatShared?: ChatShared | undefined;
    /** Optional. The domain name of the website on which the user has logged in. More about Telegram Login » */
    connectedWebsite?: string | undefined;
    /** Optional. Service message: the user allowed the bot to write messages after adding it to the attachment or side menu, launching a Web App from a link, or accepting an explicit request from a Web App sent by the method requestWriteAccess */
    writeAccessAllowed?: WriteAccessAllowed | undefined;
    /** Optional. Telegram Passport data */
    passportData?: PassportData2 | undefined;
    /** Optional. Service message. A user in the chat triggered another user's proximity alert while sharing Live Location. */
    proximityAlertTriggered?: ProximityAlertTriggered | undefined;
    /** Optional. Service message: user boosted the chat */
    boostAdded?: ChatBoostAdded | undefined;
    /** Optional. Service message: chat background set */
    chatBackgroundSet?: ChatBackground | undefined;
    /** Optional. Service message: forum topic created */
    forumTopicCreated?: ForumTopicCreated | undefined;
    /** Optional. Service message: forum topic edited */
    forumTopicEdited?: ForumTopicEdited | undefined;
    /** Optional. Service message: forum topic closed */
    forumTopicClosed?: ForumTopicClosed | undefined;
    /** Optional. Service message: forum topic reopened */
    forumTopicReopened?: ForumTopicReopened | undefined;
    /** Optional. Service message: the 'General' forum topic hidden */
    generalForumTopicHidden?: GeneralForumTopicHidden | undefined;
    /** Optional. Service message: the 'General' forum topic unhidden */
    generalForumTopicUnhidden?: GeneralForumTopicUnhidden | undefined;
    /** Optional. Service message: a scheduled giveaway was created */
    giveawayCreated?: GiveawayCreated | undefined;
    /** Optional. The message is a scheduled giveaway message */
    giveaway?: Giveaway | undefined;
    /** Optional. A giveaway with public winners was completed */
    giveawayWinners?: GiveawayWinners | undefined;
    /** Optional. Service message: a giveaway without public winners was completed */
    giveawayCompleted?: GiveawayCompleted | undefined;
    /** Optional. Service message: video chat scheduled */
    videoChatScheduled?: VideoChatScheduled | undefined;
    /** Optional. Service message: video chat started */
    videoChatStarted?: VideoChatStarted | undefined;
    /** Optional. Service message: video chat ended */
    videoChatEnded?: VideoChatEnded | undefined;
    /** Optional. Service message: new participants invited to a video chat */
    videoChatParticipantsInvited?: VideoChatParticipantsInvited | undefined;
    /** Optional. Service message: data sent by a Web App */
    webAppData?: WebAppData | undefined;
    /** Optional. Inline keyboard attached to the message. LoginUrl buttons are represented as ordinary url buttons. */
    replyMarkup?: InlineKeyboardMarkup | undefined;
    /** Gets the type of the Message */
    type!: MessageType;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chat = new Chat();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.forwardFrom = _data["forwardFrom"] ? User.fromJS(_data["forwardFrom"]) : <any>undefined;
            this.forwardFromChat = _data["forwardFromChat"] ? Chat.fromJS(_data["forwardFromChat"]) : <any>undefined;
            this.forwardFromMessageId = _data["forwardFromMessageId"];
            this.forwardSignature = _data["forwardSignature"];
            this.forwardSenderName = _data["forwardSenderName"];
            this.forwardDate = _data["forwardDate"] ? new Date(_data["forwardDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["entityValues"])) {
                this.entityValues = [] as any;
                for (let item of _data["entityValues"])
                    this.entityValues!.push(item);
            }
            if (Array.isArray(_data["captionEntityValues"])) {
                this.captionEntityValues = [] as any;
                for (let item of _data["captionEntityValues"])
                    this.captionEntityValues!.push(item);
            }
            this.id = _data["id"];
            this.messageThreadId = _data["messageThreadId"];
            this.from = _data["from"] ? User.fromJS(_data["from"]) : <any>undefined;
            this.senderChat = _data["senderChat"] ? Chat.fromJS(_data["senderChat"]) : <any>undefined;
            this.senderBoostCount = _data["senderBoostCount"];
            this.senderBusinessBot = _data["senderBusinessBot"] ? User.fromJS(_data["senderBusinessBot"]) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.businessConnectionId = _data["businessConnectionId"];
            this.chat = _data["chat"] ? Chat.fromJS(_data["chat"]) : new Chat();
            this.forwardOrigin = _data["forwardOrigin"] ? MessageOrigin.fromJS(_data["forwardOrigin"]) : <any>undefined;
            this.isTopicMessage = _data["isTopicMessage"];
            this.isAutomaticForward = _data["isAutomaticForward"];
            this.replyToMessage = _data["replyToMessage"] ? Message.fromJS(_data["replyToMessage"]) : <any>undefined;
            this.externalReply = _data["externalReply"] ? ExternalReplyInfo.fromJS(_data["externalReply"]) : <any>undefined;
            this.quote = _data["quote"] ? TextQuote.fromJS(_data["quote"]) : <any>undefined;
            this.replyToStory = _data["replyToStory"] ? Story.fromJS(_data["replyToStory"]) : <any>undefined;
            this.viaBot = _data["viaBot"] ? User.fromJS(_data["viaBot"]) : <any>undefined;
            this.editDate = _data["editDate"] ? new Date(_data["editDate"].toString()) : <any>undefined;
            this.hasProtectedContent = _data["hasProtectedContent"];
            this.isFromOffline = _data["isFromOffline"];
            this.mediaGroupId = _data["mediaGroupId"];
            this.authorSignature = _data["authorSignature"];
            this.text = _data["text"];
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(MessageEntity.fromJS(item));
            }
            this.linkPreviewOptions = _data["linkPreviewOptions"] ? LinkPreviewOptions.fromJS(_data["linkPreviewOptions"]) : <any>undefined;
            this.effectId = _data["effectId"];
            this.animation = _data["animation"] ? Animation.fromJS(_data["animation"]) : <any>undefined;
            this.audio = _data["audio"] ? Audio.fromJS(_data["audio"]) : <any>undefined;
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.paidMedia = _data["paidMedia"] ? PaidMediaInfo.fromJS(_data["paidMedia"]) : <any>undefined;
            if (Array.isArray(_data["photo"])) {
                this.photo = [] as any;
                for (let item of _data["photo"])
                    this.photo!.push(PhotoSize.fromJS(item));
            }
            this.sticker = _data["sticker"] ? Sticker.fromJS(_data["sticker"]) : <any>undefined;
            this.story = _data["story"] ? Story.fromJS(_data["story"]) : <any>undefined;
            this.video = _data["video"] ? Video.fromJS(_data["video"]) : <any>undefined;
            this.videoNote = _data["videoNote"] ? VideoNote.fromJS(_data["videoNote"]) : <any>undefined;
            this.voice = _data["voice"] ? Voice.fromJS(_data["voice"]) : <any>undefined;
            this.caption = _data["caption"];
            if (Array.isArray(_data["captionEntities"])) {
                this.captionEntities = [] as any;
                for (let item of _data["captionEntities"])
                    this.captionEntities!.push(MessageEntity.fromJS(item));
            }
            this.showCaptionAboveMedia = _data["showCaptionAboveMedia"];
            this.hasMediaSpoiler = _data["hasMediaSpoiler"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.dice = _data["dice"] ? Dice.fromJS(_data["dice"]) : <any>undefined;
            this.game = _data["game"] ? Game.fromJS(_data["game"]) : <any>undefined;
            this.poll = _data["poll"] ? Poll.fromJS(_data["poll"]) : <any>undefined;
            this.venue = _data["venue"] ? Venue.fromJS(_data["venue"]) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            if (Array.isArray(_data["newChatMembers"])) {
                this.newChatMembers = [] as any;
                for (let item of _data["newChatMembers"])
                    this.newChatMembers!.push(User.fromJS(item));
            }
            this.leftChatMember = _data["leftChatMember"] ? User.fromJS(_data["leftChatMember"]) : <any>undefined;
            this.newChatTitle = _data["newChatTitle"];
            if (Array.isArray(_data["newChatPhoto"])) {
                this.newChatPhoto = [] as any;
                for (let item of _data["newChatPhoto"])
                    this.newChatPhoto!.push(PhotoSize.fromJS(item));
            }
            this.deleteChatPhoto = _data["deleteChatPhoto"];
            this.groupChatCreated = _data["groupChatCreated"];
            this.supergroupChatCreated = _data["supergroupChatCreated"];
            this.channelChatCreated = _data["channelChatCreated"];
            this.messageAutoDeleteTimerChanged = _data["messageAutoDeleteTimerChanged"] ? MessageAutoDeleteTimerChanged.fromJS(_data["messageAutoDeleteTimerChanged"]) : <any>undefined;
            this.migrateToChatId = _data["migrateToChatId"];
            this.migrateFromChatId = _data["migrateFromChatId"];
            this.pinnedMessage = _data["pinnedMessage"] ? Message.fromJS(_data["pinnedMessage"]) : <any>undefined;
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.successfulPayment = _data["successfulPayment"] ? SuccessfulPayment.fromJS(_data["successfulPayment"]) : <any>undefined;
            this.refundedPayment = _data["refundedPayment"] ? RefundedPayment.fromJS(_data["refundedPayment"]) : <any>undefined;
            this.usersShared = _data["usersShared"] ? UsersShared.fromJS(_data["usersShared"]) : <any>undefined;
            this.chatShared = _data["chatShared"] ? ChatShared.fromJS(_data["chatShared"]) : <any>undefined;
            this.connectedWebsite = _data["connectedWebsite"];
            this.writeAccessAllowed = _data["writeAccessAllowed"] ? WriteAccessAllowed.fromJS(_data["writeAccessAllowed"]) : <any>undefined;
            this.passportData = _data["passportData"] ? PassportData2.fromJS(_data["passportData"]) : <any>undefined;
            this.proximityAlertTriggered = _data["proximityAlertTriggered"] ? ProximityAlertTriggered.fromJS(_data["proximityAlertTriggered"]) : <any>undefined;
            this.boostAdded = _data["boostAdded"] ? ChatBoostAdded.fromJS(_data["boostAdded"]) : <any>undefined;
            this.chatBackgroundSet = _data["chatBackgroundSet"] ? ChatBackground.fromJS(_data["chatBackgroundSet"]) : <any>undefined;
            this.forumTopicCreated = _data["forumTopicCreated"] ? ForumTopicCreated.fromJS(_data["forumTopicCreated"]) : <any>undefined;
            this.forumTopicEdited = _data["forumTopicEdited"] ? ForumTopicEdited.fromJS(_data["forumTopicEdited"]) : <any>undefined;
            this.forumTopicClosed = _data["forumTopicClosed"] ? ForumTopicClosed.fromJS(_data["forumTopicClosed"]) : <any>undefined;
            this.forumTopicReopened = _data["forumTopicReopened"] ? ForumTopicReopened.fromJS(_data["forumTopicReopened"]) : <any>undefined;
            this.generalForumTopicHidden = _data["generalForumTopicHidden"] ? GeneralForumTopicHidden.fromJS(_data["generalForumTopicHidden"]) : <any>undefined;
            this.generalForumTopicUnhidden = _data["generalForumTopicUnhidden"] ? GeneralForumTopicUnhidden.fromJS(_data["generalForumTopicUnhidden"]) : <any>undefined;
            this.giveawayCreated = _data["giveawayCreated"] ? GiveawayCreated.fromJS(_data["giveawayCreated"]) : <any>undefined;
            this.giveaway = _data["giveaway"] ? Giveaway.fromJS(_data["giveaway"]) : <any>undefined;
            this.giveawayWinners = _data["giveawayWinners"] ? GiveawayWinners.fromJS(_data["giveawayWinners"]) : <any>undefined;
            this.giveawayCompleted = _data["giveawayCompleted"] ? GiveawayCompleted.fromJS(_data["giveawayCompleted"]) : <any>undefined;
            this.videoChatScheduled = _data["videoChatScheduled"] ? VideoChatScheduled.fromJS(_data["videoChatScheduled"]) : <any>undefined;
            this.videoChatStarted = _data["videoChatStarted"] ? VideoChatStarted.fromJS(_data["videoChatStarted"]) : <any>undefined;
            this.videoChatEnded = _data["videoChatEnded"] ? VideoChatEnded.fromJS(_data["videoChatEnded"]) : <any>undefined;
            this.videoChatParticipantsInvited = _data["videoChatParticipantsInvited"] ? VideoChatParticipantsInvited.fromJS(_data["videoChatParticipantsInvited"]) : <any>undefined;
            this.webAppData = _data["webAppData"] ? WebAppData.fromJS(_data["webAppData"]) : <any>undefined;
            this.replyMarkup = _data["replyMarkup"] ? InlineKeyboardMarkup.fromJS(_data["replyMarkup"]) : <any>undefined;
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["forwardFrom"] = this.forwardFrom ? this.forwardFrom.toJSON() : <any>undefined;
        data["forwardFromChat"] = this.forwardFromChat ? this.forwardFromChat.toJSON() : <any>undefined;
        data["forwardFromMessageId"] = this.forwardFromMessageId;
        data["forwardSignature"] = this.forwardSignature;
        data["forwardSenderName"] = this.forwardSenderName;
        data["forwardDate"] = this.forwardDate ? this.forwardDate.toISOString() : <any>undefined;
        if (Array.isArray(this.entityValues)) {
            data["entityValues"] = [];
            for (let item of this.entityValues)
                data["entityValues"].push(item);
        }
        if (Array.isArray(this.captionEntityValues)) {
            data["captionEntityValues"] = [];
            for (let item of this.captionEntityValues)
                data["captionEntityValues"].push(item);
        }
        data["id"] = this.id;
        data["messageThreadId"] = this.messageThreadId;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["senderChat"] = this.senderChat ? this.senderChat.toJSON() : <any>undefined;
        data["senderBoostCount"] = this.senderBoostCount;
        data["senderBusinessBot"] = this.senderBusinessBot ? this.senderBusinessBot.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["businessConnectionId"] = this.businessConnectionId;
        data["chat"] = this.chat ? this.chat.toJSON() : <any>undefined;
        data["forwardOrigin"] = this.forwardOrigin ? this.forwardOrigin.toJSON() : <any>undefined;
        data["isTopicMessage"] = this.isTopicMessage;
        data["isAutomaticForward"] = this.isAutomaticForward;
        data["replyToMessage"] = this.replyToMessage ? this.replyToMessage.toJSON() : <any>undefined;
        data["externalReply"] = this.externalReply ? this.externalReply.toJSON() : <any>undefined;
        data["quote"] = this.quote ? this.quote.toJSON() : <any>undefined;
        data["replyToStory"] = this.replyToStory ? this.replyToStory.toJSON() : <any>undefined;
        data["viaBot"] = this.viaBot ? this.viaBot.toJSON() : <any>undefined;
        data["editDate"] = this.editDate ? this.editDate.toISOString() : <any>undefined;
        data["hasProtectedContent"] = this.hasProtectedContent;
        data["isFromOffline"] = this.isFromOffline;
        data["mediaGroupId"] = this.mediaGroupId;
        data["authorSignature"] = this.authorSignature;
        data["text"] = this.text;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        data["linkPreviewOptions"] = this.linkPreviewOptions ? this.linkPreviewOptions.toJSON() : <any>undefined;
        data["effectId"] = this.effectId;
        data["animation"] = this.animation ? this.animation.toJSON() : <any>undefined;
        data["audio"] = this.audio ? this.audio.toJSON() : <any>undefined;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["paidMedia"] = this.paidMedia ? this.paidMedia.toJSON() : <any>undefined;
        if (Array.isArray(this.photo)) {
            data["photo"] = [];
            for (let item of this.photo)
                data["photo"].push(item.toJSON());
        }
        data["sticker"] = this.sticker ? this.sticker.toJSON() : <any>undefined;
        data["story"] = this.story ? this.story.toJSON() : <any>undefined;
        data["video"] = this.video ? this.video.toJSON() : <any>undefined;
        data["videoNote"] = this.videoNote ? this.videoNote.toJSON() : <any>undefined;
        data["voice"] = this.voice ? this.voice.toJSON() : <any>undefined;
        data["caption"] = this.caption;
        if (Array.isArray(this.captionEntities)) {
            data["captionEntities"] = [];
            for (let item of this.captionEntities)
                data["captionEntities"].push(item.toJSON());
        }
        data["showCaptionAboveMedia"] = this.showCaptionAboveMedia;
        data["hasMediaSpoiler"] = this.hasMediaSpoiler;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["dice"] = this.dice ? this.dice.toJSON() : <any>undefined;
        data["game"] = this.game ? this.game.toJSON() : <any>undefined;
        data["poll"] = this.poll ? this.poll.toJSON() : <any>undefined;
        data["venue"] = this.venue ? this.venue.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        if (Array.isArray(this.newChatMembers)) {
            data["newChatMembers"] = [];
            for (let item of this.newChatMembers)
                data["newChatMembers"].push(item.toJSON());
        }
        data["leftChatMember"] = this.leftChatMember ? this.leftChatMember.toJSON() : <any>undefined;
        data["newChatTitle"] = this.newChatTitle;
        if (Array.isArray(this.newChatPhoto)) {
            data["newChatPhoto"] = [];
            for (let item of this.newChatPhoto)
                data["newChatPhoto"].push(item.toJSON());
        }
        data["deleteChatPhoto"] = this.deleteChatPhoto;
        data["groupChatCreated"] = this.groupChatCreated;
        data["supergroupChatCreated"] = this.supergroupChatCreated;
        data["channelChatCreated"] = this.channelChatCreated;
        data["messageAutoDeleteTimerChanged"] = this.messageAutoDeleteTimerChanged ? this.messageAutoDeleteTimerChanged.toJSON() : <any>undefined;
        data["migrateToChatId"] = this.migrateToChatId;
        data["migrateFromChatId"] = this.migrateFromChatId;
        data["pinnedMessage"] = this.pinnedMessage ? this.pinnedMessage.toJSON() : <any>undefined;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["successfulPayment"] = this.successfulPayment ? this.successfulPayment.toJSON() : <any>undefined;
        data["refundedPayment"] = this.refundedPayment ? this.refundedPayment.toJSON() : <any>undefined;
        data["usersShared"] = this.usersShared ? this.usersShared.toJSON() : <any>undefined;
        data["chatShared"] = this.chatShared ? this.chatShared.toJSON() : <any>undefined;
        data["connectedWebsite"] = this.connectedWebsite;
        data["writeAccessAllowed"] = this.writeAccessAllowed ? this.writeAccessAllowed.toJSON() : <any>undefined;
        data["passportData"] = this.passportData ? this.passportData.toJSON() : <any>undefined;
        data["proximityAlertTriggered"] = this.proximityAlertTriggered ? this.proximityAlertTriggered.toJSON() : <any>undefined;
        data["boostAdded"] = this.boostAdded ? this.boostAdded.toJSON() : <any>undefined;
        data["chatBackgroundSet"] = this.chatBackgroundSet ? this.chatBackgroundSet.toJSON() : <any>undefined;
        data["forumTopicCreated"] = this.forumTopicCreated ? this.forumTopicCreated.toJSON() : <any>undefined;
        data["forumTopicEdited"] = this.forumTopicEdited ? this.forumTopicEdited.toJSON() : <any>undefined;
        data["forumTopicClosed"] = this.forumTopicClosed ? this.forumTopicClosed.toJSON() : <any>undefined;
        data["forumTopicReopened"] = this.forumTopicReopened ? this.forumTopicReopened.toJSON() : <any>undefined;
        data["generalForumTopicHidden"] = this.generalForumTopicHidden ? this.generalForumTopicHidden.toJSON() : <any>undefined;
        data["generalForumTopicUnhidden"] = this.generalForumTopicUnhidden ? this.generalForumTopicUnhidden.toJSON() : <any>undefined;
        data["giveawayCreated"] = this.giveawayCreated ? this.giveawayCreated.toJSON() : <any>undefined;
        data["giveaway"] = this.giveaway ? this.giveaway.toJSON() : <any>undefined;
        data["giveawayWinners"] = this.giveawayWinners ? this.giveawayWinners.toJSON() : <any>undefined;
        data["giveawayCompleted"] = this.giveawayCompleted ? this.giveawayCompleted.toJSON() : <any>undefined;
        data["videoChatScheduled"] = this.videoChatScheduled ? this.videoChatScheduled.toJSON() : <any>undefined;
        data["videoChatStarted"] = this.videoChatStarted ? this.videoChatStarted.toJSON() : <any>undefined;
        data["videoChatEnded"] = this.videoChatEnded ? this.videoChatEnded.toJSON() : <any>undefined;
        data["videoChatParticipantsInvited"] = this.videoChatParticipantsInvited ? this.videoChatParticipantsInvited.toJSON() : <any>undefined;
        data["webAppData"] = this.webAppData ? this.webAppData.toJSON() : <any>undefined;
        data["replyMarkup"] = this.replyMarkup ? this.replyMarkup.toJSON() : <any>undefined;
        data["type"] = this.type;
        return data;
    }
}

/** This object represents a message. */
export interface IMessage {
    /** Same as Id */
    messageId: number;
    /** Optional. For forwarded messages, sender of the original message */
    forwardFrom?: User | undefined;
    /** Optional. For messages forwarded from channels or from anonymous administrators, information about the original sender chat */
    forwardFromChat?: Chat | undefined;
    /** Optional. For messages forwarded from channels, identifier of the original message in the channel */
    forwardFromMessageId?: number | undefined;
    /** Optional. For messages forwarded from channels, signature of the post author if present */
    forwardSignature?: string | undefined;
    /** Optional. Sender's name for messages forwarded from users who disallow adding a link to their account in forwarded messages */
    forwardSenderName?: string | undefined;
    /** Optional. For forwarded messages, date the original message was sent */
    forwardDate?: Date | undefined;
    /** Gets the entity values. */
    entityValues?: string[] | undefined;
    /** Gets the caption entity values. */
    captionEntityValues?: string[] | undefined;
    /** Unique message identifier inside this chat. In specific instances (e.g., message containing a video sent to a big chat), the server might automatically schedule a message instead of sending it immediately. In such cases, this field will be 0 and the relevant message will be unusable until it is actually sent */
    id: number;
    /** Optional. Unique identifier of a message thread to which the message belongs; for supergroups only */
    messageThreadId?: number | undefined;
    /** Optional. Sender of the message; may be empty for messages sent to channels. For backward compatibility, if the message was sent on behalf of a chat, the field contains a fake sender user in non-channel chats */
    from?: User | undefined;
    /** Optional. Sender of the message when sent on behalf of a chat. For example, the supergroup itself for messages sent by its anonymous administrators or a linked channel for messages automatically forwarded to the channel's discussion group. For backward compatibility, if the message was sent on behalf of a chat, the field From contains a fake sender user in non-channel chats. */
    senderChat?: Chat | undefined;
    /** Optional. If the sender of the message boosted the chat, the number of boosts added by the user */
    senderBoostCount?: number | undefined;
    /** Optional. The bot that actually sent the message on behalf of the business account. Available only for outgoing messages sent on behalf of the connected business account. */
    senderBusinessBot?: User | undefined;
    /** Date the message was sent. It is always a valid date. */
    date: Date;
    /** Optional. Unique identifier of the business connection from which the message was received. If non-empty, the message belongs to a chat of the corresponding business account that is independent from any potential bot chat which might share the same identifier. */
    businessConnectionId?: string | undefined;
    /** Chat the message belongs to */
    chat: Chat;
    /** Optional. Information about the original message for forwarded messages */
    forwardOrigin?: MessageOrigin | undefined;
    /** Optional. true, if the message is sent to a forum topic */
    isTopicMessage: boolean;
    /** Optional. true, if the message is a channel post that was automatically forwarded to the connected discussion group */
    isAutomaticForward: boolean;
    /** Optional. For replies in the same chat and message thread, the original message. Note that the Message object in this field will not contain further ReplyToMessage fields even if it itself is a reply. */
    replyToMessage?: Message | undefined;
    /** Optional. Information about the message that is being replied to, which may come from another chat or forum topic */
    externalReply?: ExternalReplyInfo | undefined;
    /** Optional. For replies that quote part of the original message, the quoted part of the message */
    quote?: TextQuote | undefined;
    /** Optional. For replies to a story, the original story */
    replyToStory?: Story | undefined;
    /** Optional. Bot through which the message was sent */
    viaBot?: User | undefined;
    /** Optional. Date the message was last edited */
    editDate?: Date | undefined;
    /** Optional. true, if the message can't be forwarded */
    hasProtectedContent: boolean;
    /** Optional. true, if the message was sent by an implicit action, for example, as an away or a greeting business message, or as a scheduled message */
    isFromOffline: boolean;
    /** Optional. The unique identifier of a media message group this message belongs to */
    mediaGroupId?: string | undefined;
    /** Optional. Signature of the post author for messages in channels, or the custom title of an anonymous group administrator */
    authorSignature?: string | undefined;
    /** Optional. For text messages, the actual text of the message */
    text?: string | undefined;
    /** Optional. For text messages, special entities like usernames, URLs, bot commands, etc. that appear in the text */
    entities?: MessageEntity[] | undefined;
    /** Optional. Options used for link preview generation for the message, if it is a text message and link preview options were changed */
    linkPreviewOptions?: LinkPreviewOptions | undefined;
    /** Optional. Unique identifier of the message effect added to the message */
    effectId?: string | undefined;
    /** Optional. Message is an animation, information about the animation. For backward compatibility, when this field is set, the Document field will also be set */
    animation?: Animation | undefined;
    /** Optional. Message is an audio file, information about the file */
    audio?: Audio | undefined;
    /** Optional. Message is a general file, information about the file */
    document?: Document | undefined;
    /** Optional. Message contains paid media; information about the paid media */
    paidMedia?: PaidMediaInfo | undefined;
    /** Optional. Message is a photo, available sizes of the photo */
    photo?: PhotoSize[] | undefined;
    /** Optional. Message is a sticker, information about the sticker */
    sticker?: Sticker | undefined;
    /** Optional. Message is a forwarded story */
    story?: Story | undefined;
    /** Optional. Message is a video, information about the video */
    video?: Video | undefined;
    /** Optional. Message is a video note, information about the video message */
    videoNote?: VideoNote | undefined;
    /** Optional. Message is a voice message, information about the file */
    voice?: Voice | undefined;
    /** Optional. Caption for the animation, audio, document, paid media, photo, video or voice */
    caption?: string | undefined;
    /** Optional. For messages with a caption, special entities like usernames, URLs, bot commands, etc. that appear in the caption */
    captionEntities?: MessageEntity[] | undefined;
    /** Optional. true, if the caption must be shown above the message media */
    showCaptionAboveMedia: boolean;
    /** Optional. true, if the message media is covered by a spoiler animation */
    hasMediaSpoiler: boolean;
    /** Optional. Message is a shared contact, information about the contact */
    contact?: Contact | undefined;
    /** Optional. Message is a dice with random value */
    dice?: Dice | undefined;
    /** Optional. Message is a game, information about the game. More about games » */
    game?: Game | undefined;
    /** Optional. Message is a native poll, information about the poll */
    poll?: Poll | undefined;
    /** Optional. Message is a venue, information about the venue. For backward compatibility, when this field is set, the Location field will also be set */
    venue?: Venue | undefined;
    /** Optional. Message is a shared location, information about the location */
    location?: Location | undefined;
    /** Optional. New members that were added to the group or supergroup and information about them (the bot itself may be one of these members) */
    newChatMembers?: User[] | undefined;
    /** Optional. A member was removed from the group, information about them (this member may be the bot itself) */
    leftChatMember?: User | undefined;
    /** Optional. A chat title was changed to this value */
    newChatTitle?: string | undefined;
    /** Optional. A chat photo was change to this value */
    newChatPhoto?: PhotoSize[] | undefined;
    /** Optional. Service message: the chat photo was deleted */
    deleteChatPhoto?: boolean | undefined;
    /** Optional. Service message: the group has been created */
    groupChatCreated?: boolean | undefined;
    /** Optional. Service message: the supergroup has been created. This field can't be received in a message coming through updates, because bot can't be a member of a supergroup when it is created. It can only be found in ReplyToMessage if someone replies to a very first message in a directly created supergroup. */
    supergroupChatCreated?: boolean | undefined;
    /** Optional. Service message: the channel has been created. This field can't be received in a message coming through updates, because bot can't be a member of a channel when it is created. It can only be found in ReplyToMessage if someone replies to a very first message in a channel. */
    channelChatCreated?: boolean | undefined;
    /** Optional. Service message: auto-delete timer settings changed in the chat */
    messageAutoDeleteTimerChanged?: MessageAutoDeleteTimerChanged | undefined;
    /** Optional. The group has been migrated to a supergroup with the specified identifier. */
    migrateToChatId?: number | undefined;
    /** Optional. The supergroup has been migrated from a group with the specified identifier. */
    migrateFromChatId?: number | undefined;
    /** Optional. Specified message was pinned. Note that the Message object in this field will not contain further ReplyToMessage fields even if it itself is a reply. */
    pinnedMessage?: Message | undefined;
    /** Optional. Message is an invoice for a payment, information about the invoice. More about payments » */
    invoice?: Invoice | undefined;
    /** Optional. Message is a service message about a successful payment, information about the payment. More about payments » */
    successfulPayment?: SuccessfulPayment | undefined;
    /** Optional. Message is a service message about a refunded payment, information about the payment. More about payments » */
    refundedPayment?: RefundedPayment | undefined;
    /** Optional. Service message: users were shared with the bot */
    usersShared?: UsersShared | undefined;
    /** Optional. Service message: a chat was shared with the bot */
    chatShared?: ChatShared | undefined;
    /** Optional. The domain name of the website on which the user has logged in. More about Telegram Login » */
    connectedWebsite?: string | undefined;
    /** Optional. Service message: the user allowed the bot to write messages after adding it to the attachment or side menu, launching a Web App from a link, or accepting an explicit request from a Web App sent by the method requestWriteAccess */
    writeAccessAllowed?: WriteAccessAllowed | undefined;
    /** Optional. Telegram Passport data */
    passportData?: PassportData2 | undefined;
    /** Optional. Service message. A user in the chat triggered another user's proximity alert while sharing Live Location. */
    proximityAlertTriggered?: ProximityAlertTriggered | undefined;
    /** Optional. Service message: user boosted the chat */
    boostAdded?: ChatBoostAdded | undefined;
    /** Optional. Service message: chat background set */
    chatBackgroundSet?: ChatBackground | undefined;
    /** Optional. Service message: forum topic created */
    forumTopicCreated?: ForumTopicCreated | undefined;
    /** Optional. Service message: forum topic edited */
    forumTopicEdited?: ForumTopicEdited | undefined;
    /** Optional. Service message: forum topic closed */
    forumTopicClosed?: ForumTopicClosed | undefined;
    /** Optional. Service message: forum topic reopened */
    forumTopicReopened?: ForumTopicReopened | undefined;
    /** Optional. Service message: the 'General' forum topic hidden */
    generalForumTopicHidden?: GeneralForumTopicHidden | undefined;
    /** Optional. Service message: the 'General' forum topic unhidden */
    generalForumTopicUnhidden?: GeneralForumTopicUnhidden | undefined;
    /** Optional. Service message: a scheduled giveaway was created */
    giveawayCreated?: GiveawayCreated | undefined;
    /** Optional. The message is a scheduled giveaway message */
    giveaway?: Giveaway | undefined;
    /** Optional. A giveaway with public winners was completed */
    giveawayWinners?: GiveawayWinners | undefined;
    /** Optional. Service message: a giveaway without public winners was completed */
    giveawayCompleted?: GiveawayCompleted | undefined;
    /** Optional. Service message: video chat scheduled */
    videoChatScheduled?: VideoChatScheduled | undefined;
    /** Optional. Service message: video chat started */
    videoChatStarted?: VideoChatStarted | undefined;
    /** Optional. Service message: video chat ended */
    videoChatEnded?: VideoChatEnded | undefined;
    /** Optional. Service message: new participants invited to a video chat */
    videoChatParticipantsInvited?: VideoChatParticipantsInvited | undefined;
    /** Optional. Service message: data sent by a Web App */
    webAppData?: WebAppData | undefined;
    /** Optional. Inline keyboard attached to the message. LoginUrl buttons are represented as ordinary url buttons. */
    replyMarkup?: InlineKeyboardMarkup | undefined;
    /** Gets the type of the Message */
    type: MessageType;
}

/** This object represents a Telegram user or bot. */
export class User implements IUser {
    /** Unique identifier for this user or bot. */
    id!: number;
    /** true, if this user is a bot */
    isBot!: boolean;
    /** User's or bot's first name */
    firstName!: string;
    /** Optional. User's or bot's last name */
    lastName?: string | undefined;
    /** Optional. User's or bot's username */
    username?: string | undefined;
    /** Optional. IETF language tag of the user's language */
    languageCode?: string | undefined;
    /** Optional. true, if this user is a Telegram Premium user */
    isPremium!: boolean;
    /** Optional. true, if this user added the bot to the attachment menu */
    addedToAttachmentMenu!: boolean;
    /** Optional. true, if the bot can be invited to groups. Returned only in GetMe. */
    canJoinGroups!: boolean;
    /** Optional. true, if privacy mode is disabled for the bot. Returned only in GetMe. */
    canReadAllGroupMessages!: boolean;
    /** Optional. true, if the bot supports inline queries. Returned only in GetMe. */
    supportsInlineQueries!: boolean;
    /** Optional. true, if the bot can be connected to a Telegram Business account to receive its messages. Returned only in GetMe. */
    canConnectToBusiness!: boolean;
    /** Optional. true, if the bot has a main Web App. Returned only in GetMe. */
    hasMainWebApp!: boolean;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isBot = _data["isBot"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.username = _data["username"];
            this.languageCode = _data["languageCode"];
            this.isPremium = _data["isPremium"];
            this.addedToAttachmentMenu = _data["addedToAttachmentMenu"];
            this.canJoinGroups = _data["canJoinGroups"];
            this.canReadAllGroupMessages = _data["canReadAllGroupMessages"];
            this.supportsInlineQueries = _data["supportsInlineQueries"];
            this.canConnectToBusiness = _data["canConnectToBusiness"];
            this.hasMainWebApp = _data["hasMainWebApp"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isBot"] = this.isBot;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["username"] = this.username;
        data["languageCode"] = this.languageCode;
        data["isPremium"] = this.isPremium;
        data["addedToAttachmentMenu"] = this.addedToAttachmentMenu;
        data["canJoinGroups"] = this.canJoinGroups;
        data["canReadAllGroupMessages"] = this.canReadAllGroupMessages;
        data["supportsInlineQueries"] = this.supportsInlineQueries;
        data["canConnectToBusiness"] = this.canConnectToBusiness;
        data["hasMainWebApp"] = this.hasMainWebApp;
        return data;
    }
}

/** This object represents a Telegram user or bot. */
export interface IUser {
    /** Unique identifier for this user or bot. */
    id: number;
    /** true, if this user is a bot */
    isBot: boolean;
    /** User's or bot's first name */
    firstName: string;
    /** Optional. User's or bot's last name */
    lastName?: string | undefined;
    /** Optional. User's or bot's username */
    username?: string | undefined;
    /** Optional. IETF language tag of the user's language */
    languageCode?: string | undefined;
    /** Optional. true, if this user is a Telegram Premium user */
    isPremium: boolean;
    /** Optional. true, if this user added the bot to the attachment menu */
    addedToAttachmentMenu: boolean;
    /** Optional. true, if the bot can be invited to groups. Returned only in GetMe. */
    canJoinGroups: boolean;
    /** Optional. true, if privacy mode is disabled for the bot. Returned only in GetMe. */
    canReadAllGroupMessages: boolean;
    /** Optional. true, if the bot supports inline queries. Returned only in GetMe. */
    supportsInlineQueries: boolean;
    /** Optional. true, if the bot can be connected to a Telegram Business account to receive its messages. Returned only in GetMe. */
    canConnectToBusiness: boolean;
    /** Optional. true, if the bot has a main Web App. Returned only in GetMe. */
    hasMainWebApp: boolean;
}

/** This object represents a chat. */
export class Chat implements IChat {
    /** Unique identifier for this chat. */
    id!: number;
    /** Type of the chat, can be either Private, Group, Supergroup or Channel */
    type!: ChatType;
    /** Optional. Title, for supergroups, channels and group chats */
    title?: string | undefined;
    /** Optional. Username, for private chats, supergroups and channels if available */
    username?: string | undefined;
    /** Optional. First name of the other party in a private chat */
    firstName?: string | undefined;
    /** Optional. Last name of the other party in a private chat */
    lastName?: string | undefined;
    /** Optional. true, if the supergroup chat is a forum (has topics enabled) */
    isForum!: boolean;

    constructor(data?: IChat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.title = _data["title"];
            this.username = _data["username"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isForum = _data["isForum"];
        }
    }

    static fromJS(data: any): Chat {
        data = typeof data === 'object' ? data : {};
        let result = new Chat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["title"] = this.title;
        data["username"] = this.username;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isForum"] = this.isForum;
        return data;
    }
}

/** This object represents a chat. */
export interface IChat {
    /** Unique identifier for this chat. */
    id: number;
    /** Type of the chat, can be either Private, Group, Supergroup or Channel */
    type: ChatType;
    /** Optional. Title, for supergroups, channels and group chats */
    title?: string | undefined;
    /** Optional. Username, for private chats, supergroups and channels if available */
    username?: string | undefined;
    /** Optional. First name of the other party in a private chat */
    firstName?: string | undefined;
    /** Optional. Last name of the other party in a private chat */
    lastName?: string | undefined;
    /** Optional. true, if the supergroup chat is a forum (has topics enabled) */
    isForum: boolean;
}

/** Type of the Chat, from which the inline query was sent */
export enum ChatType {
    Private = 1,
    Group = 2,
    Channel = 3,
    Supergroup = 4,
    Sender = 5,
}

/** This object describes the origin of a message. It can be one ofMessageOriginUser, MessageOriginHiddenUser, MessageOriginChat, MessageOriginChannel */
export abstract class MessageOrigin implements IMessageOrigin {
    /** Date the message was sent originally */
    date!: Date;

    constructor(data?: IMessageOrigin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MessageOrigin {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MessageOrigin' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        return data;
    }
}

/** This object describes the origin of a message. It can be one ofMessageOriginUser, MessageOriginHiddenUser, MessageOriginChat, MessageOriginChannel */
export interface IMessageOrigin {
    /** Date the message was sent originally */
    date: Date;
}

/** This object contains information about a message that is being replied to, which may come from another chat or forum topic. */
export class ExternalReplyInfo implements IExternalReplyInfo {
    /** Origin of the message replied to by the given message */
    origin!: MessageOrigin;
    /** Optional. Chat the original message belongs to. Available only if the chat is a supergroup or a channel. */
    chat?: Chat | undefined;
    /** Optional. Unique message identifier inside the original chat. Available only if the original chat is a supergroup or a channel. */
    messageId?: number | undefined;
    /** Optional. Options used for link preview generation for the original message, if it is a text message */
    linkPreviewOptions?: LinkPreviewOptions | undefined;
    /** Optional. Message is an animation, information about the animation */
    animation?: Animation | undefined;
    /** Optional. Message is an audio file, information about the file */
    audio?: Audio | undefined;
    /** Optional. Message is a general file, information about the file */
    document?: Document | undefined;
    /** Optional. Message contains paid media; information about the paid media */
    paidMedia?: PaidMediaInfo | undefined;
    /** Optional. Message is a photo, available sizes of the photo */
    photo?: PhotoSize[] | undefined;
    /** Optional. Message is a sticker, information about the sticker */
    sticker?: Sticker | undefined;
    /** Optional. Message is a forwarded story */
    story?: Story | undefined;
    /** Optional. Message is a video, information about the video */
    video?: Video | undefined;
    /** Optional. Message is a video note, information about the video message */
    videoNote?: VideoNote | undefined;
    /** Optional. Message is a voice message, information about the file */
    voice?: Voice | undefined;
    /** Optional. true, if the message media is covered by a spoiler animation */
    hasMediaSpoiler!: boolean;
    /** Optional. Message is a shared contact, information about the contact */
    contact?: Contact | undefined;
    /** Optional. Message is a dice with random value */
    dice?: Dice | undefined;
    /** Optional. Message is a game, information about the game. More about games » */
    game?: Game | undefined;
    /** Optional. Message is a scheduled giveaway, information about the giveaway */
    giveaway?: Giveaway | undefined;
    /** Optional. A giveaway with public winners was completed */
    giveawayWinners?: GiveawayWinners | undefined;
    /** Optional. Message is an invoice for a payment, information about the invoice. More about payments » */
    invoice?: Invoice | undefined;
    /** Optional. Message is a shared location, information about the location */
    location?: Location | undefined;
    /** Optional. Message is a native poll, information about the poll */
    poll?: Poll | undefined;
    /** Optional. Message is a venue, information about the venue */
    venue?: Venue | undefined;

    constructor(data?: IExternalReplyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? MessageOrigin.fromJS(_data["origin"]) : <any>undefined;
            this.chat = _data["chat"] ? Chat.fromJS(_data["chat"]) : <any>undefined;
            this.messageId = _data["messageId"];
            this.linkPreviewOptions = _data["linkPreviewOptions"] ? LinkPreviewOptions.fromJS(_data["linkPreviewOptions"]) : <any>undefined;
            this.animation = _data["animation"] ? Animation.fromJS(_data["animation"]) : <any>undefined;
            this.audio = _data["audio"] ? Audio.fromJS(_data["audio"]) : <any>undefined;
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : <any>undefined;
            this.paidMedia = _data["paidMedia"] ? PaidMediaInfo.fromJS(_data["paidMedia"]) : <any>undefined;
            if (Array.isArray(_data["photo"])) {
                this.photo = [] as any;
                for (let item of _data["photo"])
                    this.photo!.push(PhotoSize.fromJS(item));
            }
            this.sticker = _data["sticker"] ? Sticker.fromJS(_data["sticker"]) : <any>undefined;
            this.story = _data["story"] ? Story.fromJS(_data["story"]) : <any>undefined;
            this.video = _data["video"] ? Video.fromJS(_data["video"]) : <any>undefined;
            this.videoNote = _data["videoNote"] ? VideoNote.fromJS(_data["videoNote"]) : <any>undefined;
            this.voice = _data["voice"] ? Voice.fromJS(_data["voice"]) : <any>undefined;
            this.hasMediaSpoiler = _data["hasMediaSpoiler"];
            this.contact = _data["contact"] ? Contact.fromJS(_data["contact"]) : <any>undefined;
            this.dice = _data["dice"] ? Dice.fromJS(_data["dice"]) : <any>undefined;
            this.game = _data["game"] ? Game.fromJS(_data["game"]) : <any>undefined;
            this.giveaway = _data["giveaway"] ? Giveaway.fromJS(_data["giveaway"]) : <any>undefined;
            this.giveawayWinners = _data["giveawayWinners"] ? GiveawayWinners.fromJS(_data["giveawayWinners"]) : <any>undefined;
            this.invoice = _data["invoice"] ? Invoice.fromJS(_data["invoice"]) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.poll = _data["poll"] ? Poll.fromJS(_data["poll"]) : <any>undefined;
            this.venue = _data["venue"] ? Venue.fromJS(_data["venue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExternalReplyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalReplyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["chat"] = this.chat ? this.chat.toJSON() : <any>undefined;
        data["messageId"] = this.messageId;
        data["linkPreviewOptions"] = this.linkPreviewOptions ? this.linkPreviewOptions.toJSON() : <any>undefined;
        data["animation"] = this.animation ? this.animation.toJSON() : <any>undefined;
        data["audio"] = this.audio ? this.audio.toJSON() : <any>undefined;
        data["document"] = this.document ? this.document.toJSON() : <any>undefined;
        data["paidMedia"] = this.paidMedia ? this.paidMedia.toJSON() : <any>undefined;
        if (Array.isArray(this.photo)) {
            data["photo"] = [];
            for (let item of this.photo)
                data["photo"].push(item.toJSON());
        }
        data["sticker"] = this.sticker ? this.sticker.toJSON() : <any>undefined;
        data["story"] = this.story ? this.story.toJSON() : <any>undefined;
        data["video"] = this.video ? this.video.toJSON() : <any>undefined;
        data["videoNote"] = this.videoNote ? this.videoNote.toJSON() : <any>undefined;
        data["voice"] = this.voice ? this.voice.toJSON() : <any>undefined;
        data["hasMediaSpoiler"] = this.hasMediaSpoiler;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["dice"] = this.dice ? this.dice.toJSON() : <any>undefined;
        data["game"] = this.game ? this.game.toJSON() : <any>undefined;
        data["giveaway"] = this.giveaway ? this.giveaway.toJSON() : <any>undefined;
        data["giveawayWinners"] = this.giveawayWinners ? this.giveawayWinners.toJSON() : <any>undefined;
        data["invoice"] = this.invoice ? this.invoice.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["poll"] = this.poll ? this.poll.toJSON() : <any>undefined;
        data["venue"] = this.venue ? this.venue.toJSON() : <any>undefined;
        return data;
    }
}

/** This object contains information about a message that is being replied to, which may come from another chat or forum topic. */
export interface IExternalReplyInfo {
    /** Origin of the message replied to by the given message */
    origin: MessageOrigin;
    /** Optional. Chat the original message belongs to. Available only if the chat is a supergroup or a channel. */
    chat?: Chat | undefined;
    /** Optional. Unique message identifier inside the original chat. Available only if the original chat is a supergroup or a channel. */
    messageId?: number | undefined;
    /** Optional. Options used for link preview generation for the original message, if it is a text message */
    linkPreviewOptions?: LinkPreviewOptions | undefined;
    /** Optional. Message is an animation, information about the animation */
    animation?: Animation | undefined;
    /** Optional. Message is an audio file, information about the file */
    audio?: Audio | undefined;
    /** Optional. Message is a general file, information about the file */
    document?: Document | undefined;
    /** Optional. Message contains paid media; information about the paid media */
    paidMedia?: PaidMediaInfo | undefined;
    /** Optional. Message is a photo, available sizes of the photo */
    photo?: PhotoSize[] | undefined;
    /** Optional. Message is a sticker, information about the sticker */
    sticker?: Sticker | undefined;
    /** Optional. Message is a forwarded story */
    story?: Story | undefined;
    /** Optional. Message is a video, information about the video */
    video?: Video | undefined;
    /** Optional. Message is a video note, information about the video message */
    videoNote?: VideoNote | undefined;
    /** Optional. Message is a voice message, information about the file */
    voice?: Voice | undefined;
    /** Optional. true, if the message media is covered by a spoiler animation */
    hasMediaSpoiler: boolean;
    /** Optional. Message is a shared contact, information about the contact */
    contact?: Contact | undefined;
    /** Optional. Message is a dice with random value */
    dice?: Dice | undefined;
    /** Optional. Message is a game, information about the game. More about games » */
    game?: Game | undefined;
    /** Optional. Message is a scheduled giveaway, information about the giveaway */
    giveaway?: Giveaway | undefined;
    /** Optional. A giveaway with public winners was completed */
    giveawayWinners?: GiveawayWinners | undefined;
    /** Optional. Message is an invoice for a payment, information about the invoice. More about payments » */
    invoice?: Invoice | undefined;
    /** Optional. Message is a shared location, information about the location */
    location?: Location | undefined;
    /** Optional. Message is a native poll, information about the poll */
    poll?: Poll | undefined;
    /** Optional. Message is a venue, information about the venue */
    venue?: Venue | undefined;
}

/** Describes the options used for link preview generation. */
export class LinkPreviewOptions implements ILinkPreviewOptions {
    /** Optional. true, if the link preview is disabled */
    isDisabled!: boolean;
    /** Optional. URL to use for the link preview. If empty, then the first URL found in the message text will be used */
    url?: string | undefined;
    /** Optional. true, if the media in the link preview is supposed to be shrunk; ignored if the URL isn't explicitly specified or media size change isn't supported for the preview */
    preferSmallMedia!: boolean;
    /** Optional. true, if the media in the link preview is supposed to be enlarged; ignored if the URL isn't explicitly specified or media size change isn't supported for the preview */
    preferLargeMedia!: boolean;
    /** Optional. true, if the link preview must be shown above the message text; otherwise, the link preview will be shown below the message text */
    showAboveText!: boolean;

    constructor(data?: ILinkPreviewOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDisabled = _data["isDisabled"];
            this.url = _data["url"];
            this.preferSmallMedia = _data["preferSmallMedia"];
            this.preferLargeMedia = _data["preferLargeMedia"];
            this.showAboveText = _data["showAboveText"];
        }
    }

    static fromJS(data: any): LinkPreviewOptions {
        data = typeof data === 'object' ? data : {};
        let result = new LinkPreviewOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDisabled"] = this.isDisabled;
        data["url"] = this.url;
        data["preferSmallMedia"] = this.preferSmallMedia;
        data["preferLargeMedia"] = this.preferLargeMedia;
        data["showAboveText"] = this.showAboveText;
        return data;
    }
}

/** Describes the options used for link preview generation. */
export interface ILinkPreviewOptions {
    /** Optional. true, if the link preview is disabled */
    isDisabled: boolean;
    /** Optional. URL to use for the link preview. If empty, then the first URL found in the message text will be used */
    url?: string | undefined;
    /** Optional. true, if the media in the link preview is supposed to be shrunk; ignored if the URL isn't explicitly specified or media size change isn't supported for the preview */
    preferSmallMedia: boolean;
    /** Optional. true, if the media in the link preview is supposed to be enlarged; ignored if the URL isn't explicitly specified or media size change isn't supported for the preview */
    preferLargeMedia: boolean;
    /** Optional. true, if the link preview must be shown above the message text; otherwise, the link preview will be shown below the message text */
    showAboveText: boolean;
}

/** Base class for file objects */
export abstract class FileBase implements IFileBase {
    /** Identifier for this file, which can be used to download or reuse the file */
    fileId!: string;
    /** Unique identifier for this file, which is supposed to be the same over time and for different bots. Can't be used to download or reuse the file. */
    fileUniqueId!: string;
    /** Optional. File size in bytes. */
    fileSize?: number | undefined;

    constructor(data?: IFileBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.fileUniqueId = _data["fileUniqueId"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): FileBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'FileBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["fileUniqueId"] = this.fileUniqueId;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

/** Base class for file objects */
export interface IFileBase {
    /** Identifier for this file, which can be used to download or reuse the file */
    fileId: string;
    /** Unique identifier for this file, which is supposed to be the same over time and for different bots. Can't be used to download or reuse the file. */
    fileUniqueId: string;
    /** Optional. File size in bytes. */
    fileSize?: number | undefined;
}

/** This object represents an animation file (GIF or H.264/MPEG-4 AVC video without sound). */
export class Animation extends FileBase implements IAnimation {
    /** Video width as defined by the sender */
    width!: number;
    /** Video height as defined by the sender */
    height!: number;
    /** Duration of the video in seconds as defined by the sender */
    duration!: number;
    /** Optional. Animation thumbnail as defined by the sender */
    thumbnail?: PhotoSize | undefined;
    /** Optional. Original animation filename as defined by the sender */
    fileName?: string | undefined;
    /** Optional. MIME type of the file as defined by the sender */
    mimeType?: string | undefined;

    constructor(data?: IAnimation) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.width = _data["width"];
            this.height = _data["height"];
            this.duration = _data["duration"];
            this.thumbnail = _data["thumbnail"] ? PhotoSize.fromJS(_data["thumbnail"]) : <any>undefined;
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
        }
    }

    static override fromJS(data: any): Animation {
        data = typeof data === 'object' ? data : {};
        let result = new Animation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["height"] = this.height;
        data["duration"] = this.duration;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        super.toJSON(data);
        return data;
    }
}

/** This object represents an animation file (GIF or H.264/MPEG-4 AVC video without sound). */
export interface IAnimation extends IFileBase {
    /** Video width as defined by the sender */
    width: number;
    /** Video height as defined by the sender */
    height: number;
    /** Duration of the video in seconds as defined by the sender */
    duration: number;
    /** Optional. Animation thumbnail as defined by the sender */
    thumbnail?: PhotoSize | undefined;
    /** Optional. Original animation filename as defined by the sender */
    fileName?: string | undefined;
    /** Optional. MIME type of the file as defined by the sender */
    mimeType?: string | undefined;
}

/** This object represents one size of a photo or a file / Sticker thumbnail. */
export class PhotoSize extends FileBase implements IPhotoSize {
    /** Photo width */
    width!: number;
    /** Photo height */
    height!: number;

    constructor(data?: IPhotoSize) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }

    static override fromJS(data: any): PhotoSize {
        data = typeof data === 'object' ? data : {};
        let result = new PhotoSize();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["height"] = this.height;
        super.toJSON(data);
        return data;
    }
}

/** This object represents one size of a photo or a file / Sticker thumbnail. */
export interface IPhotoSize extends IFileBase {
    /** Photo width */
    width: number;
    /** Photo height */
    height: number;
}

/** This object represents an audio file to be treated as music by the Telegram clients. */
export class Audio extends FileBase implements IAudio {
    /** Duration of the audio in seconds as defined by the sender */
    duration!: number;
    /** Optional. Performer of the audio as defined by the sender or by audio tags */
    performer?: string | undefined;
    /** Optional. Title of the audio as defined by the sender or by audio tags */
    title?: string | undefined;
    /** Optional. Original filename as defined by the sender */
    fileName?: string | undefined;
    /** Optional. MIME type of the file as defined by the sender */
    mimeType?: string | undefined;
    /** Optional. Thumbnail of the album cover to which the music file belongs */
    thumbnail?: PhotoSize | undefined;

    constructor(data?: IAudio) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.duration = _data["duration"];
            this.performer = _data["performer"];
            this.title = _data["title"];
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.thumbnail = _data["thumbnail"] ? PhotoSize.fromJS(_data["thumbnail"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Audio {
        data = typeof data === 'object' ? data : {};
        let result = new Audio();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["performer"] = this.performer;
        data["title"] = this.title;
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** This object represents an audio file to be treated as music by the Telegram clients. */
export interface IAudio extends IFileBase {
    /** Duration of the audio in seconds as defined by the sender */
    duration: number;
    /** Optional. Performer of the audio as defined by the sender or by audio tags */
    performer?: string | undefined;
    /** Optional. Title of the audio as defined by the sender or by audio tags */
    title?: string | undefined;
    /** Optional. Original filename as defined by the sender */
    fileName?: string | undefined;
    /** Optional. MIME type of the file as defined by the sender */
    mimeType?: string | undefined;
    /** Optional. Thumbnail of the album cover to which the music file belongs */
    thumbnail?: PhotoSize | undefined;
}

/** This object represents a general file (as opposed to photos, voice messages and audio files). */
export class Document extends FileBase implements IDocument {
    /** Optional. Document thumbnail as defined by the sender */
    thumbnail?: PhotoSize | undefined;
    /** Optional. Original filename as defined by the sender */
    fileName?: string | undefined;
    /** Optional. MIME type of the file as defined by the sender */
    mimeType?: string | undefined;

    constructor(data?: IDocument) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.thumbnail = _data["thumbnail"] ? PhotoSize.fromJS(_data["thumbnail"]) : <any>undefined;
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
        }
    }

    static override fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        super.toJSON(data);
        return data;
    }
}

/** This object represents a general file (as opposed to photos, voice messages and audio files). */
export interface IDocument extends IFileBase {
    /** Optional. Document thumbnail as defined by the sender */
    thumbnail?: PhotoSize | undefined;
    /** Optional. Original filename as defined by the sender */
    fileName?: string | undefined;
    /** Optional. MIME type of the file as defined by the sender */
    mimeType?: string | undefined;
}

/** Describes the paid media added to a message. */
export class PaidMediaInfo implements IPaidMediaInfo {
    /** The number of Telegram Stars that must be paid to buy access to the media */
    starCount!: number;
    /** Information about the paid media */
    paidMedia!: PaidMedia[];

    constructor(data?: IPaidMediaInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.paidMedia = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.starCount = _data["starCount"];
            if (Array.isArray(_data["paidMedia"])) {
                this.paidMedia = [] as any;
                for (let item of _data["paidMedia"])
                    this.paidMedia!.push(PaidMedia.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaidMediaInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PaidMediaInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["starCount"] = this.starCount;
        if (Array.isArray(this.paidMedia)) {
            data["paidMedia"] = [];
            for (let item of this.paidMedia)
                data["paidMedia"].push(item.toJSON());
        }
        return data;
    }
}

/** Describes the paid media added to a message. */
export interface IPaidMediaInfo {
    /** The number of Telegram Stars that must be paid to buy access to the media */
    starCount: number;
    /** Information about the paid media */
    paidMedia: PaidMedia[];
}

/** This object describes paid media. Currently, it can be one ofPaidMediaPreview, PaidMediaPhoto, PaidMediaVideo */
export abstract class PaidMedia implements IPaidMedia {

    constructor(data?: IPaidMedia) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): PaidMedia {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PaidMedia' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** This object describes paid media. Currently, it can be one ofPaidMediaPreview, PaidMediaPhoto, PaidMediaVideo */
export interface IPaidMedia {
}

/** This object represents a sticker. */
export class Sticker extends FileBase implements ISticker {
    /** Type of the sticker, currently one of Regular, Mask, CustomEmoji. The type of the sticker is independent from its format, which is determined by the fields IsAnimated and IsVideo. */
    type!: StickerType;
    /** Sticker width */
    width!: number;
    /** Sticker height */
    height!: number;
    /** true, if the sticker is animated */
    isAnimated!: boolean;
    /** true, if the sticker is a video sticker */
    isVideo!: boolean;
    /** Optional. Sticker thumbnail in the .WEBP or .JPG format */
    thumbnail?: PhotoSize | undefined;
    /** Optional. Emoji associated with the sticker */
    emoji?: string | undefined;
    /** Optional. Name of the sticker set to which the sticker belongs */
    setName?: string | undefined;
    /** Optional. For premium regular stickers, premium animation for the sticker */
    premiumAnimation?: File | undefined;
    /** Optional. For mask stickers, the position where the mask should be placed */
    maskPosition?: MaskPosition | undefined;
    /** Optional. For custom emoji stickers, unique identifier of the custom emoji */
    customEmojiId?: string | undefined;
    /** Optional. true, if the sticker must be repainted to a text color in messages, the color of the Telegram Premium badge in emoji status, white color on chat photos, or another appropriate color in other places */
    needsRepainting!: boolean;

    constructor(data?: ISticker) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.isAnimated = _data["isAnimated"];
            this.isVideo = _data["isVideo"];
            this.thumbnail = _data["thumbnail"] ? PhotoSize.fromJS(_data["thumbnail"]) : <any>undefined;
            this.emoji = _data["emoji"];
            this.setName = _data["setName"];
            this.premiumAnimation = _data["premiumAnimation"] ? File.fromJS(_data["premiumAnimation"]) : <any>undefined;
            this.maskPosition = _data["maskPosition"] ? MaskPosition.fromJS(_data["maskPosition"]) : <any>undefined;
            this.customEmojiId = _data["customEmojiId"];
            this.needsRepainting = _data["needsRepainting"];
        }
    }

    static override fromJS(data: any): Sticker {
        data = typeof data === 'object' ? data : {};
        let result = new Sticker();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["width"] = this.width;
        data["height"] = this.height;
        data["isAnimated"] = this.isAnimated;
        data["isVideo"] = this.isVideo;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        data["emoji"] = this.emoji;
        data["setName"] = this.setName;
        data["premiumAnimation"] = this.premiumAnimation ? this.premiumAnimation.toJSON() : <any>undefined;
        data["maskPosition"] = this.maskPosition ? this.maskPosition.toJSON() : <any>undefined;
        data["customEmojiId"] = this.customEmojiId;
        data["needsRepainting"] = this.needsRepainting;
        super.toJSON(data);
        return data;
    }
}

/** This object represents a sticker. */
export interface ISticker extends IFileBase {
    /** Type of the sticker, currently one of Regular, Mask, CustomEmoji. The type of the sticker is independent from its format, which is determined by the fields IsAnimated and IsVideo. */
    type: StickerType;
    /** Sticker width */
    width: number;
    /** Sticker height */
    height: number;
    /** true, if the sticker is animated */
    isAnimated: boolean;
    /** true, if the sticker is a video sticker */
    isVideo: boolean;
    /** Optional. Sticker thumbnail in the .WEBP or .JPG format */
    thumbnail?: PhotoSize | undefined;
    /** Optional. Emoji associated with the sticker */
    emoji?: string | undefined;
    /** Optional. Name of the sticker set to which the sticker belongs */
    setName?: string | undefined;
    /** Optional. For premium regular stickers, premium animation for the sticker */
    premiumAnimation?: File | undefined;
    /** Optional. For mask stickers, the position where the mask should be placed */
    maskPosition?: MaskPosition | undefined;
    /** Optional. For custom emoji stickers, unique identifier of the custom emoji */
    customEmojiId?: string | undefined;
    /** Optional. true, if the sticker must be repainted to a text color in messages, the color of the Telegram Premium badge in emoji status, white color on chat photos, or another appropriate color in other places */
    needsRepainting: boolean;
}

/** Sticker: Type of the sticker, currently one of Regular, Mask, CustomEmoji. The type of the sticker is independent from its format, which is determined by the fields IsAnimated and IsVideo. */
export enum StickerType {
    Regular = 1,
    Mask = 2,
    CustomEmoji = 3,
}

/** This object represents a file ready to be downloaded. The file can be downloaded via DownloadFile. It is guaranteed that the link will be valid for at least 1 hour. When the link expires, a new one can be requested by calling GetFile. */
export class File extends FileBase implements IFile {
    /** Optional. File path. Use DownloadFile to get the file. */
    filePath?: string | undefined;

    constructor(data?: IFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.filePath = _data["filePath"];
        }
    }

    static override fromJS(data: any): File {
        data = typeof data === 'object' ? data : {};
        let result = new File();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filePath"] = this.filePath;
        super.toJSON(data);
        return data;
    }
}

/** This object represents a file ready to be downloaded. The file can be downloaded via DownloadFile. It is guaranteed that the link will be valid for at least 1 hour. When the link expires, a new one can be requested by calling GetFile. */
export interface IFile extends IFileBase {
    /** Optional. File path. Use DownloadFile to get the file. */
    filePath?: string | undefined;
}

/** This object describes the position on faces where a mask should be placed by default. */
export class MaskPosition implements IMaskPosition {
    /** The part of the face relative to which the mask should be placed. One of Forehead, Eyes, Mouth, or Chin. */
    point!: MaskPositionPoint;
    /** Shift by X-axis measured in widths of the mask scaled to the face size, from left to right. For example, choosing -1.0 will place mask just to the left of the default mask position. */
    xShift!: number;
    /** Shift by Y-axis measured in heights of the mask scaled to the face size, from top to bottom. For example, 1.0 will place the mask just below the default mask position. */
    yShift!: number;
    /** Mask scaling coefficient. For example, 2.0 means double size. */
    scale!: number;

    constructor(data?: IMaskPosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.point = _data["point"];
            this.xShift = _data["xShift"];
            this.yShift = _data["yShift"];
            this.scale = _data["scale"];
        }
    }

    static fromJS(data: any): MaskPosition {
        data = typeof data === 'object' ? data : {};
        let result = new MaskPosition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["point"] = this.point;
        data["xShift"] = this.xShift;
        data["yShift"] = this.yShift;
        data["scale"] = this.scale;
        return data;
    }
}

/** This object describes the position on faces where a mask should be placed by default. */
export interface IMaskPosition {
    /** The part of the face relative to which the mask should be placed. One of Forehead, Eyes, Mouth, or Chin. */
    point: MaskPositionPoint;
    /** Shift by X-axis measured in widths of the mask scaled to the face size, from left to right. For example, choosing -1.0 will place mask just to the left of the default mask position. */
    xShift: number;
    /** Shift by Y-axis measured in heights of the mask scaled to the face size, from top to bottom. For example, 1.0 will place the mask just below the default mask position. */
    yShift: number;
    /** Mask scaling coefficient. For example, 2.0 means double size. */
    scale: number;
}

/** MaskPosition: The part of the face relative to which the mask should be placed. One of Forehead, Eyes, Mouth, or Chin. */
export enum MaskPositionPoint {
    Forehead = 1,
    Eyes = 2,
    Mouth = 3,
    Chin = 4,
}

/** This object represents a story. */
export class Story implements IStory {
    /** Chat that posted the story */
    chat!: Chat;
    /** Unique identifier for the story in the chat */
    id!: number;

    constructor(data?: IStory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chat = new Chat();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chat = _data["chat"] ? Chat.fromJS(_data["chat"]) : new Chat();
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Story {
        data = typeof data === 'object' ? data : {};
        let result = new Story();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chat"] = this.chat ? this.chat.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

/** This object represents a story. */
export interface IStory {
    /** Chat that posted the story */
    chat: Chat;
    /** Unique identifier for the story in the chat */
    id: number;
}

/** This object represents a video file. */
export class Video extends FileBase implements IVideo {
    /** Video width as defined by the sender */
    width!: number;
    /** Video height as defined by the sender */
    height!: number;
    /** Duration of the video in seconds as defined by the sender */
    duration!: number;
    /** Optional. Video thumbnail */
    thumbnail?: PhotoSize | undefined;
    /** Optional. Original filename as defined by the sender */
    fileName?: string | undefined;
    /** Optional. MIME type of the file as defined by the sender */
    mimeType?: string | undefined;

    constructor(data?: IVideo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.width = _data["width"];
            this.height = _data["height"];
            this.duration = _data["duration"];
            this.thumbnail = _data["thumbnail"] ? PhotoSize.fromJS(_data["thumbnail"]) : <any>undefined;
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
        }
    }

    static override fromJS(data: any): Video {
        data = typeof data === 'object' ? data : {};
        let result = new Video();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["height"] = this.height;
        data["duration"] = this.duration;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        super.toJSON(data);
        return data;
    }
}

/** This object represents a video file. */
export interface IVideo extends IFileBase {
    /** Video width as defined by the sender */
    width: number;
    /** Video height as defined by the sender */
    height: number;
    /** Duration of the video in seconds as defined by the sender */
    duration: number;
    /** Optional. Video thumbnail */
    thumbnail?: PhotoSize | undefined;
    /** Optional. Original filename as defined by the sender */
    fileName?: string | undefined;
    /** Optional. MIME type of the file as defined by the sender */
    mimeType?: string | undefined;
}

/** This object represents a video message (available in Telegram apps as of v.4.0). */
export class VideoNote extends FileBase implements IVideoNote {
    /** Video width and height (diameter of the video message) as defined by the sender */
    length!: number;
    /** Duration of the video in seconds as defined by the sender */
    duration!: number;
    /** Optional. Video thumbnail */
    thumbnail?: PhotoSize | undefined;

    constructor(data?: IVideoNote) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.length = _data["length"];
            this.duration = _data["duration"];
            this.thumbnail = _data["thumbnail"] ? PhotoSize.fromJS(_data["thumbnail"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): VideoNote {
        data = typeof data === 'object' ? data : {};
        let result = new VideoNote();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length;
        data["duration"] = this.duration;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** This object represents a video message (available in Telegram apps as of v.4.0). */
export interface IVideoNote extends IFileBase {
    /** Video width and height (diameter of the video message) as defined by the sender */
    length: number;
    /** Duration of the video in seconds as defined by the sender */
    duration: number;
    /** Optional. Video thumbnail */
    thumbnail?: PhotoSize | undefined;
}

/** This object represents a voice note. */
export class Voice extends FileBase implements IVoice {
    /** Duration of the audio in seconds as defined by the sender */
    duration!: number;
    /** Optional. MIME type of the file as defined by the sender */
    mimeType?: string | undefined;

    constructor(data?: IVoice) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.duration = _data["duration"];
            this.mimeType = _data["mimeType"];
        }
    }

    static override fromJS(data: any): Voice {
        data = typeof data === 'object' ? data : {};
        let result = new Voice();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["mimeType"] = this.mimeType;
        super.toJSON(data);
        return data;
    }
}

/** This object represents a voice note. */
export interface IVoice extends IFileBase {
    /** Duration of the audio in seconds as defined by the sender */
    duration: number;
    /** Optional. MIME type of the file as defined by the sender */
    mimeType?: string | undefined;
}

/** This object represents a phone contact. */
export class Contact implements IContact {
    /** Contact's phone number */
    phoneNumber!: string;
    /** Contact's first name */
    firstName!: string;
    /** Optional. Contact's last name */
    lastName?: string | undefined;
    /** Optional. Contact's user identifier in Telegram. */
    userId?: number | undefined;
    /** Optional. Additional data about the contact in the form of a vCard */
    vcard?: string | undefined;

    constructor(data?: IContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userId = _data["userId"];
            this.vcard = _data["vcard"];
        }
    }

    static fromJS(data: any): Contact {
        data = typeof data === 'object' ? data : {};
        let result = new Contact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userId"] = this.userId;
        data["vcard"] = this.vcard;
        return data;
    }
}

/** This object represents a phone contact. */
export interface IContact {
    /** Contact's phone number */
    phoneNumber: string;
    /** Contact's first name */
    firstName: string;
    /** Optional. Contact's last name */
    lastName?: string | undefined;
    /** Optional. Contact's user identifier in Telegram. */
    userId?: number | undefined;
    /** Optional. Additional data about the contact in the form of a vCard */
    vcard?: string | undefined;
}

/** This object represents an animated emoji that displays a random value. */
export class Dice implements IDice {
    /** Emoji on which the dice throw animation is based */
    emoji!: string;
    /** Value of the dice, 1-6 for “🎲”, “🎯” and “🎳” base emoji, 1-5 for “🏀” and “⚽” base emoji, 1-64 for “🎰” base emoji */
    value!: number;

    constructor(data?: IDice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emoji = _data["emoji"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): Dice {
        data = typeof data === 'object' ? data : {};
        let result = new Dice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emoji"] = this.emoji;
        data["value"] = this.value;
        return data;
    }
}

/** This object represents an animated emoji that displays a random value. */
export interface IDice {
    /** Emoji on which the dice throw animation is based */
    emoji: string;
    /** Value of the dice, 1-6 for “🎲”, “🎯” and “🎳” base emoji, 1-5 for “🏀” and “⚽” base emoji, 1-64 for “🎰” base emoji */
    value: number;
}

/** This object represents a game. Use BotFather to create and edit games, their short names will act as unique identifiers. */
export class Game implements IGame {
    /** Title of the game */
    title!: string;
    /** Description of the game */
    description!: string;
    /** Photo that will be displayed in the game message in chats. */
    photo!: PhotoSize[];
    /** Optional. Brief description of the game or high scores included in the game message. Can be automatically edited to include current high scores for the game when the bot calls SetGameScore, or manually edited using EditMessageText. 0-4096 characters. */
    text?: string | undefined;
    /** Optional. Special entities that appear in Text, such as usernames, URLs, bot commands, etc. */
    textEntities?: MessageEntity[] | undefined;
    /** Optional. Animation that will be displayed in the game message in chats. Upload via @BotFather */
    animation?: Animation | undefined;

    constructor(data?: IGame) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.photo = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            if (Array.isArray(_data["photo"])) {
                this.photo = [] as any;
                for (let item of _data["photo"])
                    this.photo!.push(PhotoSize.fromJS(item));
            }
            this.text = _data["text"];
            if (Array.isArray(_data["textEntities"])) {
                this.textEntities = [] as any;
                for (let item of _data["textEntities"])
                    this.textEntities!.push(MessageEntity.fromJS(item));
            }
            this.animation = _data["animation"] ? Animation.fromJS(_data["animation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Game {
        data = typeof data === 'object' ? data : {};
        let result = new Game();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        if (Array.isArray(this.photo)) {
            data["photo"] = [];
            for (let item of this.photo)
                data["photo"].push(item.toJSON());
        }
        data["text"] = this.text;
        if (Array.isArray(this.textEntities)) {
            data["textEntities"] = [];
            for (let item of this.textEntities)
                data["textEntities"].push(item.toJSON());
        }
        data["animation"] = this.animation ? this.animation.toJSON() : <any>undefined;
        return data;
    }
}

/** This object represents a game. Use BotFather to create and edit games, their short names will act as unique identifiers. */
export interface IGame {
    /** Title of the game */
    title: string;
    /** Description of the game */
    description: string;
    /** Photo that will be displayed in the game message in chats. */
    photo: PhotoSize[];
    /** Optional. Brief description of the game or high scores included in the game message. Can be automatically edited to include current high scores for the game when the bot calls SetGameScore, or manually edited using EditMessageText. 0-4096 characters. */
    text?: string | undefined;
    /** Optional. Special entities that appear in Text, such as usernames, URLs, bot commands, etc. */
    textEntities?: MessageEntity[] | undefined;
    /** Optional. Animation that will be displayed in the game message in chats. Upload via @BotFather */
    animation?: Animation | undefined;
}

/** This object represents one special entity in a text message. For example, hashtags, usernames, URLs, etc. */
export class MessageEntity implements IMessageEntity {
    /** Type of the entity. Currently, can be “mention” (@username), “hashtag” (#hashtag), “cashtag” ($USD), BotCommand (/start@JobsBot), “url” (https://telegram.org), “email” (do-not-reply@telegram.org), “PhoneNumber” (+1-212-555-0123), “bold” (bold text), “italic” (italic text), “underline” (underlined text), “strikethrough” (strikethrough text), “spoiler” (spoiler message), “blockquote” (block quotation), “ExpandableBlockquote” (collapsed-by-default block quotation), “code” (monowidth string), “pre” (monowidth block), “TextLink” (for clickable text URLs), “TextMention” (for users without usernames), “CustomEmoji” (for inline custom emoji stickers) */
    type!: MessageEntityType;
    /** Offset in UTF-16 code units to the start of the entity */
    offset!: number;
    /** Length of the entity in UTF-16 code units */
    length!: number;
    /** Optional. For TextLink only, URL that will be opened after user taps on the text */
    url?: string | undefined;
    /** Optional. For TextMention only, the mentioned user */
    user?: User | undefined;
    /** Optional. For Pre only, the programming language of the entity text */
    language?: string | undefined;
    /** Optional. For CustomEmoji only, unique identifier of the custom emoji. Use GetCustomEmojiStickers to get full information about the sticker */
    customEmojiId?: string | undefined;

    constructor(data?: IMessageEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.offset = _data["offset"];
            this.length = _data["length"];
            this.url = _data["url"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.language = _data["language"];
            this.customEmojiId = _data["customEmojiId"];
        }
    }

    static fromJS(data: any): MessageEntity {
        data = typeof data === 'object' ? data : {};
        let result = new MessageEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["offset"] = this.offset;
        data["length"] = this.length;
        data["url"] = this.url;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["language"] = this.language;
        data["customEmojiId"] = this.customEmojiId;
        return data;
    }
}

/** This object represents one special entity in a text message. For example, hashtags, usernames, URLs, etc. */
export interface IMessageEntity {
    /** Type of the entity. Currently, can be “mention” (@username), “hashtag” (#hashtag), “cashtag” ($USD), BotCommand (/start@JobsBot), “url” (https://telegram.org), “email” (do-not-reply@telegram.org), “PhoneNumber” (+1-212-555-0123), “bold” (bold text), “italic” (italic text), “underline” (underlined text), “strikethrough” (strikethrough text), “spoiler” (spoiler message), “blockquote” (block quotation), “ExpandableBlockquote” (collapsed-by-default block quotation), “code” (monowidth string), “pre” (monowidth block), “TextLink” (for clickable text URLs), “TextMention” (for users without usernames), “CustomEmoji” (for inline custom emoji stickers) */
    type: MessageEntityType;
    /** Offset in UTF-16 code units to the start of the entity */
    offset: number;
    /** Length of the entity in UTF-16 code units */
    length: number;
    /** Optional. For TextLink only, URL that will be opened after user taps on the text */
    url?: string | undefined;
    /** Optional. For TextMention only, the mentioned user */
    user?: User | undefined;
    /** Optional. For Pre only, the programming language of the entity text */
    language?: string | undefined;
    /** Optional. For CustomEmoji only, unique identifier of the custom emoji. Use GetCustomEmojiStickers to get full information about the sticker */
    customEmojiId?: string | undefined;
}

/** Type of a MessageEntity */
export enum MessageEntityType {
    Mention = 1,
    Hashtag = 2,
    BotCommand = 3,
    Url = 4,
    Email = 5,
    Bold = 6,
    Italic = 7,
    Code = 8,
    Pre = 9,
    TextLink = 10,
    TextMention = 11,
    PhoneNumber = 12,
    Cashtag = 13,
    Underline = 14,
    Strikethrough = 15,
    Spoiler = 16,
    CustomEmoji = 17,
    Blockquote = 18,
    ExpandableBlockquote = 19,
}

/** This object represents a message about a scheduled giveaway. */
export class Giveaway implements IGiveaway {
    /** The list of chats which the user must join to participate in the giveaway */
    chats!: Chat[];
    /** Point in time when winners of the giveaway will be selected */
    winnersSelectionDate!: Date;
    /** The number of users which are supposed to be selected as winners of the giveaway */
    winnerCount!: number;
    /** Optional. true, if only users who join the chats after the giveaway started should be eligible to win */
    onlyNewMembers!: boolean;
    /** Optional. true, if the list of giveaway winners will be visible to everyone */
    hasPublicWinners!: boolean;
    /** Optional. Description of additional giveaway prize */
    prizeDescription?: string | undefined;
    /** Optional. A list of two-letter ISO 3166-1 alpha-2 country codes indicating the countries from which eligible users for the giveaway must come. If empty, then all users can participate in the giveaway. Users with a phone number that was bought on Fragment can always participate in giveaways. */
    countryCodes?: string[] | undefined;
    /** Optional. The number of Telegram Stars to be split between giveaway winners; for Telegram Star giveaways only */
    prizeStarCount?: number | undefined;
    /** Optional. The number of months the Telegram Premium subscription won from the giveaway will be active for; for Telegram Premium giveaways only */
    premiumSubscriptionMonthCount?: number | undefined;

    constructor(data?: IGiveaway) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chats = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["chats"])) {
                this.chats = [] as any;
                for (let item of _data["chats"])
                    this.chats!.push(Chat.fromJS(item));
            }
            this.winnersSelectionDate = _data["winnersSelectionDate"] ? new Date(_data["winnersSelectionDate"].toString()) : <any>undefined;
            this.winnerCount = _data["winnerCount"];
            this.onlyNewMembers = _data["onlyNewMembers"];
            this.hasPublicWinners = _data["hasPublicWinners"];
            this.prizeDescription = _data["prizeDescription"];
            if (Array.isArray(_data["countryCodes"])) {
                this.countryCodes = [] as any;
                for (let item of _data["countryCodes"])
                    this.countryCodes!.push(item);
            }
            this.prizeStarCount = _data["prizeStarCount"];
            this.premiumSubscriptionMonthCount = _data["premiumSubscriptionMonthCount"];
        }
    }

    static fromJS(data: any): Giveaway {
        data = typeof data === 'object' ? data : {};
        let result = new Giveaway();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.chats)) {
            data["chats"] = [];
            for (let item of this.chats)
                data["chats"].push(item.toJSON());
        }
        data["winnersSelectionDate"] = this.winnersSelectionDate ? this.winnersSelectionDate.toISOString() : <any>undefined;
        data["winnerCount"] = this.winnerCount;
        data["onlyNewMembers"] = this.onlyNewMembers;
        data["hasPublicWinners"] = this.hasPublicWinners;
        data["prizeDescription"] = this.prizeDescription;
        if (Array.isArray(this.countryCodes)) {
            data["countryCodes"] = [];
            for (let item of this.countryCodes)
                data["countryCodes"].push(item);
        }
        data["prizeStarCount"] = this.prizeStarCount;
        data["premiumSubscriptionMonthCount"] = this.premiumSubscriptionMonthCount;
        return data;
    }
}

/** This object represents a message about a scheduled giveaway. */
export interface IGiveaway {
    /** The list of chats which the user must join to participate in the giveaway */
    chats: Chat[];
    /** Point in time when winners of the giveaway will be selected */
    winnersSelectionDate: Date;
    /** The number of users which are supposed to be selected as winners of the giveaway */
    winnerCount: number;
    /** Optional. true, if only users who join the chats after the giveaway started should be eligible to win */
    onlyNewMembers: boolean;
    /** Optional. true, if the list of giveaway winners will be visible to everyone */
    hasPublicWinners: boolean;
    /** Optional. Description of additional giveaway prize */
    prizeDescription?: string | undefined;
    /** Optional. A list of two-letter ISO 3166-1 alpha-2 country codes indicating the countries from which eligible users for the giveaway must come. If empty, then all users can participate in the giveaway. Users with a phone number that was bought on Fragment can always participate in giveaways. */
    countryCodes?: string[] | undefined;
    /** Optional. The number of Telegram Stars to be split between giveaway winners; for Telegram Star giveaways only */
    prizeStarCount?: number | undefined;
    /** Optional. The number of months the Telegram Premium subscription won from the giveaway will be active for; for Telegram Premium giveaways only */
    premiumSubscriptionMonthCount?: number | undefined;
}

/** This object represents a message about the completion of a giveaway with public winners. */
export class GiveawayWinners implements IGiveawayWinners {
    /** The chat that created the giveaway */
    chat!: Chat;
    /** Identifier of the message with the giveaway in the chat */
    giveawayMessageId!: number;
    /** Point in time when winners of the giveaway were selected */
    winnersSelectionDate!: Date;
    /** Total number of winners in the giveaway */
    winnerCount!: number;
    /** List of up to 100 winners of the giveaway */
    winners!: User[];
    /** Optional. The number of other chats the user had to join in order to be eligible for the giveaway */
    additionalChatCount?: number | undefined;
    /** Optional. The number of Telegram Stars that were split between giveaway winners; for Telegram Star giveaways only */
    prizeStarCount?: number | undefined;
    /** Optional. The number of months the Telegram Premium subscription won from the giveaway will be active for; for Telegram Premium giveaways only */
    premiumSubscriptionMonthCount?: number | undefined;
    /** Optional. Number of undistributed prizes */
    unclaimedPrizeCount?: number | undefined;
    /** Optional. true, if only users who had joined the chats after the giveaway started were eligible to win */
    onlyNewMembers!: boolean;
    /** Optional. true, if the giveaway was canceled because the payment for it was refunded */
    wasRefunded!: boolean;
    /** Optional. Description of additional giveaway prize */
    prizeDescription?: string | undefined;

    constructor(data?: IGiveawayWinners) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chat = new Chat();
            this.winners = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chat = _data["chat"] ? Chat.fromJS(_data["chat"]) : new Chat();
            this.giveawayMessageId = _data["giveawayMessageId"];
            this.winnersSelectionDate = _data["winnersSelectionDate"] ? new Date(_data["winnersSelectionDate"].toString()) : <any>undefined;
            this.winnerCount = _data["winnerCount"];
            if (Array.isArray(_data["winners"])) {
                this.winners = [] as any;
                for (let item of _data["winners"])
                    this.winners!.push(User.fromJS(item));
            }
            this.additionalChatCount = _data["additionalChatCount"];
            this.prizeStarCount = _data["prizeStarCount"];
            this.premiumSubscriptionMonthCount = _data["premiumSubscriptionMonthCount"];
            this.unclaimedPrizeCount = _data["unclaimedPrizeCount"];
            this.onlyNewMembers = _data["onlyNewMembers"];
            this.wasRefunded = _data["wasRefunded"];
            this.prizeDescription = _data["prizeDescription"];
        }
    }

    static fromJS(data: any): GiveawayWinners {
        data = typeof data === 'object' ? data : {};
        let result = new GiveawayWinners();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chat"] = this.chat ? this.chat.toJSON() : <any>undefined;
        data["giveawayMessageId"] = this.giveawayMessageId;
        data["winnersSelectionDate"] = this.winnersSelectionDate ? this.winnersSelectionDate.toISOString() : <any>undefined;
        data["winnerCount"] = this.winnerCount;
        if (Array.isArray(this.winners)) {
            data["winners"] = [];
            for (let item of this.winners)
                data["winners"].push(item.toJSON());
        }
        data["additionalChatCount"] = this.additionalChatCount;
        data["prizeStarCount"] = this.prizeStarCount;
        data["premiumSubscriptionMonthCount"] = this.premiumSubscriptionMonthCount;
        data["unclaimedPrizeCount"] = this.unclaimedPrizeCount;
        data["onlyNewMembers"] = this.onlyNewMembers;
        data["wasRefunded"] = this.wasRefunded;
        data["prizeDescription"] = this.prizeDescription;
        return data;
    }
}

/** This object represents a message about the completion of a giveaway with public winners. */
export interface IGiveawayWinners {
    /** The chat that created the giveaway */
    chat: Chat;
    /** Identifier of the message with the giveaway in the chat */
    giveawayMessageId: number;
    /** Point in time when winners of the giveaway were selected */
    winnersSelectionDate: Date;
    /** Total number of winners in the giveaway */
    winnerCount: number;
    /** List of up to 100 winners of the giveaway */
    winners: User[];
    /** Optional. The number of other chats the user had to join in order to be eligible for the giveaway */
    additionalChatCount?: number | undefined;
    /** Optional. The number of Telegram Stars that were split between giveaway winners; for Telegram Star giveaways only */
    prizeStarCount?: number | undefined;
    /** Optional. The number of months the Telegram Premium subscription won from the giveaway will be active for; for Telegram Premium giveaways only */
    premiumSubscriptionMonthCount?: number | undefined;
    /** Optional. Number of undistributed prizes */
    unclaimedPrizeCount?: number | undefined;
    /** Optional. true, if only users who had joined the chats after the giveaway started were eligible to win */
    onlyNewMembers: boolean;
    /** Optional. true, if the giveaway was canceled because the payment for it was refunded */
    wasRefunded: boolean;
    /** Optional. Description of additional giveaway prize */
    prizeDescription?: string | undefined;
}

/** This object contains basic information about an invoice. */
export class Invoice implements IInvoice {
    /** Product name */
    title!: string;
    /** Product description */
    description!: string;
    /** Unique bot deep-linking parameter that can be used to generate this invoice */
    startParameter!: string;
    /** Three-letter ISO 4217 currency code, or “XTR” for payments in Telegram Stars */
    currency!: string;
    /** Total price in the smallest units of the currency (integer, not float/double). For example, for a price of US$ 1.45 pass amount = 145. See the exp parameter in currencies.json, it shows the number of digits past the decimal point for each currency (2 for the majority of currencies). */
    totalAmount!: number;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.startParameter = _data["startParameter"];
            this.currency = _data["currency"];
            this.totalAmount = _data["totalAmount"];
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["startParameter"] = this.startParameter;
        data["currency"] = this.currency;
        data["totalAmount"] = this.totalAmount;
        return data;
    }
}

/** This object contains basic information about an invoice. */
export interface IInvoice {
    /** Product name */
    title: string;
    /** Product description */
    description: string;
    /** Unique bot deep-linking parameter that can be used to generate this invoice */
    startParameter: string;
    /** Three-letter ISO 4217 currency code, or “XTR” for payments in Telegram Stars */
    currency: string;
    /** Total price in the smallest units of the currency (integer, not float/double). For example, for a price of US$ 1.45 pass amount = 145. See the exp parameter in currencies.json, it shows the number of digits past the decimal point for each currency (2 for the majority of currencies). */
    totalAmount: number;
}

/** This object represents a point on the map. */
export class Location implements ILocation {
    /** Latitude as defined by the sender */
    latitude!: number;
    /** Longitude as defined by the sender */
    longitude!: number;
    /** Optional. The radius of uncertainty for the location, measured in meters; 0-1500 */
    horizontalAccuracy?: number | undefined;
    /** Optional. Time relative to the message sending date, during which the location can be updated; in seconds. For active live locations only. */
    livePeriod?: number | undefined;
    /** Optional. The direction in which user is moving, in degrees; 1-360. For active live locations only. */
    heading?: number | undefined;
    /** Optional. The maximum distance for proximity alerts about approaching another chat member, in meters. For sent live locations only. */
    proximityAlertRadius?: number | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.horizontalAccuracy = _data["horizontalAccuracy"];
            this.livePeriod = _data["livePeriod"];
            this.heading = _data["heading"];
            this.proximityAlertRadius = _data["proximityAlertRadius"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["horizontalAccuracy"] = this.horizontalAccuracy;
        data["livePeriod"] = this.livePeriod;
        data["heading"] = this.heading;
        data["proximityAlertRadius"] = this.proximityAlertRadius;
        return data;
    }
}

/** This object represents a point on the map. */
export interface ILocation {
    /** Latitude as defined by the sender */
    latitude: number;
    /** Longitude as defined by the sender */
    longitude: number;
    /** Optional. The radius of uncertainty for the location, measured in meters; 0-1500 */
    horizontalAccuracy?: number | undefined;
    /** Optional. Time relative to the message sending date, during which the location can be updated; in seconds. For active live locations only. */
    livePeriod?: number | undefined;
    /** Optional. The direction in which user is moving, in degrees; 1-360. For active live locations only. */
    heading?: number | undefined;
    /** Optional. The maximum distance for proximity alerts about approaching another chat member, in meters. For sent live locations only. */
    proximityAlertRadius?: number | undefined;
}

/** This object contains information about a poll. */
export class Poll implements IPoll {
    /** Unique poll identifier */
    id!: string;
    /** Poll question, 1-300 characters */
    question!: string;
    /** Optional. Special entities that appear in the Question. Currently, only custom emoji entities are allowed in poll questions */
    questionEntities?: MessageEntity[] | undefined;
    /** List of poll options */
    options!: PollOption[];
    /** Total number of users that voted in the poll */
    totalVoterCount!: number;
    /** true, if the poll is closed */
    isClosed!: boolean;
    /** true, if the poll is anonymous */
    isAnonymous!: boolean;
    /** Poll type, currently can be “regular” or “quiz” */
    type!: string;
    /** true, if the poll allows multiple answers */
    allowsMultipleAnswers!: boolean;
    /** Optional. 0-based identifier of the correct answer option. Available only for polls in the quiz mode, which are closed, or was sent (not forwarded) by the bot or to the private chat with the bot. */
    correctOptionId?: number | undefined;
    /** Optional. Text that is shown when a user chooses an incorrect answer or taps on the lamp icon in a quiz-style poll, 0-200 characters */
    explanation?: string | undefined;
    /** Optional. Special entities like usernames, URLs, bot commands, etc. that appear in the Explanation */
    explanationEntities?: MessageEntity[] | undefined;
    /** Optional. Amount of time in seconds the poll will be active after creation */
    openPeriod?: number | undefined;
    /** Optional. Point in time when the poll will be automatically closed */
    closeDate?: Date | undefined;

    constructor(data?: IPoll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.options = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.question = _data["question"];
            if (Array.isArray(_data["questionEntities"])) {
                this.questionEntities = [] as any;
                for (let item of _data["questionEntities"])
                    this.questionEntities!.push(MessageEntity.fromJS(item));
            }
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(PollOption.fromJS(item));
            }
            this.totalVoterCount = _data["totalVoterCount"];
            this.isClosed = _data["isClosed"];
            this.isAnonymous = _data["isAnonymous"];
            this.type = _data["type"];
            this.allowsMultipleAnswers = _data["allowsMultipleAnswers"];
            this.correctOptionId = _data["correctOptionId"];
            this.explanation = _data["explanation"];
            if (Array.isArray(_data["explanationEntities"])) {
                this.explanationEntities = [] as any;
                for (let item of _data["explanationEntities"])
                    this.explanationEntities!.push(MessageEntity.fromJS(item));
            }
            this.openPeriod = _data["openPeriod"];
            this.closeDate = _data["closeDate"] ? new Date(_data["closeDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Poll {
        data = typeof data === 'object' ? data : {};
        let result = new Poll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["question"] = this.question;
        if (Array.isArray(this.questionEntities)) {
            data["questionEntities"] = [];
            for (let item of this.questionEntities)
                data["questionEntities"].push(item.toJSON());
        }
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        data["totalVoterCount"] = this.totalVoterCount;
        data["isClosed"] = this.isClosed;
        data["isAnonymous"] = this.isAnonymous;
        data["type"] = this.type;
        data["allowsMultipleAnswers"] = this.allowsMultipleAnswers;
        data["correctOptionId"] = this.correctOptionId;
        data["explanation"] = this.explanation;
        if (Array.isArray(this.explanationEntities)) {
            data["explanationEntities"] = [];
            for (let item of this.explanationEntities)
                data["explanationEntities"].push(item.toJSON());
        }
        data["openPeriod"] = this.openPeriod;
        data["closeDate"] = this.closeDate ? this.closeDate.toISOString() : <any>undefined;
        return data;
    }
}

/** This object contains information about a poll. */
export interface IPoll {
    /** Unique poll identifier */
    id: string;
    /** Poll question, 1-300 characters */
    question: string;
    /** Optional. Special entities that appear in the Question. Currently, only custom emoji entities are allowed in poll questions */
    questionEntities?: MessageEntity[] | undefined;
    /** List of poll options */
    options: PollOption[];
    /** Total number of users that voted in the poll */
    totalVoterCount: number;
    /** true, if the poll is closed */
    isClosed: boolean;
    /** true, if the poll is anonymous */
    isAnonymous: boolean;
    /** Poll type, currently can be “regular” or “quiz” */
    type: string;
    /** true, if the poll allows multiple answers */
    allowsMultipleAnswers: boolean;
    /** Optional. 0-based identifier of the correct answer option. Available only for polls in the quiz mode, which are closed, or was sent (not forwarded) by the bot or to the private chat with the bot. */
    correctOptionId?: number | undefined;
    /** Optional. Text that is shown when a user chooses an incorrect answer or taps on the lamp icon in a quiz-style poll, 0-200 characters */
    explanation?: string | undefined;
    /** Optional. Special entities like usernames, URLs, bot commands, etc. that appear in the Explanation */
    explanationEntities?: MessageEntity[] | undefined;
    /** Optional. Amount of time in seconds the poll will be active after creation */
    openPeriod?: number | undefined;
    /** Optional. Point in time when the poll will be automatically closed */
    closeDate?: Date | undefined;
}

/** This object contains information about one answer option in a poll. */
export class PollOption implements IPollOption {
    /** Option text, 1-100 characters */
    text!: string;
    /** Optional. Special entities that appear in the option Text. Currently, only custom emoji entities are allowed in poll option texts */
    textEntities?: MessageEntity[] | undefined;
    /** Number of users that voted for this option */
    voterCount!: number;

    constructor(data?: IPollOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            if (Array.isArray(_data["textEntities"])) {
                this.textEntities = [] as any;
                for (let item of _data["textEntities"])
                    this.textEntities!.push(MessageEntity.fromJS(item));
            }
            this.voterCount = _data["voterCount"];
        }
    }

    static fromJS(data: any): PollOption {
        data = typeof data === 'object' ? data : {};
        let result = new PollOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        if (Array.isArray(this.textEntities)) {
            data["textEntities"] = [];
            for (let item of this.textEntities)
                data["textEntities"].push(item.toJSON());
        }
        data["voterCount"] = this.voterCount;
        return data;
    }
}

/** This object contains information about one answer option in a poll. */
export interface IPollOption {
    /** Option text, 1-100 characters */
    text: string;
    /** Optional. Special entities that appear in the option Text. Currently, only custom emoji entities are allowed in poll option texts */
    textEntities?: MessageEntity[] | undefined;
    /** Number of users that voted for this option */
    voterCount: number;
}

/** This object represents a venue. */
export class Venue implements IVenue {
    /** Venue location. Can't be a live location */
    location!: Location;
    /** Name of the venue */
    title!: string;
    /** Address of the venue */
    address!: string;
    /** Optional. Foursquare identifier of the venue */
    foursquareId?: string | undefined;
    /** Optional. Foursquare type of the venue. (For example, “arts_entertainment/default”, “arts_entertainment/aquarium” or “food/icecream”.) */
    foursquareType?: string | undefined;
    /** Optional. Google Places identifier of the venue */
    googlePlaceId?: string | undefined;
    /** Optional. Google Places type of the venue. (See supported types.) */
    googlePlaceType?: string | undefined;

    constructor(data?: IVenue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.location = new Location();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : new Location();
            this.title = _data["title"];
            this.address = _data["address"];
            this.foursquareId = _data["foursquareId"];
            this.foursquareType = _data["foursquareType"];
            this.googlePlaceId = _data["googlePlaceId"];
            this.googlePlaceType = _data["googlePlaceType"];
        }
    }

    static fromJS(data: any): Venue {
        data = typeof data === 'object' ? data : {};
        let result = new Venue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["address"] = this.address;
        data["foursquareId"] = this.foursquareId;
        data["foursquareType"] = this.foursquareType;
        data["googlePlaceId"] = this.googlePlaceId;
        data["googlePlaceType"] = this.googlePlaceType;
        return data;
    }
}

/** This object represents a venue. */
export interface IVenue {
    /** Venue location. Can't be a live location */
    location: Location;
    /** Name of the venue */
    title: string;
    /** Address of the venue */
    address: string;
    /** Optional. Foursquare identifier of the venue */
    foursquareId?: string | undefined;
    /** Optional. Foursquare type of the venue. (For example, “arts_entertainment/default”, “arts_entertainment/aquarium” or “food/icecream”.) */
    foursquareType?: string | undefined;
    /** Optional. Google Places identifier of the venue */
    googlePlaceId?: string | undefined;
    /** Optional. Google Places type of the venue. (See supported types.) */
    googlePlaceType?: string | undefined;
}

/** This object contains information about the quoted part of a message that is replied to by the given message. */
export class TextQuote implements ITextQuote {
    /** Text of the quoted part of a message that is replied to by the given message */
    text!: string;
    /** Optional. Special entities that appear in the quote. Currently, only bold, italic, underline, strikethrough, spoiler, and CustomEmoji entities are kept in quotes. */
    entities?: MessageEntity[] | undefined;
    /** Approximate quote position in the original message in UTF-16 code units as specified by the sender */
    position!: number;
    /** Optional. true, if the quote was chosen manually by the message sender. Otherwise, the quote was added automatically by the server. */
    isManual!: boolean;

    constructor(data?: ITextQuote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(MessageEntity.fromJS(item));
            }
            this.position = _data["position"];
            this.isManual = _data["isManual"];
        }
    }

    static fromJS(data: any): TextQuote {
        data = typeof data === 'object' ? data : {};
        let result = new TextQuote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        data["position"] = this.position;
        data["isManual"] = this.isManual;
        return data;
    }
}

/** This object contains information about the quoted part of a message that is replied to by the given message. */
export interface ITextQuote {
    /** Text of the quoted part of a message that is replied to by the given message */
    text: string;
    /** Optional. Special entities that appear in the quote. Currently, only bold, italic, underline, strikethrough, spoiler, and CustomEmoji entities are kept in quotes. */
    entities?: MessageEntity[] | undefined;
    /** Approximate quote position in the original message in UTF-16 code units as specified by the sender */
    position: number;
    /** Optional. true, if the quote was chosen manually by the message sender. Otherwise, the quote was added automatically by the server. */
    isManual: boolean;
}

/** This object represents a service message about a change in auto-delete timer settings. */
export class MessageAutoDeleteTimerChanged implements IMessageAutoDeleteTimerChanged {
    /** New auto-delete time for messages in the chat; in seconds */
    messageAutoDeleteTime!: number;

    constructor(data?: IMessageAutoDeleteTimerChanged) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageAutoDeleteTime = _data["messageAutoDeleteTime"];
        }
    }

    static fromJS(data: any): MessageAutoDeleteTimerChanged {
        data = typeof data === 'object' ? data : {};
        let result = new MessageAutoDeleteTimerChanged();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageAutoDeleteTime"] = this.messageAutoDeleteTime;
        return data;
    }
}

/** This object represents a service message about a change in auto-delete timer settings. */
export interface IMessageAutoDeleteTimerChanged {
    /** New auto-delete time for messages in the chat; in seconds */
    messageAutoDeleteTime: number;
}

/** This object contains basic information about a successful payment. */
export class SuccessfulPayment implements ISuccessfulPayment {
    /** Three-letter ISO 4217 currency code, or “XTR” for payments in Telegram Stars */
    currency!: string;
    /** Total price in the smallest units of the currency (integer, not float/double). For example, for a price of US$ 1.45 pass amount = 145. See the exp parameter in currencies.json, it shows the number of digits past the decimal point for each currency (2 for the majority of currencies). */
    totalAmount!: number;
    /** Bot-specified invoice payload */
    invoicePayload!: string;
    /** Optional. Identifier of the shipping option chosen by the user */
    shippingOptionId?: string | undefined;
    /** Optional. Order information provided by the user */
    orderInfo?: OrderInfo | undefined;
    /** Telegram payment identifier */
    telegramPaymentChargeId!: string;
    /** Provider payment identifier */
    providerPaymentChargeId!: string;

    constructor(data?: ISuccessfulPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            this.totalAmount = _data["totalAmount"];
            this.invoicePayload = _data["invoicePayload"];
            this.shippingOptionId = _data["shippingOptionId"];
            this.orderInfo = _data["orderInfo"] ? OrderInfo.fromJS(_data["orderInfo"]) : <any>undefined;
            this.telegramPaymentChargeId = _data["telegramPaymentChargeId"];
            this.providerPaymentChargeId = _data["providerPaymentChargeId"];
        }
    }

    static fromJS(data: any): SuccessfulPayment {
        data = typeof data === 'object' ? data : {};
        let result = new SuccessfulPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["totalAmount"] = this.totalAmount;
        data["invoicePayload"] = this.invoicePayload;
        data["shippingOptionId"] = this.shippingOptionId;
        data["orderInfo"] = this.orderInfo ? this.orderInfo.toJSON() : <any>undefined;
        data["telegramPaymentChargeId"] = this.telegramPaymentChargeId;
        data["providerPaymentChargeId"] = this.providerPaymentChargeId;
        return data;
    }
}

/** This object contains basic information about a successful payment. */
export interface ISuccessfulPayment {
    /** Three-letter ISO 4217 currency code, or “XTR” for payments in Telegram Stars */
    currency: string;
    /** Total price in the smallest units of the currency (integer, not float/double). For example, for a price of US$ 1.45 pass amount = 145. See the exp parameter in currencies.json, it shows the number of digits past the decimal point for each currency (2 for the majority of currencies). */
    totalAmount: number;
    /** Bot-specified invoice payload */
    invoicePayload: string;
    /** Optional. Identifier of the shipping option chosen by the user */
    shippingOptionId?: string | undefined;
    /** Optional. Order information provided by the user */
    orderInfo?: OrderInfo | undefined;
    /** Telegram payment identifier */
    telegramPaymentChargeId: string;
    /** Provider payment identifier */
    providerPaymentChargeId: string;
}

/** This object represents information about an order. */
export class OrderInfo implements IOrderInfo {
    /** Optional. User name */
    name?: string | undefined;
    /** Optional. User's phone number */
    phoneNumber?: string | undefined;
    /** Optional. User email */
    email?: string | undefined;
    /** Optional. User shipping address */
    shippingAddress?: ShippingAddress | undefined;

    constructor(data?: IOrderInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.shippingAddress = _data["shippingAddress"] ? ShippingAddress.fromJS(_data["shippingAddress"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        return data;
    }
}

/** This object represents information about an order. */
export interface IOrderInfo {
    /** Optional. User name */
    name?: string | undefined;
    /** Optional. User's phone number */
    phoneNumber?: string | undefined;
    /** Optional. User email */
    email?: string | undefined;
    /** Optional. User shipping address */
    shippingAddress?: ShippingAddress | undefined;
}

/** This object represents a shipping address. */
export class ShippingAddress implements IShippingAddress {
    /** Two-letter ISO 3166-1 alpha-2 country code */
    countryCode!: string;
    /** State, if applicable */
    state?: string | undefined;
    /** City */
    city!: string;
    /** First line for the address */
    streetLine1!: string;
    /** Second line for the address */
    streetLine2!: string;
    /** Address post code */
    postCode!: string;

    constructor(data?: IShippingAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.streetLine1 = _data["streetLine1"];
            this.streetLine2 = _data["streetLine2"];
            this.postCode = _data["postCode"];
        }
    }

    static fromJS(data: any): ShippingAddress {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["state"] = this.state;
        data["city"] = this.city;
        data["streetLine1"] = this.streetLine1;
        data["streetLine2"] = this.streetLine2;
        data["postCode"] = this.postCode;
        return data;
    }
}

/** This object represents a shipping address. */
export interface IShippingAddress {
    /** Two-letter ISO 3166-1 alpha-2 country code */
    countryCode: string;
    /** State, if applicable */
    state?: string | undefined;
    /** City */
    city: string;
    /** First line for the address */
    streetLine1: string;
    /** Second line for the address */
    streetLine2: string;
    /** Address post code */
    postCode: string;
}

/** This object contains basic information about a refunded payment. */
export class RefundedPayment implements IRefundedPayment {
    /** Three-letter ISO 4217 currency code, or “XTR” for payments in Telegram Stars. Currently, always “XTR” */
    currency!: string;
    /** Total refunded price in the smallest units of the currency (integer, not float/double). For example, for a price of US$ 1.45, TotalAmount = 145. See the exp parameter in currencies.json, it shows the number of digits past the decimal point for each currency (2 for the majority of currencies). */
    totalAmount!: number;
    /** Bot-specified invoice payload */
    invoicePayload!: string;
    /** Telegram payment identifier */
    telegramPaymentChargeId!: string;
    /** Optional. Provider payment identifier */
    providerPaymentChargeId?: string | undefined;

    constructor(data?: IRefundedPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currency = _data["currency"];
            this.totalAmount = _data["totalAmount"];
            this.invoicePayload = _data["invoicePayload"];
            this.telegramPaymentChargeId = _data["telegramPaymentChargeId"];
            this.providerPaymentChargeId = _data["providerPaymentChargeId"];
        }
    }

    static fromJS(data: any): RefundedPayment {
        data = typeof data === 'object' ? data : {};
        let result = new RefundedPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["totalAmount"] = this.totalAmount;
        data["invoicePayload"] = this.invoicePayload;
        data["telegramPaymentChargeId"] = this.telegramPaymentChargeId;
        data["providerPaymentChargeId"] = this.providerPaymentChargeId;
        return data;
    }
}

/** This object contains basic information about a refunded payment. */
export interface IRefundedPayment {
    /** Three-letter ISO 4217 currency code, or “XTR” for payments in Telegram Stars. Currently, always “XTR” */
    currency: string;
    /** Total refunded price in the smallest units of the currency (integer, not float/double). For example, for a price of US$ 1.45, TotalAmount = 145. See the exp parameter in currencies.json, it shows the number of digits past the decimal point for each currency (2 for the majority of currencies). */
    totalAmount: number;
    /** Bot-specified invoice payload */
    invoicePayload: string;
    /** Telegram payment identifier */
    telegramPaymentChargeId: string;
    /** Optional. Provider payment identifier */
    providerPaymentChargeId?: string | undefined;
}

/** This object contains information about the users whose identifiers were shared with the bot using a KeyboardButtonRequestUsers button. */
export class UsersShared implements IUsersShared {
    /** Identifier of the request */
    requestId!: number;
    /** Information about users shared with the bot. */
    users!: SharedUser[];

    constructor(data?: IUsersShared) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(SharedUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UsersShared {
        data = typeof data === 'object' ? data : {};
        let result = new UsersShared();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

/** This object contains information about the users whose identifiers were shared with the bot using a KeyboardButtonRequestUsers button. */
export interface IUsersShared {
    /** Identifier of the request */
    requestId: number;
    /** Information about users shared with the bot. */
    users: SharedUser[];
}

/** This object contains information about a user that was shared with the bot using a KeyboardButtonRequestUsers button. */
export class SharedUser implements ISharedUser {
    /** Identifier of the shared user. The bot may not have access to the user and could be unable to use this identifier, unless the user is already known to the bot by some other means. */
    userId!: number;
    /** Optional. First name of the user, if the name was requested by the bot */
    firstName?: string | undefined;
    /** Optional. Last name of the user, if the name was requested by the bot */
    lastName?: string | undefined;
    /** Optional. Username of the user, if the username was requested by the bot */
    username?: string | undefined;
    /** Optional. Available sizes of the chat photo, if the photo was requested by the bot */
    photo?: PhotoSize[] | undefined;

    constructor(data?: ISharedUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.username = _data["username"];
            if (Array.isArray(_data["photo"])) {
                this.photo = [] as any;
                for (let item of _data["photo"])
                    this.photo!.push(PhotoSize.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SharedUser {
        data = typeof data === 'object' ? data : {};
        let result = new SharedUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["username"] = this.username;
        if (Array.isArray(this.photo)) {
            data["photo"] = [];
            for (let item of this.photo)
                data["photo"].push(item.toJSON());
        }
        return data;
    }
}

/** This object contains information about a user that was shared with the bot using a KeyboardButtonRequestUsers button. */
export interface ISharedUser {
    /** Identifier of the shared user. The bot may not have access to the user and could be unable to use this identifier, unless the user is already known to the bot by some other means. */
    userId: number;
    /** Optional. First name of the user, if the name was requested by the bot */
    firstName?: string | undefined;
    /** Optional. Last name of the user, if the name was requested by the bot */
    lastName?: string | undefined;
    /** Optional. Username of the user, if the username was requested by the bot */
    username?: string | undefined;
    /** Optional. Available sizes of the chat photo, if the photo was requested by the bot */
    photo?: PhotoSize[] | undefined;
}

/** This object contains information about a chat that was shared with the bot using a KeyboardButtonRequestChat button. */
export class ChatShared implements IChatShared {
    /** Identifier of the request */
    requestId!: number;
    /** Identifier of the shared chat. The bot may not have access to the chat and could be unable to use this identifier, unless the chat is already known to the bot by some other means. */
    chatId!: number;
    /** Optional. Title of the chat, if the title was requested by the bot. */
    title?: string | undefined;
    /** Optional. Username of the chat, if the username was requested by the bot and available. */
    username?: string | undefined;
    /** Optional. Available sizes of the chat photo, if the photo was requested by the bot */
    photo?: PhotoSize[] | undefined;

    constructor(data?: IChatShared) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"];
            this.chatId = _data["chatId"];
            this.title = _data["title"];
            this.username = _data["username"];
            if (Array.isArray(_data["photo"])) {
                this.photo = [] as any;
                for (let item of _data["photo"])
                    this.photo!.push(PhotoSize.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChatShared {
        data = typeof data === 'object' ? data : {};
        let result = new ChatShared();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId;
        data["chatId"] = this.chatId;
        data["title"] = this.title;
        data["username"] = this.username;
        if (Array.isArray(this.photo)) {
            data["photo"] = [];
            for (let item of this.photo)
                data["photo"].push(item.toJSON());
        }
        return data;
    }
}

/** This object contains information about a chat that was shared with the bot using a KeyboardButtonRequestChat button. */
export interface IChatShared {
    /** Identifier of the request */
    requestId: number;
    /** Identifier of the shared chat. The bot may not have access to the chat and could be unable to use this identifier, unless the chat is already known to the bot by some other means. */
    chatId: number;
    /** Optional. Title of the chat, if the title was requested by the bot. */
    title?: string | undefined;
    /** Optional. Username of the chat, if the username was requested by the bot and available. */
    username?: string | undefined;
    /** Optional. Available sizes of the chat photo, if the photo was requested by the bot */
    photo?: PhotoSize[] | undefined;
}

/** This object represents a service message about a user allowing a bot to write messages after adding it to the attachment menu, launching a Web App from a link, or accepting an explicit request from a Web App sent by the method requestWriteAccess. */
export class WriteAccessAllowed implements IWriteAccessAllowed {
    /** Optional. true, if the access was granted after the user accepted an explicit request from a Web App sent by the method requestWriteAccess */
    fromRequest!: boolean;
    /** Optional. Name of the Web App, if the access was granted when the Web App was launched from a link */
    webAppName?: string | undefined;
    /** Optional. true, if the access was granted when the bot was added to the attachment or side menu */
    fromAttachmentMenu!: boolean;

    constructor(data?: IWriteAccessAllowed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromRequest = _data["fromRequest"];
            this.webAppName = _data["webAppName"];
            this.fromAttachmentMenu = _data["fromAttachmentMenu"];
        }
    }

    static fromJS(data: any): WriteAccessAllowed {
        data = typeof data === 'object' ? data : {};
        let result = new WriteAccessAllowed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromRequest"] = this.fromRequest;
        data["webAppName"] = this.webAppName;
        data["fromAttachmentMenu"] = this.fromAttachmentMenu;
        return data;
    }
}

/** This object represents a service message about a user allowing a bot to write messages after adding it to the attachment menu, launching a Web App from a link, or accepting an explicit request from a Web App sent by the method requestWriteAccess. */
export interface IWriteAccessAllowed {
    /** Optional. true, if the access was granted after the user accepted an explicit request from a Web App sent by the method requestWriteAccess */
    fromRequest: boolean;
    /** Optional. Name of the Web App, if the access was granted when the Web App was launched from a link */
    webAppName?: string | undefined;
    /** Optional. true, if the access was granted when the bot was added to the attachment or side menu */
    fromAttachmentMenu: boolean;
}

/** Describes Telegram Passport data shared with the bot by the user. */
export class PassportData2 implements IPassportData2 {
    /** Array with information about documents and other Telegram Passport elements that was shared with the bot */
    data!: EncryptedPassportElement[];
    /** Encrypted credentials required to decrypt the data */
    credentials!: EncryptedCredentials;

    constructor(data?: IPassportData2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = [];
            this.credentials = new EncryptedCredentials();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(EncryptedPassportElement.fromJS(item));
            }
            this.credentials = _data["credentials"] ? EncryptedCredentials.fromJS(_data["credentials"]) : new EncryptedCredentials();
        }
    }

    static fromJS(data: any): PassportData2 {
        data = typeof data === 'object' ? data : {};
        let result = new PassportData2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["credentials"] = this.credentials ? this.credentials.toJSON() : <any>undefined;
        return data;
    }
}

/** Describes Telegram Passport data shared with the bot by the user. */
export interface IPassportData2 {
    /** Array with information about documents and other Telegram Passport elements that was shared with the bot */
    data: EncryptedPassportElement[];
    /** Encrypted credentials required to decrypt the data */
    credentials: EncryptedCredentials;
}

/** Describes documents or other Telegram Passport elements shared with the bot by the user. */
export class EncryptedPassportElement implements IEncryptedPassportElement {
    /** Element type. One of PersonalDetails, Passport, DriverLicense, IdentityCard, InternalPassport, Address, UtilityBill, BankStatement, RentalAgreement, PassportRegistration, TemporaryRegistration, PhoneNumber, Email. */
    type!: EncryptedPassportElementType;
    /** Optional. Base64-encoded encrypted Telegram Passport element data provided by the user; available only for “PersonalDetails”, “passport”, “DriverLicense”, “IdentityCard”, “InternalPassport” and “address” types. Can be decrypted and verified using the accompanying EncryptedCredentials. */
    data?: string | undefined;
    /** Optional. User's verified phone number; available only for “PhoneNumber” type */
    phoneNumber?: string | undefined;
    /** Optional. User's verified email address; available only for “email” type */
    email?: string | undefined;
    /** Optional. Array of encrypted files with documents provided by the user; available only for “UtilityBill”, “BankStatement”, “RentalAgreement”, “PassportRegistration” and “TemporaryRegistration” types. Files can be decrypted and verified using the accompanying EncryptedCredentials. */
    files?: PassportFile[] | undefined;
    /** Optional. Encrypted file with the front side of the document, provided by the user; available only for “passport”, “DriverLicense”, “IdentityCard” and “InternalPassport”. The file can be decrypted and verified using the accompanying EncryptedCredentials. */
    frontSide?: PassportFile | undefined;
    /** Optional. Encrypted file with the reverse side of the document, provided by the user; available only for “DriverLicense” and “IdentityCard”. The file can be decrypted and verified using the accompanying EncryptedCredentials. */
    reverseSide?: PassportFile | undefined;
    /** Optional. Encrypted file with the selfie of the user holding a document, provided by the user; available if requested for “passport”, “DriverLicense”, “IdentityCard” and “InternalPassport”. The file can be decrypted and verified using the accompanying EncryptedCredentials. */
    selfie?: PassportFile | undefined;
    /** Optional. Array of encrypted files with translated versions of documents provided by the user; available if requested for “passport”, “DriverLicense”, “IdentityCard”, “InternalPassport”, “UtilityBill”, “BankStatement”, “RentalAgreement”, “PassportRegistration” and “TemporaryRegistration” types. Files can be decrypted and verified using the accompanying EncryptedCredentials. */
    translation?: PassportFile[] | undefined;
    /** Base64-encoded element hash for using in PassportElementErrorUnspecified */
    hash!: string;

    constructor(data?: IEncryptedPassportElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.data = _data["data"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(PassportFile.fromJS(item));
            }
            this.frontSide = _data["frontSide"] ? PassportFile.fromJS(_data["frontSide"]) : <any>undefined;
            this.reverseSide = _data["reverseSide"] ? PassportFile.fromJS(_data["reverseSide"]) : <any>undefined;
            this.selfie = _data["selfie"] ? PassportFile.fromJS(_data["selfie"]) : <any>undefined;
            if (Array.isArray(_data["translation"])) {
                this.translation = [] as any;
                for (let item of _data["translation"])
                    this.translation!.push(PassportFile.fromJS(item));
            }
            this.hash = _data["hash"];
        }
    }

    static fromJS(data: any): EncryptedPassportElement {
        data = typeof data === 'object' ? data : {};
        let result = new EncryptedPassportElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["data"] = this.data;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["frontSide"] = this.frontSide ? this.frontSide.toJSON() : <any>undefined;
        data["reverseSide"] = this.reverseSide ? this.reverseSide.toJSON() : <any>undefined;
        data["selfie"] = this.selfie ? this.selfie.toJSON() : <any>undefined;
        if (Array.isArray(this.translation)) {
            data["translation"] = [];
            for (let item of this.translation)
                data["translation"].push(item.toJSON());
        }
        data["hash"] = this.hash;
        return data;
    }
}

/** Describes documents or other Telegram Passport elements shared with the bot by the user. */
export interface IEncryptedPassportElement {
    /** Element type. One of PersonalDetails, Passport, DriverLicense, IdentityCard, InternalPassport, Address, UtilityBill, BankStatement, RentalAgreement, PassportRegistration, TemporaryRegistration, PhoneNumber, Email. */
    type: EncryptedPassportElementType;
    /** Optional. Base64-encoded encrypted Telegram Passport element data provided by the user; available only for “PersonalDetails”, “passport”, “DriverLicense”, “IdentityCard”, “InternalPassport” and “address” types. Can be decrypted and verified using the accompanying EncryptedCredentials. */
    data?: string | undefined;
    /** Optional. User's verified phone number; available only for “PhoneNumber” type */
    phoneNumber?: string | undefined;
    /** Optional. User's verified email address; available only for “email” type */
    email?: string | undefined;
    /** Optional. Array of encrypted files with documents provided by the user; available only for “UtilityBill”, “BankStatement”, “RentalAgreement”, “PassportRegistration” and “TemporaryRegistration” types. Files can be decrypted and verified using the accompanying EncryptedCredentials. */
    files?: PassportFile[] | undefined;
    /** Optional. Encrypted file with the front side of the document, provided by the user; available only for “passport”, “DriverLicense”, “IdentityCard” and “InternalPassport”. The file can be decrypted and verified using the accompanying EncryptedCredentials. */
    frontSide?: PassportFile | undefined;
    /** Optional. Encrypted file with the reverse side of the document, provided by the user; available only for “DriverLicense” and “IdentityCard”. The file can be decrypted and verified using the accompanying EncryptedCredentials. */
    reverseSide?: PassportFile | undefined;
    /** Optional. Encrypted file with the selfie of the user holding a document, provided by the user; available if requested for “passport”, “DriverLicense”, “IdentityCard” and “InternalPassport”. The file can be decrypted and verified using the accompanying EncryptedCredentials. */
    selfie?: PassportFile | undefined;
    /** Optional. Array of encrypted files with translated versions of documents provided by the user; available if requested for “passport”, “DriverLicense”, “IdentityCard”, “InternalPassport”, “UtilityBill”, “BankStatement”, “RentalAgreement”, “PassportRegistration” and “TemporaryRegistration” types. Files can be decrypted and verified using the accompanying EncryptedCredentials. */
    translation?: PassportFile[] | undefined;
    /** Base64-encoded element hash for using in PassportElementErrorUnspecified */
    hash: string;
}

/** EncryptedPassportElement: Element type. One of PersonalDetails, Passport, DriverLicense, IdentityCard, InternalPassport, Address, UtilityBill, BankStatement, RentalAgreement, PassportRegistration, TemporaryRegistration, PhoneNumber, Email. */
export enum EncryptedPassportElementType {
    PersonalDetails = 1,
    Passport = 2,
    DriverLicense = 3,
    IdentityCard = 4,
    InternalPassport = 5,
    Address = 6,
    UtilityBill = 7,
    BankStatement = 8,
    RentalAgreement = 9,
    PassportRegistration = 10,
    TemporaryRegistration = 11,
    PhoneNumber = 12,
    Email = 13,
}

/** This object represents a file uploaded to Telegram Passport. Currently all Telegram Passport files are in JPEG format when decrypted and don't exceed 10MB. */
export class PassportFile extends FileBase implements IPassportFile {
    /** DateTime when the file was uploaded */
    fileDate!: Date;

    constructor(data?: IPassportFile) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fileDate = _data["fileDate"] ? new Date(_data["fileDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): PassportFile {
        data = typeof data === 'object' ? data : {};
        let result = new PassportFile();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileDate"] = this.fileDate ? this.fileDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** This object represents a file uploaded to Telegram Passport. Currently all Telegram Passport files are in JPEG format when decrypted and don't exceed 10MB. */
export interface IPassportFile extends IFileBase {
    /** DateTime when the file was uploaded */
    fileDate: Date;
}

/** Describes data required for decrypting and authenticating EncryptedPassportElement. See the Telegram Passport Documentation for a complete description of the data decryption and authentication processes. */
export class EncryptedCredentials implements IEncryptedCredentials {
    /** Base64-encoded encrypted JSON-serialized data with unique user's payload, data hashes and secrets required for EncryptedPassportElement decryption and authentication */
    data!: string;
    /** Base64-encoded data hash for data authentication */
    hash!: string;
    /** Base64-encoded secret, encrypted with the bot's public RSA key, required for data decryption */
    secret!: string;

    constructor(data?: IEncryptedCredentials) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.hash = _data["hash"];
            this.secret = _data["secret"];
        }
    }

    static fromJS(data: any): EncryptedCredentials {
        data = typeof data === 'object' ? data : {};
        let result = new EncryptedCredentials();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["hash"] = this.hash;
        data["secret"] = this.secret;
        return data;
    }
}

/** Describes data required for decrypting and authenticating EncryptedPassportElement. See the Telegram Passport Documentation for a complete description of the data decryption and authentication processes. */
export interface IEncryptedCredentials {
    /** Base64-encoded encrypted JSON-serialized data with unique user's payload, data hashes and secrets required for EncryptedPassportElement decryption and authentication */
    data: string;
    /** Base64-encoded data hash for data authentication */
    hash: string;
    /** Base64-encoded secret, encrypted with the bot's public RSA key, required for data decryption */
    secret: string;
}

/** This object represents the content of a service message, sent whenever a user in the chat triggers a proximity alert set by another user. */
export class ProximityAlertTriggered implements IProximityAlertTriggered {
    /** User that triggered the alert */
    traveler!: User;
    /** User that set the alert */
    watcher!: User;
    /** The distance between the users */
    distance!: number;

    constructor(data?: IProximityAlertTriggered) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.traveler = new User();
            this.watcher = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.traveler = _data["traveler"] ? User.fromJS(_data["traveler"]) : new User();
            this.watcher = _data["watcher"] ? User.fromJS(_data["watcher"]) : new User();
            this.distance = _data["distance"];
        }
    }

    static fromJS(data: any): ProximityAlertTriggered {
        data = typeof data === 'object' ? data : {};
        let result = new ProximityAlertTriggered();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["traveler"] = this.traveler ? this.traveler.toJSON() : <any>undefined;
        data["watcher"] = this.watcher ? this.watcher.toJSON() : <any>undefined;
        data["distance"] = this.distance;
        return data;
    }
}

/** This object represents the content of a service message, sent whenever a user in the chat triggers a proximity alert set by another user. */
export interface IProximityAlertTriggered {
    /** User that triggered the alert */
    traveler: User;
    /** User that set the alert */
    watcher: User;
    /** The distance between the users */
    distance: number;
}

/** This object represents a service message about a user boosting a chat. */
export class ChatBoostAdded implements IChatBoostAdded {
    /** Number of boosts added by the user */
    boostCount!: number;

    constructor(data?: IChatBoostAdded) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boostCount = _data["boostCount"];
        }
    }

    static fromJS(data: any): ChatBoostAdded {
        data = typeof data === 'object' ? data : {};
        let result = new ChatBoostAdded();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boostCount"] = this.boostCount;
        return data;
    }
}

/** This object represents a service message about a user boosting a chat. */
export interface IChatBoostAdded {
    /** Number of boosts added by the user */
    boostCount: number;
}

/** This object represents a chat background. */
export class ChatBackground implements IChatBackground {
    /** Type of the background */
    type!: BackgroundType;

    constructor(data?: IChatBackground) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] ? BackgroundType.fromJS(_data["type"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatBackground {
        data = typeof data === 'object' ? data : {};
        let result = new ChatBackground();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        return data;
    }
}

/** This object represents a chat background. */
export interface IChatBackground {
    /** Type of the background */
    type: BackgroundType;
}

/** This object describes the type of a background. Currently, it can be one ofBackgroundTypeFill, BackgroundTypeWallpaper, BackgroundTypePattern, BackgroundTypeChatTheme */
export abstract class BackgroundType implements IBackgroundType {

    constructor(data?: IBackgroundType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BackgroundType {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BackgroundType' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** This object describes the type of a background. Currently, it can be one ofBackgroundTypeFill, BackgroundTypeWallpaper, BackgroundTypePattern, BackgroundTypeChatTheme */
export interface IBackgroundType {
}

/** This object represents a service message about a new forum topic created in the chat. */
export class ForumTopicCreated implements IForumTopicCreated {
    /** Name of the topic */
    name!: string;
    /** Color of the topic icon in RGB format */
    iconColor!: number;
    /** Optional. Unique identifier of the custom emoji shown as the topic icon */
    iconCustomEmojiId?: string | undefined;

    constructor(data?: IForumTopicCreated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.iconColor = _data["iconColor"];
            this.iconCustomEmojiId = _data["iconCustomEmojiId"];
        }
    }

    static fromJS(data: any): ForumTopicCreated {
        data = typeof data === 'object' ? data : {};
        let result = new ForumTopicCreated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["iconColor"] = this.iconColor;
        data["iconCustomEmojiId"] = this.iconCustomEmojiId;
        return data;
    }
}

/** This object represents a service message about a new forum topic created in the chat. */
export interface IForumTopicCreated {
    /** Name of the topic */
    name: string;
    /** Color of the topic icon in RGB format */
    iconColor: number;
    /** Optional. Unique identifier of the custom emoji shown as the topic icon */
    iconCustomEmojiId?: string | undefined;
}

/** This object represents a service message about an edited forum topic. */
export class ForumTopicEdited implements IForumTopicEdited {
    /** Optional. New name of the topic, if it was edited */
    name?: string | undefined;
    /** Optional. New identifier of the custom emoji shown as the topic icon, if it was edited; an empty string if the icon was removed */
    iconCustomEmojiId?: string | undefined;

    constructor(data?: IForumTopicEdited) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.iconCustomEmojiId = _data["iconCustomEmojiId"];
        }
    }

    static fromJS(data: any): ForumTopicEdited {
        data = typeof data === 'object' ? data : {};
        let result = new ForumTopicEdited();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["iconCustomEmojiId"] = this.iconCustomEmojiId;
        return data;
    }
}

/** This object represents a service message about an edited forum topic. */
export interface IForumTopicEdited {
    /** Optional. New name of the topic, if it was edited */
    name?: string | undefined;
    /** Optional. New identifier of the custom emoji shown as the topic icon, if it was edited; an empty string if the icon was removed */
    iconCustomEmojiId?: string | undefined;
}

/** This object represents a service message about a forum topic closed in the chat. Currently holds no information. */
export class ForumTopicClosed implements IForumTopicClosed {

    constructor(data?: IForumTopicClosed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ForumTopicClosed {
        data = typeof data === 'object' ? data : {};
        let result = new ForumTopicClosed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** This object represents a service message about a forum topic closed in the chat. Currently holds no information. */
export interface IForumTopicClosed {
}

/** This object represents a service message about a forum topic reopened in the chat. Currently holds no information. */
export class ForumTopicReopened implements IForumTopicReopened {

    constructor(data?: IForumTopicReopened) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ForumTopicReopened {
        data = typeof data === 'object' ? data : {};
        let result = new ForumTopicReopened();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** This object represents a service message about a forum topic reopened in the chat. Currently holds no information. */
export interface IForumTopicReopened {
}

/** This object represents a service message about General forum topic hidden in the chat. Currently holds no information. */
export class GeneralForumTopicHidden implements IGeneralForumTopicHidden {

    constructor(data?: IGeneralForumTopicHidden) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GeneralForumTopicHidden {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralForumTopicHidden();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** This object represents a service message about General forum topic hidden in the chat. Currently holds no information. */
export interface IGeneralForumTopicHidden {
}

/** This object represents a service message about General forum topic unhidden in the chat. Currently holds no information. */
export class GeneralForumTopicUnhidden implements IGeneralForumTopicUnhidden {

    constructor(data?: IGeneralForumTopicUnhidden) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GeneralForumTopicUnhidden {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralForumTopicUnhidden();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** This object represents a service message about General forum topic unhidden in the chat. Currently holds no information. */
export interface IGeneralForumTopicUnhidden {
}

/** This object represents a service message about the creation of a scheduled giveaway. */
export class GiveawayCreated implements IGiveawayCreated {
    /** Optional. The number of Telegram Stars to be split between giveaway winners; for Telegram Star giveaways only */
    prizeStarCount?: number | undefined;

    constructor(data?: IGiveawayCreated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prizeStarCount = _data["prizeStarCount"];
        }
    }

    static fromJS(data: any): GiveawayCreated {
        data = typeof data === 'object' ? data : {};
        let result = new GiveawayCreated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prizeStarCount"] = this.prizeStarCount;
        return data;
    }
}

/** This object represents a service message about the creation of a scheduled giveaway. */
export interface IGiveawayCreated {
    /** Optional. The number of Telegram Stars to be split between giveaway winners; for Telegram Star giveaways only */
    prizeStarCount?: number | undefined;
}

/** This object represents a service message about the completion of a giveaway without public winners. */
export class GiveawayCompleted implements IGiveawayCompleted {
    /** Number of winners in the giveaway */
    winnerCount!: number;
    /** Optional. Number of undistributed prizes */
    unclaimedPrizeCount?: number | undefined;
    /** Optional. Message with the giveaway that was completed, if it wasn't deleted */
    giveawayMessage?: Message | undefined;
    /** Optional. true, if the giveaway is a Telegram Star giveaway. Otherwise, currently, the giveaway is a Telegram Premium giveaway. */
    isStarGiveaway!: boolean;

    constructor(data?: IGiveawayCompleted) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.winnerCount = _data["winnerCount"];
            this.unclaimedPrizeCount = _data["unclaimedPrizeCount"];
            this.giveawayMessage = _data["giveawayMessage"] ? Message.fromJS(_data["giveawayMessage"]) : <any>undefined;
            this.isStarGiveaway = _data["isStarGiveaway"];
        }
    }

    static fromJS(data: any): GiveawayCompleted {
        data = typeof data === 'object' ? data : {};
        let result = new GiveawayCompleted();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["winnerCount"] = this.winnerCount;
        data["unclaimedPrizeCount"] = this.unclaimedPrizeCount;
        data["giveawayMessage"] = this.giveawayMessage ? this.giveawayMessage.toJSON() : <any>undefined;
        data["isStarGiveaway"] = this.isStarGiveaway;
        return data;
    }
}

/** This object represents a service message about the completion of a giveaway without public winners. */
export interface IGiveawayCompleted {
    /** Number of winners in the giveaway */
    winnerCount: number;
    /** Optional. Number of undistributed prizes */
    unclaimedPrizeCount?: number | undefined;
    /** Optional. Message with the giveaway that was completed, if it wasn't deleted */
    giveawayMessage?: Message | undefined;
    /** Optional. true, if the giveaway is a Telegram Star giveaway. Otherwise, currently, the giveaway is a Telegram Premium giveaway. */
    isStarGiveaway: boolean;
}

/** This object represents a service message about a video chat scheduled in the chat. */
export class VideoChatScheduled implements IVideoChatScheduled {
    /** Point in time when the video chat is supposed to be started by a chat administrator */
    startDate!: Date;

    constructor(data?: IVideoChatScheduled) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): VideoChatScheduled {
        data = typeof data === 'object' ? data : {};
        let result = new VideoChatScheduled();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        return data;
    }
}

/** This object represents a service message about a video chat scheduled in the chat. */
export interface IVideoChatScheduled {
    /** Point in time when the video chat is supposed to be started by a chat administrator */
    startDate: Date;
}

/** This object represents a service message about a video chat started in the chat. Currently holds no information. */
export class VideoChatStarted implements IVideoChatStarted {

    constructor(data?: IVideoChatStarted) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): VideoChatStarted {
        data = typeof data === 'object' ? data : {};
        let result = new VideoChatStarted();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** This object represents a service message about a video chat started in the chat. Currently holds no information. */
export interface IVideoChatStarted {
}

/** This object represents a service message about a video chat ended in the chat. */
export class VideoChatEnded implements IVideoChatEnded {
    /** Video chat duration in seconds */
    duration!: number;

    constructor(data?: IVideoChatEnded) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): VideoChatEnded {
        data = typeof data === 'object' ? data : {};
        let result = new VideoChatEnded();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        return data;
    }
}

/** This object represents a service message about a video chat ended in the chat. */
export interface IVideoChatEnded {
    /** Video chat duration in seconds */
    duration: number;
}

/** This object represents a service message about new members invited to a video chat. */
export class VideoChatParticipantsInvited implements IVideoChatParticipantsInvited {
    /** New members that were invited to the video chat */
    users!: User[];

    constructor(data?: IVideoChatParticipantsInvited) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VideoChatParticipantsInvited {
        data = typeof data === 'object' ? data : {};
        let result = new VideoChatParticipantsInvited();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }
}

/** This object represents a service message about new members invited to a video chat. */
export interface IVideoChatParticipantsInvited {
    /** New members that were invited to the video chat */
    users: User[];
}

/** Describes data sent from a Web App to the bot. */
export class WebAppData implements IWebAppData {
    /** The data. Be aware that a bad client can send arbitrary data in this field. */
    data!: string;
    /** Text of the WebApp keyboard button from which the Web App was opened. Be aware that a bad client can send arbitrary data in this field. */
    buttonText!: string;

    constructor(data?: IWebAppData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.buttonText = _data["buttonText"];
        }
    }

    static fromJS(data: any): WebAppData {
        data = typeof data === 'object' ? data : {};
        let result = new WebAppData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["buttonText"] = this.buttonText;
        return data;
    }
}

/** Describes data sent from a Web App to the bot. */
export interface IWebAppData {
    /** The data. Be aware that a bad client can send arbitrary data in this field. */
    data: string;
    /** Text of the WebApp keyboard button from which the Web App was opened. Be aware that a bad client can send arbitrary data in this field. */
    buttonText: string;
}

/** This object represents an inline keyboard that appears right next to the message it belongs to. */
export class InlineKeyboardMarkup implements IInlineKeyboardMarkup {
    /** Array of button rows, each represented by an Array of InlineKeyboardButton objects */
    inlineKeyboard!: InlineKeyboardButton[][];

    constructor(data?: IInlineKeyboardMarkup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.inlineKeyboard = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["inlineKeyboard"])) {
                this.inlineKeyboard = [] as any;
                for (let item of _data["inlineKeyboard"])
                    this.inlineKeyboard!.push(item);
            }
        }
    }

    static fromJS(data: any): InlineKeyboardMarkup {
        data = typeof data === 'object' ? data : {};
        let result = new InlineKeyboardMarkup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.inlineKeyboard)) {
            data["inlineKeyboard"] = [];
            for (let item of this.inlineKeyboard)
                data["inlineKeyboard"].push(item);
        }
        return data;
    }
}

/** This object represents an inline keyboard that appears right next to the message it belongs to. */
export interface IInlineKeyboardMarkup {
    /** Array of button rows, each represented by an Array of InlineKeyboardButton objects */
    inlineKeyboard: InlineKeyboardButton[][];
}

/** This object represents one button of an inline keyboard. Exactly one of the optional fields must be used to specify type of the button. */
export class InlineKeyboardButton implements IInlineKeyboardButton {
    /** Label text on the button */
    text!: string;
    /** Optional. HTTP or tg:// URL to be opened when the button is pressed. Links tg://user?id=<UserId> can be used to mention a user by their identifier without using a username, if this is allowed by their privacy settings. */
    url?: string | undefined;
    /** Optional. Data to be sent in a callback query to the bot when the button is pressed, 1-64 bytes */
    callbackData?: string | undefined;
    /** Optional. Description of the Web App that will be launched when the user presses the button. The Web App will be able to send an arbitrary message on behalf of the user using the method AnswerWebAppQuery. Available only in private chats between a user and the bot. Not supported for messages sent on behalf of a Telegram Business account. */
    webApp?: WebAppInfo | undefined;
    /** Optional. An HTTPS URL used to automatically authorize the user. Can be used as a replacement for the Telegram Login Widget. */
    loginUrl?: LoginUrl | undefined;
    /** Optional. If set, pressing the button will prompt the user to select one of their chats, open that chat and insert the bot's username and the specified inline query in the input field. May be empty, in which case just the bot's username will be inserted. Not supported for messages sent on behalf of a Telegram Business account. */
    switchInlineQuery?: string | undefined;
    /** Optional. If set, pressing the button will insert the bot's username and the specified inline query in the current chat's input field. May be empty, in which case only the bot's username will be inserted.This offers a quick way for the user to open your bot in inline mode in the same chat - good for selecting something from multiple options. Not supported in channels and for messages sent on behalf of a Telegram Business account. */
    switchInlineQueryCurrentChat?: string | undefined;
    /** Optional. If set, pressing the button will prompt the user to select one of their chats of the specified type, open that chat and insert the bot's username and the specified inline query in the input field. Not supported for messages sent on behalf of a Telegram Business account. */
    switchInlineQueryChosenChat?: SwitchInlineQueryChosenChat | undefined;
    /** Optional. Description of the button that copies the specified text to the clipboard. */
    copyText?: CopyTextButton | undefined;
    /** Optional. Description of the game that will be launched when the user presses the button.NOTE: This type of button must always be the first button in the first row. */
    callbackGame?: CallbackGame | undefined;
    /** Optional. Specify true, to send a Pay button. Substrings “⭐” and “XTR” in the buttons's text will be replaced with a Telegram Star icon.NOTE: This type of button must always be the first button in the first row and can only be used in invoice messages. */
    pay!: boolean;

    constructor(data?: IInlineKeyboardButton) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.url = _data["url"];
            this.callbackData = _data["callbackData"];
            this.webApp = _data["webApp"] ? WebAppInfo.fromJS(_data["webApp"]) : <any>undefined;
            this.loginUrl = _data["loginUrl"] ? LoginUrl.fromJS(_data["loginUrl"]) : <any>undefined;
            this.switchInlineQuery = _data["switchInlineQuery"];
            this.switchInlineQueryCurrentChat = _data["switchInlineQueryCurrentChat"];
            this.switchInlineQueryChosenChat = _data["switchInlineQueryChosenChat"] ? SwitchInlineQueryChosenChat.fromJS(_data["switchInlineQueryChosenChat"]) : <any>undefined;
            this.copyText = _data["copyText"] ? CopyTextButton.fromJS(_data["copyText"]) : <any>undefined;
            this.callbackGame = _data["callbackGame"] ? CallbackGame.fromJS(_data["callbackGame"]) : <any>undefined;
            this.pay = _data["pay"];
        }
    }

    static fromJS(data: any): InlineKeyboardButton {
        data = typeof data === 'object' ? data : {};
        let result = new InlineKeyboardButton();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["url"] = this.url;
        data["callbackData"] = this.callbackData;
        data["webApp"] = this.webApp ? this.webApp.toJSON() : <any>undefined;
        data["loginUrl"] = this.loginUrl ? this.loginUrl.toJSON() : <any>undefined;
        data["switchInlineQuery"] = this.switchInlineQuery;
        data["switchInlineQueryCurrentChat"] = this.switchInlineQueryCurrentChat;
        data["switchInlineQueryChosenChat"] = this.switchInlineQueryChosenChat ? this.switchInlineQueryChosenChat.toJSON() : <any>undefined;
        data["copyText"] = this.copyText ? this.copyText.toJSON() : <any>undefined;
        data["callbackGame"] = this.callbackGame ? this.callbackGame.toJSON() : <any>undefined;
        data["pay"] = this.pay;
        return data;
    }
}

/** This object represents one button of an inline keyboard. Exactly one of the optional fields must be used to specify type of the button. */
export interface IInlineKeyboardButton {
    /** Label text on the button */
    text: string;
    /** Optional. HTTP or tg:// URL to be opened when the button is pressed. Links tg://user?id=<UserId> can be used to mention a user by their identifier without using a username, if this is allowed by their privacy settings. */
    url?: string | undefined;
    /** Optional. Data to be sent in a callback query to the bot when the button is pressed, 1-64 bytes */
    callbackData?: string | undefined;
    /** Optional. Description of the Web App that will be launched when the user presses the button. The Web App will be able to send an arbitrary message on behalf of the user using the method AnswerWebAppQuery. Available only in private chats between a user and the bot. Not supported for messages sent on behalf of a Telegram Business account. */
    webApp?: WebAppInfo | undefined;
    /** Optional. An HTTPS URL used to automatically authorize the user. Can be used as a replacement for the Telegram Login Widget. */
    loginUrl?: LoginUrl | undefined;
    /** Optional. If set, pressing the button will prompt the user to select one of their chats, open that chat and insert the bot's username and the specified inline query in the input field. May be empty, in which case just the bot's username will be inserted. Not supported for messages sent on behalf of a Telegram Business account. */
    switchInlineQuery?: string | undefined;
    /** Optional. If set, pressing the button will insert the bot's username and the specified inline query in the current chat's input field. May be empty, in which case only the bot's username will be inserted.This offers a quick way for the user to open your bot in inline mode in the same chat - good for selecting something from multiple options. Not supported in channels and for messages sent on behalf of a Telegram Business account. */
    switchInlineQueryCurrentChat?: string | undefined;
    /** Optional. If set, pressing the button will prompt the user to select one of their chats of the specified type, open that chat and insert the bot's username and the specified inline query in the input field. Not supported for messages sent on behalf of a Telegram Business account. */
    switchInlineQueryChosenChat?: SwitchInlineQueryChosenChat | undefined;
    /** Optional. Description of the button that copies the specified text to the clipboard. */
    copyText?: CopyTextButton | undefined;
    /** Optional. Description of the game that will be launched when the user presses the button.NOTE: This type of button must always be the first button in the first row. */
    callbackGame?: CallbackGame | undefined;
    /** Optional. Specify true, to send a Pay button. Substrings “⭐” and “XTR” in the buttons's text will be replaced with a Telegram Star icon.NOTE: This type of button must always be the first button in the first row and can only be used in invoice messages. */
    pay: boolean;
}

/** Describes a Web App. */
export class WebAppInfo implements IWebAppInfo {
    /** An HTTPS URL of a Web App to be opened with additional data as specified in Initializing Web Apps */
    url!: string;

    constructor(data?: IWebAppInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): WebAppInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WebAppInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }
}

/** Describes a Web App. */
export interface IWebAppInfo {
    /** An HTTPS URL of a Web App to be opened with additional data as specified in Initializing Web Apps */
    url: string;
}

/** This object represents a parameter of the inline keyboard button used to automatically authorize a user. Serves as a great replacement for the Telegram Login Widget when the user is coming from Telegram. All the user needs to do is tap/click a button and confirm that they want to log in:Telegram apps support these buttons as of version 5.7. */
export class LoginUrl implements ILoginUrl {
    /** An HTTPS URL to be opened with user authorization data added to the query string when the button is pressed. If the user refuses to provide authorization data, the original URL without information about the user will be opened. The data added is the same as described in Receiving authorization data.NOTE: You must always check the hash of the received data to verify the authentication and the integrity of the data as described in Checking authorization. */
    url!: string;
    /** Optional. New text of the button in forwarded messages. */
    forwardText?: string | undefined;
    /** Optional. Username of a bot, which will be used for user authorization. See Setting up a bot for more details. If not specified, the current bot's username will be assumed. The Url's domain must be the same as the domain linked with the bot. See Linking your domain to the bot for more details. */
    botUsername?: string | undefined;
    /** Optional. Pass true to request the permission for your bot to send messages to the user. */
    requestWriteAccess!: boolean;

    constructor(data?: ILoginUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.forwardText = _data["forwardText"];
            this.botUsername = _data["botUsername"];
            this.requestWriteAccess = _data["requestWriteAccess"];
        }
    }

    static fromJS(data: any): LoginUrl {
        data = typeof data === 'object' ? data : {};
        let result = new LoginUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["forwardText"] = this.forwardText;
        data["botUsername"] = this.botUsername;
        data["requestWriteAccess"] = this.requestWriteAccess;
        return data;
    }
}

/** This object represents a parameter of the inline keyboard button used to automatically authorize a user. Serves as a great replacement for the Telegram Login Widget when the user is coming from Telegram. All the user needs to do is tap/click a button and confirm that they want to log in:Telegram apps support these buttons as of version 5.7. */
export interface ILoginUrl {
    /** An HTTPS URL to be opened with user authorization data added to the query string when the button is pressed. If the user refuses to provide authorization data, the original URL without information about the user will be opened. The data added is the same as described in Receiving authorization data.NOTE: You must always check the hash of the received data to verify the authentication and the integrity of the data as described in Checking authorization. */
    url: string;
    /** Optional. New text of the button in forwarded messages. */
    forwardText?: string | undefined;
    /** Optional. Username of a bot, which will be used for user authorization. See Setting up a bot for more details. If not specified, the current bot's username will be assumed. The Url's domain must be the same as the domain linked with the bot. See Linking your domain to the bot for more details. */
    botUsername?: string | undefined;
    /** Optional. Pass true to request the permission for your bot to send messages to the user. */
    requestWriteAccess: boolean;
}

/** This object represents an inline button that switches the current user to inline mode in a chosen chat, with an optional default inline query. */
export class SwitchInlineQueryChosenChat implements ISwitchInlineQueryChosenChat {
    /** Optional. The default inline query to be inserted in the input field. If left empty, only the bot's username will be inserted */
    query?: string | undefined;
    /** Optional. true, if private chats with users can be chosen */
    allowUserChats!: boolean;
    /** Optional. true, if private chats with bots can be chosen */
    allowBotChats!: boolean;
    /** Optional. true, if group and supergroup chats can be chosen */
    allowGroupChats!: boolean;
    /** Optional. true, if channel chats can be chosen */
    allowChannelChats!: boolean;

    constructor(data?: ISwitchInlineQueryChosenChat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"];
            this.allowUserChats = _data["allowUserChats"];
            this.allowBotChats = _data["allowBotChats"];
            this.allowGroupChats = _data["allowGroupChats"];
            this.allowChannelChats = _data["allowChannelChats"];
        }
    }

    static fromJS(data: any): SwitchInlineQueryChosenChat {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchInlineQueryChosenChat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query;
        data["allowUserChats"] = this.allowUserChats;
        data["allowBotChats"] = this.allowBotChats;
        data["allowGroupChats"] = this.allowGroupChats;
        data["allowChannelChats"] = this.allowChannelChats;
        return data;
    }
}

/** This object represents an inline button that switches the current user to inline mode in a chosen chat, with an optional default inline query. */
export interface ISwitchInlineQueryChosenChat {
    /** Optional. The default inline query to be inserted in the input field. If left empty, only the bot's username will be inserted */
    query?: string | undefined;
    /** Optional. true, if private chats with users can be chosen */
    allowUserChats: boolean;
    /** Optional. true, if private chats with bots can be chosen */
    allowBotChats: boolean;
    /** Optional. true, if group and supergroup chats can be chosen */
    allowGroupChats: boolean;
    /** Optional. true, if channel chats can be chosen */
    allowChannelChats: boolean;
}

/** This object represents an inline keyboard button that copies specified text to the clipboard. */
export class CopyTextButton implements ICopyTextButton {
    /** The text to be copied to the clipboard; 1-256 characters */
    text!: string;

    constructor(data?: ICopyTextButton) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): CopyTextButton {
        data = typeof data === 'object' ? data : {};
        let result = new CopyTextButton();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }
}

/** This object represents an inline keyboard button that copies specified text to the clipboard. */
export interface ICopyTextButton {
    /** The text to be copied to the clipboard; 1-256 characters */
    text: string;
}

/** A placeholder, currently holds no information. Use @BotFather to set up your game. */
export class CallbackGame implements ICallbackGame {

    constructor(data?: ICallbackGame) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CallbackGame {
        data = typeof data === 'object' ? data : {};
        let result = new CallbackGame();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** A placeholder, currently holds no information. Use @BotFather to set up your game. */
export interface ICallbackGame {
}

/** The type of Message */
export enum MessageType {
    Unknown = 0,
    Text = 1,
    Photo = 2,
    Audio = 3,
    Video = 4,
    Voice = 5,
    Document = 6,
    Sticker = 7,
    Location = 8,
    Contact = 9,
    Venue = 10,
    Game = 11,
    VideoNote = 12,
    Invoice = 13,
    SuccessfulPayment = 14,
    ConnectedWebsite = 15,
    NewChatMembers = 16,
    LeftChatMember = 17,
    NewChatTitle = 18,
    NewChatPhoto = 19,
    PinnedMessage = 20,
    DeleteChatPhoto = 21,
    GroupChatCreated = 22,
    SupergroupChatCreated = 23,
    ChannelChatCreated = 24,
    MigrateFromChatId = 25,
    MigrateToChatId = 26,
    Poll = 27,
    Dice = 28,
    MessageAutoDeleteTimerChanged = 29,
    ProximityAlertTriggered = 30,
    WebAppData = 31,
    VideoChatScheduled = 32,
    VideoChatStarted = 33,
    VideoChatEnded = 34,
    VideoChatParticipantsInvited = 35,
    Animation = 36,
    ForumTopicCreated = 37,
    ForumTopicClosed = 38,
    ForumTopicReopened = 39,
    ForumTopicEdited = 40,
    GeneralForumTopicHidden = 41,
    GeneralForumTopicUnhidden = 42,
    WriteAccessAllowed = 43,
    UsersShared = 44,
    ChatShared = 45,
    Story = 46,
    PassportData = 47,
    GiveawayCreated = 48,
    Giveaway = 49,
    GiveawayWinners = 50,
    GiveawayCompleted = 51,
    BoostAdded = 52,
    ChatBackgroundSet = 53,
    PaidMedia = 54,
    RefundedPayment = 55,
}

/** Describes the connection of the bot with a business account. */
export class BusinessConnection implements IBusinessConnection {
    /** Unique identifier of the business connection */
    id!: string;
    /** Business account user that created the business connection */
    user!: User;
    /** Identifier of a private chat with the user who created the business connection. */
    userChatId!: number;
    /** Date the connection was established */
    date!: Date;
    /** true, if the bot can act on behalf of the business account in chats that were active in the last 24 hours */
    canReply!: boolean;
    /** true, if the connection is active */
    isEnabled!: boolean;

    constructor(data?: IBusinessConnection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : new User();
            this.userChatId = _data["userChatId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.canReply = _data["canReply"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): BusinessConnection {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessConnection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["userChatId"] = this.userChatId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["canReply"] = this.canReply;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

/** Describes the connection of the bot with a business account. */
export interface IBusinessConnection {
    /** Unique identifier of the business connection */
    id: string;
    /** Business account user that created the business connection */
    user: User;
    /** Identifier of a private chat with the user who created the business connection. */
    userChatId: number;
    /** Date the connection was established */
    date: Date;
    /** true, if the bot can act on behalf of the business account in chats that were active in the last 24 hours */
    canReply: boolean;
    /** true, if the connection is active */
    isEnabled: boolean;
}

/** This object is received when messages are deleted from a connected business account. */
export class BusinessMessagesDeleted implements IBusinessMessagesDeleted {
    /** Unique identifier of the business connection */
    businessConnectionId!: string;
    /** Information about a chat in the business account. The bot may not have access to the chat or the corresponding user. */
    chat!: Chat;
    /** The list of identifiers of deleted messages in the chat of the business account */
    messageIds!: number[];

    constructor(data?: IBusinessMessagesDeleted) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chat = new Chat();
            this.messageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.businessConnectionId = _data["businessConnectionId"];
            this.chat = _data["chat"] ? Chat.fromJS(_data["chat"]) : new Chat();
            if (Array.isArray(_data["messageIds"])) {
                this.messageIds = [] as any;
                for (let item of _data["messageIds"])
                    this.messageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BusinessMessagesDeleted {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessMessagesDeleted();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessConnectionId"] = this.businessConnectionId;
        data["chat"] = this.chat ? this.chat.toJSON() : <any>undefined;
        if (Array.isArray(this.messageIds)) {
            data["messageIds"] = [];
            for (let item of this.messageIds)
                data["messageIds"].push(item);
        }
        return data;
    }
}

/** This object is received when messages are deleted from a connected business account. */
export interface IBusinessMessagesDeleted {
    /** Unique identifier of the business connection */
    businessConnectionId: string;
    /** Information about a chat in the business account. The bot may not have access to the chat or the corresponding user. */
    chat: Chat;
    /** The list of identifiers of deleted messages in the chat of the business account */
    messageIds: number[];
}

/** This object represents a change of a reaction on a message performed by a user. */
export class MessageReactionUpdated implements IMessageReactionUpdated {
    /** The chat containing the message the user reacted to */
    chat!: Chat;
    /** Unique identifier of the message inside the chat */
    messageId!: number;
    /** Optional. The user that changed the reaction, if the user isn't anonymous */
    user?: User | undefined;
    /** Optional. The chat on behalf of which the reaction was changed, if the user is anonymous */
    actorChat?: Chat | undefined;
    /** Date of the change */
    date!: Date;
    /** Previous list of reaction types that were set by the user */
    oldReaction!: ReactionType[];
    /** New list of reaction types that have been set by the user */
    newReaction!: ReactionType[];

    constructor(data?: IMessageReactionUpdated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chat = new Chat();
            this.oldReaction = [];
            this.newReaction = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chat = _data["chat"] ? Chat.fromJS(_data["chat"]) : new Chat();
            this.messageId = _data["messageId"];
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            this.actorChat = _data["actorChat"] ? Chat.fromJS(_data["actorChat"]) : <any>undefined;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["oldReaction"])) {
                this.oldReaction = [] as any;
                for (let item of _data["oldReaction"])
                    this.oldReaction!.push(ReactionType.fromJS(item));
            }
            if (Array.isArray(_data["newReaction"])) {
                this.newReaction = [] as any;
                for (let item of _data["newReaction"])
                    this.newReaction!.push(ReactionType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageReactionUpdated {
        data = typeof data === 'object' ? data : {};
        let result = new MessageReactionUpdated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chat"] = this.chat ? this.chat.toJSON() : <any>undefined;
        data["messageId"] = this.messageId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["actorChat"] = this.actorChat ? this.actorChat.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.oldReaction)) {
            data["oldReaction"] = [];
            for (let item of this.oldReaction)
                data["oldReaction"].push(item.toJSON());
        }
        if (Array.isArray(this.newReaction)) {
            data["newReaction"] = [];
            for (let item of this.newReaction)
                data["newReaction"].push(item.toJSON());
        }
        return data;
    }
}

/** This object represents a change of a reaction on a message performed by a user. */
export interface IMessageReactionUpdated {
    /** The chat containing the message the user reacted to */
    chat: Chat;
    /** Unique identifier of the message inside the chat */
    messageId: number;
    /** Optional. The user that changed the reaction, if the user isn't anonymous */
    user?: User | undefined;
    /** Optional. The chat on behalf of which the reaction was changed, if the user is anonymous */
    actorChat?: Chat | undefined;
    /** Date of the change */
    date: Date;
    /** Previous list of reaction types that were set by the user */
    oldReaction: ReactionType[];
    /** New list of reaction types that have been set by the user */
    newReaction: ReactionType[];
}

/** This object describes the type of a reaction. Currently, it can be one ofReactionTypeEmoji, ReactionTypeCustomEmoji, ReactionTypePaid */
export abstract class ReactionType implements IReactionType {

    constructor(data?: IReactionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ReactionType {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ReactionType' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** This object describes the type of a reaction. Currently, it can be one ofReactionTypeEmoji, ReactionTypeCustomEmoji, ReactionTypePaid */
export interface IReactionType {
}

/** This object represents reaction changes on a message with anonymous reactions. */
export class MessageReactionCountUpdated implements IMessageReactionCountUpdated {
    /** The chat containing the message */
    chat!: Chat;
    /** Unique message identifier inside the chat */
    messageId!: number;
    /** Date of the change */
    date!: Date;
    /** List of reactions that are present on the message */
    reactions!: ReactionCount[];

    constructor(data?: IMessageReactionCountUpdated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chat = new Chat();
            this.reactions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chat = _data["chat"] ? Chat.fromJS(_data["chat"]) : new Chat();
            this.messageId = _data["messageId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["reactions"])) {
                this.reactions = [] as any;
                for (let item of _data["reactions"])
                    this.reactions!.push(ReactionCount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageReactionCountUpdated {
        data = typeof data === 'object' ? data : {};
        let result = new MessageReactionCountUpdated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chat"] = this.chat ? this.chat.toJSON() : <any>undefined;
        data["messageId"] = this.messageId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.reactions)) {
            data["reactions"] = [];
            for (let item of this.reactions)
                data["reactions"].push(item.toJSON());
        }
        return data;
    }
}

/** This object represents reaction changes on a message with anonymous reactions. */
export interface IMessageReactionCountUpdated {
    /** The chat containing the message */
    chat: Chat;
    /** Unique message identifier inside the chat */
    messageId: number;
    /** Date of the change */
    date: Date;
    /** List of reactions that are present on the message */
    reactions: ReactionCount[];
}

/** Represents a reaction added to a message along with the number of times it was added. */
export class ReactionCount implements IReactionCount {
    /** Type of the reaction */
    type!: ReactionType;
    /** Number of times the reaction was added */
    totalCount!: number;

    constructor(data?: IReactionCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] ? ReactionType.fromJS(_data["type"]) : <any>undefined;
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReactionCount {
        data = typeof data === 'object' ? data : {};
        let result = new ReactionCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

/** Represents a reaction added to a message along with the number of times it was added. */
export interface IReactionCount {
    /** Type of the reaction */
    type: ReactionType;
    /** Number of times the reaction was added */
    totalCount: number;
}

/** This object represents an incoming inline query. When the user sends an empty query, your bot could return some default or trending results. */
export class InlineQuery implements IInlineQuery {
    /** Unique identifier for this query */
    id!: string;
    /** Sender */
    from!: User;
    /** Text of the query (up to 256 characters) */
    query!: string;
    /** Offset of the results to be returned, can be controlled by the bot */
    offset!: string;
    /** Optional. Type of the chat from which the inline query was sent. Can be either Sender for a private chat with the inline query sender, Private, Group, Supergroup, or Channel. The chat type should be always known for requests sent from official clients and most third-party clients, unless the request was sent from a secret chat */
    chatType?: ChatType | undefined;
    /** Optional. Sender location, only for bots that request user location */
    location?: Location | undefined;

    constructor(data?: IInlineQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.from = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"] ? User.fromJS(_data["from"]) : new User();
            this.query = _data["query"];
            this.offset = _data["offset"];
            this.chatType = _data["chatType"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InlineQuery {
        data = typeof data === 'object' ? data : {};
        let result = new InlineQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["query"] = this.query;
        data["offset"] = this.offset;
        data["chatType"] = this.chatType;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data;
    }
}

/** This object represents an incoming inline query. When the user sends an empty query, your bot could return some default or trending results. */
export interface IInlineQuery {
    /** Unique identifier for this query */
    id: string;
    /** Sender */
    from: User;
    /** Text of the query (up to 256 characters) */
    query: string;
    /** Offset of the results to be returned, can be controlled by the bot */
    offset: string;
    /** Optional. Type of the chat from which the inline query was sent. Can be either Sender for a private chat with the inline query sender, Private, Group, Supergroup, or Channel. The chat type should be always known for requests sent from official clients and most third-party clients, unless the request was sent from a secret chat */
    chatType?: ChatType | undefined;
    /** Optional. Sender location, only for bots that request user location */
    location?: Location | undefined;
}

/** Represents a result of an inline query that was chosen by the user and sent to their chat partner.Note: It is necessary to enable inline feedback via @BotFather in order to receive these objects in updates. */
export class ChosenInlineResult implements IChosenInlineResult {
    /** The unique identifier for the result that was chosen */
    resultId!: string;
    /** The user that chose the result */
    from!: User;
    /** Optional. Sender location, only for bots that require user location */
    location?: Location | undefined;
    /** Optional. Identifier of the sent inline message. Available only if there is an inline keyboard attached to the message. Will be also received in callback queries and can be used to edit the message. */
    inlineMessageId?: string | undefined;
    /** The query that was used to obtain the result */
    query!: string;

    constructor(data?: IChosenInlineResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.from = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultId = _data["resultId"];
            this.from = _data["from"] ? User.fromJS(_data["from"]) : new User();
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.inlineMessageId = _data["inlineMessageId"];
            this.query = _data["query"];
        }
    }

    static fromJS(data: any): ChosenInlineResult {
        data = typeof data === 'object' ? data : {};
        let result = new ChosenInlineResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultId"] = this.resultId;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["inlineMessageId"] = this.inlineMessageId;
        data["query"] = this.query;
        return data;
    }
}

/** Represents a result of an inline query that was chosen by the user and sent to their chat partner.Note: It is necessary to enable inline feedback via @BotFather in order to receive these objects in updates. */
export interface IChosenInlineResult {
    /** The unique identifier for the result that was chosen */
    resultId: string;
    /** The user that chose the result */
    from: User;
    /** Optional. Sender location, only for bots that require user location */
    location?: Location | undefined;
    /** Optional. Identifier of the sent inline message. Available only if there is an inline keyboard attached to the message. Will be also received in callback queries and can be used to edit the message. */
    inlineMessageId?: string | undefined;
    /** The query that was used to obtain the result */
    query: string;
}

/** This object represents an incoming callback query from a callback button in an inline keyboard. If the button that originated the query was attached to a message sent by the bot, the field Message will be present. If the button was attached to a message sent via the bot (in inline mode), the field InlineMessageId will be present. Exactly one of the fields Data or GameShortName will be present. */
export class CallbackQuery implements ICallbackQuery {
    /** Unique identifier for this query */
    id!: string;
    /** Sender */
    from!: User;
    /** Optional. Message sent by the bot with the callback button that originated the query */
    message?: Message | undefined;
    /** Optional. Identifier of the message sent via the bot in inline mode, that originated the query. */
    inlineMessageId?: string | undefined;
    /** Global identifier, uniquely corresponding to the chat to which the message with the callback button was sent. Useful for high scores in games. */
    chatInstance!: string;
    /** Optional. Data associated with the callback button. Be aware that the message originated the query can contain no callback buttons with this data. */
    data?: string | undefined;
    /** Optional. Short name of a Game to be returned, serves as the unique identifier for the game */
    gameShortName?: string | undefined;

    constructor(data?: ICallbackQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.from = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"] ? User.fromJS(_data["from"]) : new User();
            this.message = _data["message"] ? Message.fromJS(_data["message"]) : <any>undefined;
            this.inlineMessageId = _data["inlineMessageId"];
            this.chatInstance = _data["chatInstance"];
            this.data = _data["data"];
            this.gameShortName = _data["gameShortName"];
        }
    }

    static fromJS(data: any): CallbackQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CallbackQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["message"] = this.message ? this.message.toJSON() : <any>undefined;
        data["inlineMessageId"] = this.inlineMessageId;
        data["chatInstance"] = this.chatInstance;
        data["data"] = this.data;
        data["gameShortName"] = this.gameShortName;
        return data;
    }
}

/** This object represents an incoming callback query from a callback button in an inline keyboard. If the button that originated the query was attached to a message sent by the bot, the field Message will be present. If the button was attached to a message sent via the bot (in inline mode), the field InlineMessageId will be present. Exactly one of the fields Data or GameShortName will be present. */
export interface ICallbackQuery {
    /** Unique identifier for this query */
    id: string;
    /** Sender */
    from: User;
    /** Optional. Message sent by the bot with the callback button that originated the query */
    message?: Message | undefined;
    /** Optional. Identifier of the message sent via the bot in inline mode, that originated the query. */
    inlineMessageId?: string | undefined;
    /** Global identifier, uniquely corresponding to the chat to which the message with the callback button was sent. Useful for high scores in games. */
    chatInstance: string;
    /** Optional. Data associated with the callback button. Be aware that the message originated the query can contain no callback buttons with this data. */
    data?: string | undefined;
    /** Optional. Short name of a Game to be returned, serves as the unique identifier for the game */
    gameShortName?: string | undefined;
}

/** This object contains information about an incoming shipping query. */
export class ShippingQuery implements IShippingQuery {
    /** Unique query identifier */
    id!: string;
    /** User who sent the query */
    from!: User;
    /** Bot-specified invoice payload */
    invoicePayload!: string;
    /** User specified shipping address */
    shippingAddress!: ShippingAddress;

    constructor(data?: IShippingQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.from = new User();
            this.shippingAddress = new ShippingAddress();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"] ? User.fromJS(_data["from"]) : new User();
            this.invoicePayload = _data["invoicePayload"];
            this.shippingAddress = _data["shippingAddress"] ? ShippingAddress.fromJS(_data["shippingAddress"]) : new ShippingAddress();
        }
    }

    static fromJS(data: any): ShippingQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ShippingQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["invoicePayload"] = this.invoicePayload;
        data["shippingAddress"] = this.shippingAddress ? this.shippingAddress.toJSON() : <any>undefined;
        return data;
    }
}

/** This object contains information about an incoming shipping query. */
export interface IShippingQuery {
    /** Unique query identifier */
    id: string;
    /** User who sent the query */
    from: User;
    /** Bot-specified invoice payload */
    invoicePayload: string;
    /** User specified shipping address */
    shippingAddress: ShippingAddress;
}

/** This object contains information about an incoming pre-checkout query. */
export class PreCheckoutQuery implements IPreCheckoutQuery {
    /** Unique query identifier */
    id!: string;
    /** User who sent the query */
    from!: User;
    /** Three-letter ISO 4217 currency code, or “XTR” for payments in Telegram Stars */
    currency!: string;
    /** Total price in the smallest units of the currency (integer, not float/double). For example, for a price of US$ 1.45 pass amount = 145. See the exp parameter in currencies.json, it shows the number of digits past the decimal point for each currency (2 for the majority of currencies). */
    totalAmount!: number;
    /** Bot-specified invoice payload */
    invoicePayload!: string;
    /** Optional. Identifier of the shipping option chosen by the user */
    shippingOptionId?: string | undefined;
    /** Optional. Order information provided by the user */
    orderInfo?: OrderInfo | undefined;

    constructor(data?: IPreCheckoutQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.from = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.from = _data["from"] ? User.fromJS(_data["from"]) : new User();
            this.currency = _data["currency"];
            this.totalAmount = _data["totalAmount"];
            this.invoicePayload = _data["invoicePayload"];
            this.shippingOptionId = _data["shippingOptionId"];
            this.orderInfo = _data["orderInfo"] ? OrderInfo.fromJS(_data["orderInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PreCheckoutQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PreCheckoutQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["currency"] = this.currency;
        data["totalAmount"] = this.totalAmount;
        data["invoicePayload"] = this.invoicePayload;
        data["shippingOptionId"] = this.shippingOptionId;
        data["orderInfo"] = this.orderInfo ? this.orderInfo.toJSON() : <any>undefined;
        return data;
    }
}

/** This object contains information about an incoming pre-checkout query. */
export interface IPreCheckoutQuery {
    /** Unique query identifier */
    id: string;
    /** User who sent the query */
    from: User;
    /** Three-letter ISO 4217 currency code, or “XTR” for payments in Telegram Stars */
    currency: string;
    /** Total price in the smallest units of the currency (integer, not float/double). For example, for a price of US$ 1.45 pass amount = 145. See the exp parameter in currencies.json, it shows the number of digits past the decimal point for each currency (2 for the majority of currencies). */
    totalAmount: number;
    /** Bot-specified invoice payload */
    invoicePayload: string;
    /** Optional. Identifier of the shipping option chosen by the user */
    shippingOptionId?: string | undefined;
    /** Optional. Order information provided by the user */
    orderInfo?: OrderInfo | undefined;
}

/** This object contains information about a paid media purchase. */
export class PaidMediaPurchased implements IPaidMediaPurchased {
    /** User who purchased the media */
    from!: User;
    /** Bot-specified paid media payload */
    paidMediaPayload!: string;

    constructor(data?: IPaidMediaPurchased) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.from = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? User.fromJS(_data["from"]) : new User();
            this.paidMediaPayload = _data["paidMediaPayload"];
        }
    }

    static fromJS(data: any): PaidMediaPurchased {
        data = typeof data === 'object' ? data : {};
        let result = new PaidMediaPurchased();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["paidMediaPayload"] = this.paidMediaPayload;
        return data;
    }
}

/** This object contains information about a paid media purchase. */
export interface IPaidMediaPurchased {
    /** User who purchased the media */
    from: User;
    /** Bot-specified paid media payload */
    paidMediaPayload: string;
}

/** This object represents an answer of a user in a non-anonymous poll. */
export class PollAnswer implements IPollAnswer {
    /** Unique poll identifier */
    pollId!: string;
    /** Optional. The chat that changed the answer to the poll, if the voter is anonymous */
    voterChat?: Chat | undefined;
    /** Optional. The user that changed the answer to the poll, if the voter isn't anonymous */
    user?: User | undefined;
    /** 0-based identifiers of chosen answer options. May be empty if the vote was retracted. */
    optionIds!: number[];

    constructor(data?: IPollAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.optionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pollId = _data["pollId"];
            this.voterChat = _data["voterChat"] ? Chat.fromJS(_data["voterChat"]) : <any>undefined;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["optionIds"])) {
                this.optionIds = [] as any;
                for (let item of _data["optionIds"])
                    this.optionIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PollAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new PollAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pollId"] = this.pollId;
        data["voterChat"] = this.voterChat ? this.voterChat.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.optionIds)) {
            data["optionIds"] = [];
            for (let item of this.optionIds)
                data["optionIds"].push(item);
        }
        return data;
    }
}

/** This object represents an answer of a user in a non-anonymous poll. */
export interface IPollAnswer {
    /** Unique poll identifier */
    pollId: string;
    /** Optional. The chat that changed the answer to the poll, if the voter is anonymous */
    voterChat?: Chat | undefined;
    /** Optional. The user that changed the answer to the poll, if the voter isn't anonymous */
    user?: User | undefined;
    /** 0-based identifiers of chosen answer options. May be empty if the vote was retracted. */
    optionIds: number[];
}

/** This object represents changes in the status of a chat member. */
export class ChatMemberUpdated implements IChatMemberUpdated {
    /** Chat the user belongs to */
    chat!: Chat;
    /** Performer of the action, which resulted in the change */
    from!: User;
    /** Date the change was done */
    date!: Date;
    /** Previous information about the chat member */
    oldChatMember!: ChatMember;
    /** New information about the chat member */
    newChatMember!: ChatMember;
    /** Optional. Chat invite link, which was used by the user to join the chat; for joining by invite link events only. */
    inviteLink?: ChatInviteLink | undefined;
    /** Optional. true, if the user joined the chat after sending a direct join request without using an invite link and being approved by an administrator */
    viaJoinRequest!: boolean;
    /** Optional. true, if the user joined the chat via a chat folder invite link */
    viaChatFolderInviteLink!: boolean;

    constructor(data?: IChatMemberUpdated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chat = new Chat();
            this.from = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chat = _data["chat"] ? Chat.fromJS(_data["chat"]) : new Chat();
            this.from = _data["from"] ? User.fromJS(_data["from"]) : new User();
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.oldChatMember = _data["oldChatMember"] ? ChatMember.fromJS(_data["oldChatMember"]) : <any>undefined;
            this.newChatMember = _data["newChatMember"] ? ChatMember.fromJS(_data["newChatMember"]) : <any>undefined;
            this.inviteLink = _data["inviteLink"] ? ChatInviteLink.fromJS(_data["inviteLink"]) : <any>undefined;
            this.viaJoinRequest = _data["viaJoinRequest"];
            this.viaChatFolderInviteLink = _data["viaChatFolderInviteLink"];
        }
    }

    static fromJS(data: any): ChatMemberUpdated {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMemberUpdated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chat"] = this.chat ? this.chat.toJSON() : <any>undefined;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["oldChatMember"] = this.oldChatMember ? this.oldChatMember.toJSON() : <any>undefined;
        data["newChatMember"] = this.newChatMember ? this.newChatMember.toJSON() : <any>undefined;
        data["inviteLink"] = this.inviteLink ? this.inviteLink.toJSON() : <any>undefined;
        data["viaJoinRequest"] = this.viaJoinRequest;
        data["viaChatFolderInviteLink"] = this.viaChatFolderInviteLink;
        return data;
    }
}

/** This object represents changes in the status of a chat member. */
export interface IChatMemberUpdated {
    /** Chat the user belongs to */
    chat: Chat;
    /** Performer of the action, which resulted in the change */
    from: User;
    /** Date the change was done */
    date: Date;
    /** Previous information about the chat member */
    oldChatMember: ChatMember;
    /** New information about the chat member */
    newChatMember: ChatMember;
    /** Optional. Chat invite link, which was used by the user to join the chat; for joining by invite link events only. */
    inviteLink?: ChatInviteLink | undefined;
    /** Optional. true, if the user joined the chat after sending a direct join request without using an invite link and being approved by an administrator */
    viaJoinRequest: boolean;
    /** Optional. true, if the user joined the chat via a chat folder invite link */
    viaChatFolderInviteLink: boolean;
}

/** This object contains information about one member of a chat. Currently, the following 6 types of chat members are supported:ChatMemberOwner, ChatMemberAdministrator, ChatMemberMember, ChatMemberRestricted, ChatMemberLeft, ChatMemberBanned */
export abstract class ChatMember implements IChatMember {
    /** Information about the user */
    user!: User;

    constructor(data?: IChatMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? User.fromJS(_data["user"]) : new User();
        }
    }

    static fromJS(data: any): ChatMember {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ChatMember' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

/** This object contains information about one member of a chat. Currently, the following 6 types of chat members are supported:ChatMemberOwner, ChatMemberAdministrator, ChatMemberMember, ChatMemberRestricted, ChatMemberLeft, ChatMemberBanned */
export interface IChatMember {
    /** Information about the user */
    user: User;
}

/** Represents an invite link for a chat. */
export class ChatInviteLink implements IChatInviteLink {
    /** The invite link. If the link was created by another chat administrator, then the second part of the link will be replaced with “…”. */
    inviteLink!: string;
    /** Creator of the link */
    creator!: User;
    /** true, if users joining the chat via the link need to be approved by chat administrators */
    createsJoinRequest!: boolean;
    /** true, if the link is primary */
    isPrimary!: boolean;
    /** true, if the link is revoked */
    isRevoked!: boolean;
    /** Optional. Invite link name */
    name?: string | undefined;
    /** Optional. Point in time when the link will expire or has been expired */
    expireDate?: Date | undefined;
    /** Optional. The maximum number of users that can be members of the chat simultaneously after joining the chat via this invite link; 1-99999 */
    memberLimit?: number | undefined;
    /** Optional. Number of pending join requests created using this link */
    pendingJoinRequestCount?: number | undefined;
    /** Optional. The number of seconds the subscription will be active for before the next payment */
    subscriptionPeriod?: number | undefined;
    /** Optional. The amount of Telegram Stars a user must pay initially and after each subsequent subscription period to be a member of the chat using the link */
    subscriptionPrice?: number | undefined;

    constructor(data?: IChatInviteLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.creator = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inviteLink = _data["inviteLink"];
            this.creator = _data["creator"] ? User.fromJS(_data["creator"]) : new User();
            this.createsJoinRequest = _data["createsJoinRequest"];
            this.isPrimary = _data["isPrimary"];
            this.isRevoked = _data["isRevoked"];
            this.name = _data["name"];
            this.expireDate = _data["expireDate"] ? new Date(_data["expireDate"].toString()) : <any>undefined;
            this.memberLimit = _data["memberLimit"];
            this.pendingJoinRequestCount = _data["pendingJoinRequestCount"];
            this.subscriptionPeriod = _data["subscriptionPeriod"];
            this.subscriptionPrice = _data["subscriptionPrice"];
        }
    }

    static fromJS(data: any): ChatInviteLink {
        data = typeof data === 'object' ? data : {};
        let result = new ChatInviteLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inviteLink"] = this.inviteLink;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>undefined;
        data["createsJoinRequest"] = this.createsJoinRequest;
        data["isPrimary"] = this.isPrimary;
        data["isRevoked"] = this.isRevoked;
        data["name"] = this.name;
        data["expireDate"] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        data["memberLimit"] = this.memberLimit;
        data["pendingJoinRequestCount"] = this.pendingJoinRequestCount;
        data["subscriptionPeriod"] = this.subscriptionPeriod;
        data["subscriptionPrice"] = this.subscriptionPrice;
        return data;
    }
}

/** Represents an invite link for a chat. */
export interface IChatInviteLink {
    /** The invite link. If the link was created by another chat administrator, then the second part of the link will be replaced with “…”. */
    inviteLink: string;
    /** Creator of the link */
    creator: User;
    /** true, if users joining the chat via the link need to be approved by chat administrators */
    createsJoinRequest: boolean;
    /** true, if the link is primary */
    isPrimary: boolean;
    /** true, if the link is revoked */
    isRevoked: boolean;
    /** Optional. Invite link name */
    name?: string | undefined;
    /** Optional. Point in time when the link will expire or has been expired */
    expireDate?: Date | undefined;
    /** Optional. The maximum number of users that can be members of the chat simultaneously after joining the chat via this invite link; 1-99999 */
    memberLimit?: number | undefined;
    /** Optional. Number of pending join requests created using this link */
    pendingJoinRequestCount?: number | undefined;
    /** Optional. The number of seconds the subscription will be active for before the next payment */
    subscriptionPeriod?: number | undefined;
    /** Optional. The amount of Telegram Stars a user must pay initially and after each subsequent subscription period to be a member of the chat using the link */
    subscriptionPrice?: number | undefined;
}

/** Represents a join request sent to a chat. */
export class ChatJoinRequest implements IChatJoinRequest {
    /** Chat to which the request was sent */
    chat!: Chat;
    /** User that sent the join request */
    from!: User;
    /** Identifier of a private chat with the user who sent the join request. The bot can use this identifier for 5 minutes to send messages until the join request is processed, assuming no other administrator contacted the user. */
    userChatId!: number;
    /** Date the request was sent */
    date!: Date;
    /** Optional. Bio of the user. */
    bio?: string | undefined;
    /** Optional. Chat invite link that was used by the user to send the join request */
    inviteLink?: ChatInviteLink | undefined;

    constructor(data?: IChatJoinRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chat = new Chat();
            this.from = new User();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chat = _data["chat"] ? Chat.fromJS(_data["chat"]) : new Chat();
            this.from = _data["from"] ? User.fromJS(_data["from"]) : new User();
            this.userChatId = _data["userChatId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.bio = _data["bio"];
            this.inviteLink = _data["inviteLink"] ? ChatInviteLink.fromJS(_data["inviteLink"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatJoinRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChatJoinRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chat"] = this.chat ? this.chat.toJSON() : <any>undefined;
        data["from"] = this.from ? this.from.toJSON() : <any>undefined;
        data["userChatId"] = this.userChatId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["bio"] = this.bio;
        data["inviteLink"] = this.inviteLink ? this.inviteLink.toJSON() : <any>undefined;
        return data;
    }
}

/** Represents a join request sent to a chat. */
export interface IChatJoinRequest {
    /** Chat to which the request was sent */
    chat: Chat;
    /** User that sent the join request */
    from: User;
    /** Identifier of a private chat with the user who sent the join request. The bot can use this identifier for 5 minutes to send messages until the join request is processed, assuming no other administrator contacted the user. */
    userChatId: number;
    /** Date the request was sent */
    date: Date;
    /** Optional. Bio of the user. */
    bio?: string | undefined;
    /** Optional. Chat invite link that was used by the user to send the join request */
    inviteLink?: ChatInviteLink | undefined;
}

/** This object represents a boost added to a chat or changed. */
export class ChatBoostUpdated implements IChatBoostUpdated {
    /** Chat which was boosted */
    chat!: Chat;
    /** Information about the chat boost */
    boost!: ChatBoost;

    constructor(data?: IChatBoostUpdated) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chat = new Chat();
            this.boost = new ChatBoost();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chat = _data["chat"] ? Chat.fromJS(_data["chat"]) : new Chat();
            this.boost = _data["boost"] ? ChatBoost.fromJS(_data["boost"]) : new ChatBoost();
        }
    }

    static fromJS(data: any): ChatBoostUpdated {
        data = typeof data === 'object' ? data : {};
        let result = new ChatBoostUpdated();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chat"] = this.chat ? this.chat.toJSON() : <any>undefined;
        data["boost"] = this.boost ? this.boost.toJSON() : <any>undefined;
        return data;
    }
}

/** This object represents a boost added to a chat or changed. */
export interface IChatBoostUpdated {
    /** Chat which was boosted */
    chat: Chat;
    /** Information about the chat boost */
    boost: ChatBoost;
}

/** This object contains information about a chat boost. */
export class ChatBoost implements IChatBoost {
    /** Unique identifier of the boost */
    boostId!: string;
    /** Point in time when the chat was boosted */
    addDate!: Date;
    /** Point in time when the boost will automatically expire, unless the booster's Telegram Premium subscription is prolonged */
    expirationDate!: Date;
    /** Source of the added boost */
    source!: ChatBoostSource;

    constructor(data?: IChatBoost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boostId = _data["boostId"];
            this.addDate = _data["addDate"] ? new Date(_data["addDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.source = _data["source"] ? ChatBoostSource.fromJS(_data["source"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatBoost {
        data = typeof data === 'object' ? data : {};
        let result = new ChatBoost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boostId"] = this.boostId;
        data["addDate"] = this.addDate ? this.addDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["source"] = this.source ? this.source.toJSON() : <any>undefined;
        return data;
    }
}

/** This object contains information about a chat boost. */
export interface IChatBoost {
    /** Unique identifier of the boost */
    boostId: string;
    /** Point in time when the chat was boosted */
    addDate: Date;
    /** Point in time when the boost will automatically expire, unless the booster's Telegram Premium subscription is prolonged */
    expirationDate: Date;
    /** Source of the added boost */
    source: ChatBoostSource;
}

/** This object describes the source of a chat boost. It can be one ofChatBoostSourcePremium, ChatBoostSourceGiftCode, ChatBoostSourceGiveaway */
export abstract class ChatBoostSource implements IChatBoostSource {

    constructor(data?: IChatBoostSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ChatBoostSource {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ChatBoostSource' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** This object describes the source of a chat boost. It can be one ofChatBoostSourcePremium, ChatBoostSourceGiftCode, ChatBoostSourceGiveaway */
export interface IChatBoostSource {
}

/** This object represents a boost removed from a chat. */
export class ChatBoostRemoved implements IChatBoostRemoved {
    /** Chat which was boosted */
    chat!: Chat;
    /** Unique identifier of the boost */
    boostId!: string;
    /** Point in time when the boost was removed */
    removeDate!: Date;
    /** Source of the removed boost */
    source!: ChatBoostSource;

    constructor(data?: IChatBoostRemoved) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chat = new Chat();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chat = _data["chat"] ? Chat.fromJS(_data["chat"]) : new Chat();
            this.boostId = _data["boostId"];
            this.removeDate = _data["removeDate"] ? new Date(_data["removeDate"].toString()) : <any>undefined;
            this.source = _data["source"] ? ChatBoostSource.fromJS(_data["source"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatBoostRemoved {
        data = typeof data === 'object' ? data : {};
        let result = new ChatBoostRemoved();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chat"] = this.chat ? this.chat.toJSON() : <any>undefined;
        data["boostId"] = this.boostId;
        data["removeDate"] = this.removeDate ? this.removeDate.toISOString() : <any>undefined;
        data["source"] = this.source ? this.source.toJSON() : <any>undefined;
        return data;
    }
}

/** This object represents a boost removed from a chat. */
export interface IChatBoostRemoved {
    /** Chat which was boosted */
    chat: Chat;
    /** Unique identifier of the boost */
    boostId: string;
    /** Point in time when the boost was removed */
    removeDate: Date;
    /** Source of the removed boost */
    source: ChatBoostSource;
}

/** The type of Update */
export enum UpdateType {
    Unknown = 0,
    Message = 1,
    InlineQuery = 2,
    ChosenInlineResult = 3,
    CallbackQuery = 4,
    EditedMessage = 5,
    ChannelPost = 6,
    EditedChannelPost = 7,
    ShippingQuery = 8,
    PreCheckoutQuery = 9,
    Poll = 10,
    PollAnswer = 11,
    MyChatMember = 12,
    ChatMember = 13,
    ChatJoinRequest = 14,
    MessageReaction = 15,
    MessageReactionCount = 16,
    ChatBoost = 17,
    RemovedChatBoost = 18,
    BusinessConnection = 19,
    BusinessMessage = 20,
    EditedBusinessMessage = 21,
    DeletedBusinessMessages = 22,
    PurchasedPaidMedia = 23,
}

export class SelectItem implements ISelectItem {
    label!: string;
    value!: string;
    dataInt?: number | undefined;
    code?: string | undefined;
    rootCode?: string | undefined;
    dataStr?: string | undefined;
    dataStr2?: string | undefined;
    dateTime?: string | undefined;
    comment?: string | undefined;
    booleanProperty?: boolean | undefined;

    constructor(data?: ISelectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
            this.dataInt = _data["dataInt"];
            this.code = _data["code"];
            this.rootCode = _data["rootCode"];
            this.dataStr = _data["dataStr"];
            this.dataStr2 = _data["dataStr2"];
            this.dateTime = _data["dateTime"];
            this.comment = _data["comment"];
            this.booleanProperty = _data["booleanProperty"];
        }
    }

    static fromJS(data: any): SelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        data["dataInt"] = this.dataInt;
        data["code"] = this.code;
        data["rootCode"] = this.rootCode;
        data["dataStr"] = this.dataStr;
        data["dataStr2"] = this.dataStr2;
        data["dateTime"] = this.dateTime;
        data["comment"] = this.comment;
        data["booleanProperty"] = this.booleanProperty;
        return data;
    }
}

export interface ISelectItem {
    label: string;
    value: string;
    dataInt?: number | undefined;
    code?: string | undefined;
    rootCode?: string | undefined;
    dataStr?: string | undefined;
    dataStr2?: string | undefined;
    dateTime?: string | undefined;
    comment?: string | undefined;
    booleanProperty?: boolean | undefined;
}

export class VacancyHrmDto implements IVacancyHrmDto {
    id!: number;
    spInstitutionId!: number;
    spInstitutionName?: string | undefined;
    spDepartmentId!: number;
    spDepartmentName?: string | undefined;
    spPositionId!: number;
    spPositionName?: string | undefined;
    educationLevelId?: number | undefined;
    salary!: number;
    workingHours?: string | undefined;
    typeOfEmploymentRelations!: number;
    qualificationRequirements?: string | undefined;
    positionDuties?: string | undefined;
    workingConditions!: string;
    rate!: number;
    workExperience!: string;
    typeOfPosition!: TypeOfPosition;
    typeOfPositionLabel?: string | undefined;
    spCategoryOfPositionId!: number;
    spCategoryOfPositionLabel?: string | undefined;
    sourceVacancy?: SourceVacancy | undefined;
    tin?: string | undefined;

    constructor(data?: IVacancyHrmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.spInstitutionId = _data["spInstitutionId"];
            this.spInstitutionName = _data["spInstitutionName"];
            this.spDepartmentId = _data["spDepartmentId"];
            this.spDepartmentName = _data["spDepartmentName"];
            this.spPositionId = _data["spPositionId"];
            this.spPositionName = _data["spPositionName"];
            this.educationLevelId = _data["educationLevelId"];
            this.salary = _data["salary"];
            this.workingHours = _data["workingHours"];
            this.typeOfEmploymentRelations = _data["typeOfEmploymentRelations"];
            this.qualificationRequirements = _data["qualificationRequirements"];
            this.positionDuties = _data["positionDuties"];
            this.workingConditions = _data["workingConditions"];
            this.rate = _data["rate"];
            this.workExperience = _data["workExperience"];
            this.typeOfPosition = _data["typeOfPosition"];
            this.typeOfPositionLabel = _data["typeOfPositionLabel"];
            this.spCategoryOfPositionId = _data["spCategoryOfPositionId"];
            this.spCategoryOfPositionLabel = _data["spCategoryOfPositionLabel"];
            this.sourceVacancy = _data["sourceVacancy"];
            this.tin = _data["tin"];
        }
    }

    static fromJS(data: any): VacancyHrmDto {
        data = typeof data === 'object' ? data : {};
        let result = new VacancyHrmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["spInstitutionId"] = this.spInstitutionId;
        data["spInstitutionName"] = this.spInstitutionName;
        data["spDepartmentId"] = this.spDepartmentId;
        data["spDepartmentName"] = this.spDepartmentName;
        data["spPositionId"] = this.spPositionId;
        data["spPositionName"] = this.spPositionName;
        data["educationLevelId"] = this.educationLevelId;
        data["salary"] = this.salary;
        data["workingHours"] = this.workingHours;
        data["typeOfEmploymentRelations"] = this.typeOfEmploymentRelations;
        data["qualificationRequirements"] = this.qualificationRequirements;
        data["positionDuties"] = this.positionDuties;
        data["workingConditions"] = this.workingConditions;
        data["rate"] = this.rate;
        data["workExperience"] = this.workExperience;
        data["typeOfPosition"] = this.typeOfPosition;
        data["typeOfPositionLabel"] = this.typeOfPositionLabel;
        data["spCategoryOfPositionId"] = this.spCategoryOfPositionId;
        data["spCategoryOfPositionLabel"] = this.spCategoryOfPositionLabel;
        data["sourceVacancy"] = this.sourceVacancy;
        data["tin"] = this.tin;
        return data;
    }
}

export interface IVacancyHrmDto {
    id: number;
    spInstitutionId: number;
    spInstitutionName?: string | undefined;
    spDepartmentId: number;
    spDepartmentName?: string | undefined;
    spPositionId: number;
    spPositionName?: string | undefined;
    educationLevelId?: number | undefined;
    salary: number;
    workingHours?: string | undefined;
    typeOfEmploymentRelations: number;
    qualificationRequirements?: string | undefined;
    positionDuties?: string | undefined;
    workingConditions: string;
    rate: number;
    workExperience: string;
    typeOfPosition: TypeOfPosition;
    typeOfPositionLabel?: string | undefined;
    spCategoryOfPositionId: number;
    spCategoryOfPositionLabel?: string | undefined;
    sourceVacancy?: SourceVacancy | undefined;
    tin?: string | undefined;
}

export enum TypeOfPosition {
    All = 0,
    Leader = 1,
    Management = 2,
    Техник = 3,
    Expert = 4,
    ProductionEmployee = 5,
}

export class VacancyTotal implements IVacancyTotal {
    institutionId!: number;
    tin!: string;
    institutionName!: string;
    totalCount!: number;
    sourceVacancy!: SourceVacancy;

    constructor(data?: IVacancyTotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.institutionId = _data["institutionId"];
            this.tin = _data["tin"];
            this.institutionName = _data["institutionName"];
            this.totalCount = _data["totalCount"];
            this.sourceVacancy = _data["sourceVacancy"];
        }
    }

    static fromJS(data: any): VacancyTotal {
        data = typeof data === 'object' ? data : {};
        let result = new VacancyTotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["institutionId"] = this.institutionId;
        data["tin"] = this.tin;
        data["institutionName"] = this.institutionName;
        data["totalCount"] = this.totalCount;
        data["sourceVacancy"] = this.sourceVacancy;
        return data;
    }
}

export interface IVacancyTotal {
    institutionId: number;
    tin: string;
    institutionName: string;
    totalCount: number;
    sourceVacancy: SourceVacancy;
}

export class QueryResultOfVacancyDto implements IQueryResultOfVacancyDto {
    items!: VacancyDto[];
    totalItems!: number;

    constructor(data?: IQueryResultOfVacancyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VacancyDto.fromJS(item));
            }
            this.totalItems = _data["totalItems"];
        }
    }

    static fromJS(data: any): QueryResultOfVacancyDto {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultOfVacancyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalItems"] = this.totalItems;
        return data;
    }
}

export interface IQueryResultOfVacancyDto {
    items: VacancyDto[];
    totalItems: number;
}

export class Response implements IResponse {
    status!: Status;
    message?: string | undefined;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IResponse {
    status: Status;
    message?: string | undefined;
}

export enum Status {
    Success = 0,
    Error = 1,
}

export class SelectItem2 implements ISelectItem2 {
    id!: number;
    label?: string | undefined;
    nameRu?: string | undefined;
    nameUz?: string | undefined;
    nameCyr?: string | undefined;
    nameKar?: string | undefined;
    code?: string | undefined;
    spRootCode?: string | undefined;
    comment?: string | undefined;

    constructor(data?: ISelectItem2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.nameRu = _data["nameRu"];
            this.nameUz = _data["nameUz"];
            this.nameCyr = _data["nameCyr"];
            this.nameKar = _data["nameKar"];
            this.code = _data["code"];
            this.spRootCode = _data["spRootCode"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): SelectItem2 {
        data = typeof data === 'object' ? data : {};
        let result = new SelectItem2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["nameRu"] = this.nameRu;
        data["nameUz"] = this.nameUz;
        data["nameCyr"] = this.nameCyr;
        data["nameKar"] = this.nameKar;
        data["code"] = this.code;
        data["spRootCode"] = this.spRootCode;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ISelectItem2 {
    id: number;
    label?: string | undefined;
    nameRu?: string | undefined;
    nameUz?: string | undefined;
    nameCyr?: string | undefined;
    nameKar?: string | undefined;
    code?: string | undefined;
    spRootCode?: string | undefined;
    comment?: string | undefined;
}

export class PaginatorMetaData implements IPaginatorMetaData {
    pageIndex!: number;
    pageSize!: number;
    previousPageIndex!: number;
    filters?: string | undefined;

    constructor(data?: IPaginatorMetaData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageIndex = _data["pageIndex"];
            this.pageSize = _data["pageSize"];
            this.previousPageIndex = _data["previousPageIndex"];
            this.filters = _data["filters"];
        }
    }

    static fromJS(data: any): PaginatorMetaData {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatorMetaData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageIndex"] = this.pageIndex;
        data["pageSize"] = this.pageSize;
        data["previousPageIndex"] = this.previousPageIndex;
        data["filters"] = this.filters;
        return data;
    }
}

export interface IPaginatorMetaData {
    pageIndex: number;
    pageSize: number;
    previousPageIndex: number;
    filters?: string | undefined;
}

export class CResponseOfBoolean implements ICResponseOfBoolean {
    status?: string | undefined;
    message?: string | undefined;
    data!: boolean;
    code!: number;

    constructor(data?: ICResponseOfBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CResponseOfBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new CResponseOfBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data;
        data["code"] = this.code;
        return data;
    }
}

export interface ICResponseOfBoolean {
    status?: string | undefined;
    message?: string | undefined;
    data: boolean;
    code: number;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}